//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

//import moment from 'moment';;
import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AboutServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getAbout(): Observable<AboutModel> {
    let url_ = this.baseUrl + '/api/services/app/About/GetAbout';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAbout(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAbout(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AboutModel>;
            }
          } else return _observableThrow(response_) as any as Observable<AboutModel>;
        }),
      );
  }

  protected processGetAbout(response: HttpResponseBase): Observable<AboutModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AboutModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AccountServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Account/ActivateEmail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivateEmail(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivateEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processActivateEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  backToImpersonator(): Observable<ImpersonateOutput> {
    let url_ = this.baseUrl + '/api/services/app/Account/BackToImpersonator';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBackToImpersonator(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBackToImpersonator(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ImpersonateOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }),
      );
  }

  protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ImpersonateOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllTenants(): Observable<TenantListDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Account/GetAllTenants';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllTenants(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllTenants(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantListDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantListDto[]>;
        }),
      );
  }

  protected processGetAllTenants(response: HttpResponseBase): Observable<TenantListDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(TenantListDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
    let url_ = this.baseUrl + '/api/services/app/Account/Impersonate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImpersonate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImpersonate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ImpersonateOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }),
      );
  }

  protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ImpersonateOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
    let url_ = this.baseUrl + '/api/services/app/Account/IsTenantAvailable';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsTenantAvailable(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsTenantAvailable(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }),
      );
  }

  protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IsTenantAvailableOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
    let url_ = this.baseUrl + '/api/services/app/Account/ResetPassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }),
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ResetPasswordOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
    let url_ = this.baseUrl + '/api/services/app/Account/ResolveTenantId';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResolveTenantId(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResolveTenantId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        }),
      );
  }

  protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Account/SendEmailActivationLink';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendEmailActivationLink(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendEmailActivationLink(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Account/SendPasswordResetCode';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendPasswordResetCode(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendPasswordResetCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AirportServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param code (optional)
   * @return Success
   */
  getByCode(code: string | null | undefined): Observable<AirportsDto> {
    let url_ = this.baseUrl + '/api/services/app/Airport/GetByCode?';
    if (code !== undefined && code !== null) url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetByCode(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetByCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AirportsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AirportsDto>;
        }),
      );
  }

  protected processGetByCode(response: HttpResponseBase): Observable<AirportsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AirportsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getById(id: number | undefined): Observable<AirportsDto> {
    let url_ = this.baseUrl + '/api/services/app/Airport/GetById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AirportsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AirportsDto>;
        }),
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<AirportsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AirportsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param nome (optional)
   * @param iATACode (optional)
   * @param countryCode (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    nome: string | null | undefined,
    iATACode: string | null | undefined,
    countryCode: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfAirportsDto> {
    let url_ = this.baseUrl + '/api/services/app/Airport/GetAll?';
    if (nome !== undefined && nome !== null) url_ += 'Nome=' + encodeURIComponent('' + nome) + '&';
    if (iATACode !== undefined && iATACode !== null) url_ += 'IATACode=' + encodeURIComponent('' + iATACode) + '&';
    if (countryCode !== undefined && countryCode !== null) url_ += 'CountryCode=' + encodeURIComponent('' + countryCode) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfAirportsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfAirportsDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAirportsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfAirportsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param lang (optional)
   * @return Success
   */
  getList(lang: string | null | undefined): Observable<AirportItemDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Airport/GetList?';
    if (lang !== undefined && lang !== null) url_ += 'lang=' + encodeURIComponent('' + lang) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetList(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetList(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AirportItemDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<AirportItemDto[]>;
        }),
      );
  }

  protected processGetList(response: HttpResponseBase): Observable<AirportItemDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AirportItemDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AlertServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addAlert(body: AlertDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Alert/AddAlert';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddAlert(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddAlert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddAlert(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateAlert(body: AlertDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Alert/UpdateAlert';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAlert(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAlert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateAlert(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteAlert(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Alert/DeleteAlert?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAlert(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteAlert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteAlert(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAlertById(id: number | undefined): Observable<AlertDto> {
    let url_ = this.baseUrl + '/api/services/app/Alert/GetAlertById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAlertById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAlertById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AlertDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AlertDto>;
        }),
      );
  }

  protected processGetAlertById(response: HttpResponseBase): Observable<AlertDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AlertDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listAlerts(body: SearchAlertDto | undefined): Observable<PagedResultDtoOfAlertDto> {
    let url_ = this.baseUrl + '/api/services/app/Alert/ListAlerts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListAlerts(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListAlerts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfAlertDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlertDto>;
        }),
      );
  }

  protected processListAlerts(response: HttpResponseBase): Observable<PagedResultDtoOfAlertDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfAlertDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAvailableRegistration(): Observable<string[]> {
    let url_ = this.baseUrl + '/api/services/app/Alert/GetAvailableRegistration';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAvailableRegistration(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAvailableRegistration(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        }),
      );
  }

  protected processGetAvailableRegistration(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AlternateFlightServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addAlternateFlight(body: AlternateFlightDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/AlternateFlight/AddAlternateFlight';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddAlternateFlight(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddAlternateFlight(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddAlternateFlight(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteAlternateFlight(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/AlternateFlight/DeleteAlternateFlight?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAlternateFlight(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteAlternateFlight(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteAlternateFlight(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAlternateFlightById(id: number | undefined): Observable<AlternateFlightDto> {
    let url_ = this.baseUrl + '/api/services/app/AlternateFlight/GetAlternateFlightById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAlternateFlightById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAlternateFlightById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AlternateFlightDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AlternateFlightDto>;
        }),
      );
  }

  protected processGetAlternateFlightById(response: HttpResponseBase): Observable<AlternateFlightDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AlternateFlightDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listAlternateFlight(body: SearchAlternateFlightDto | undefined): Observable<PagedResultDtoOfAlternateFlightDto> {
    let url_ = this.baseUrl + '/api/services/app/AlternateFlight/ListAlternateFlight';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListAlternateFlight(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListAlternateFlight(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfAlternateFlightDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfAlternateFlightDto>;
        }),
      );
  }

  protected processListAlternateFlight(response: HttpResponseBase): Observable<PagedResultDtoOfAlternateFlightDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfAlternateFlightDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateAlternateFlight(body: AlternateFlightDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/AlternateFlight/UpdateAlternateFlight';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAlternateFlight(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAlternateFlight(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateAlternateFlight(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AntiForgeryServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getToken(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/AntiForgery/GetToken';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetToken(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetToken(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processGetToken(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ArticlesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addArticle(body: ArticleDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Articles/AddArticle';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddArticle(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddArticle(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddArticle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateArticle(body: ArticleDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Articles/UpdateArticle';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateArticle(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateArticle(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateArticle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfArticleDto> {
    let url_ = this.baseUrl + '/api/services/app/Articles/GetAll?';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfArticleDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfArticleDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfArticleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfArticleDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteArticle(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Articles/DeleteArticle?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteArticle(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteArticle(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteArticle(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getArticleById(id: number | undefined): Observable<ArticleDto> {
    let url_ = this.baseUrl + '/api/services/app/Articles/GetArticleById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetArticleById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetArticleById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ArticleDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ArticleDto>;
        }),
      );
  }

  protected processGetArticleById(response: HttpResponseBase): Observable<ArticleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ArticleDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class AuditLogServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param browserInfo (optional)
   * @param endDate (optional)
   * @param hasException (optional)
   * @param maxExecutionDuration (optional)
   * @param methodName (optional)
   * @param minExecutionDuration (optional)
   * @param serviceName (optional)
   * @param startDate (optional)
   * @param userName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getAuditLogs(
    browserInfo: string | null | undefined,
    endDate: moment.Moment | undefined,
    hasException: boolean | null | undefined,
    maxExecutionDuration: number | null | undefined,
    methodName: string | null | undefined,
    minExecutionDuration: number | null | undefined,
    serviceName: string | null | undefined,
    startDate: moment.Moment | undefined,
    userName: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<PagedResultDtoOfAuditLogListDto> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLogs?';
    if (browserInfo !== undefined && browserInfo !== null) url_ += 'BrowserInfo=' + encodeURIComponent('' + browserInfo) + '&';
    if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    if (hasException !== undefined && hasException !== null) url_ += 'HasException=' + encodeURIComponent('' + hasException) + '&';
    if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
      url_ += 'MaxExecutionDuration=' + encodeURIComponent('' + maxExecutionDuration) + '&';
    if (methodName !== undefined && methodName !== null) url_ += 'MethodName=' + encodeURIComponent('' + methodName) + '&';
    if (minExecutionDuration !== undefined && minExecutionDuration !== null)
      url_ += 'MinExecutionDuration=' + encodeURIComponent('' + minExecutionDuration) + '&';
    if (serviceName !== undefined && serviceName !== null) url_ += 'ServiceName=' + encodeURIComponent('' + serviceName) + '&';
    if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (userName !== undefined && userName !== null) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAuditLogs(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAuditLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }),
      );
  }

  protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param browserInfo (optional)
   * @param endDate (optional)
   * @param hasException (optional)
   * @param maxExecutionDuration (optional)
   * @param methodName (optional)
   * @param minExecutionDuration (optional)
   * @param serviceName (optional)
   * @param startDate (optional)
   * @param userName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getAuditLogsToExcel(
    browserInfo: string | null | undefined,
    endDate: moment.Moment | undefined,
    hasException: boolean | null | undefined,
    maxExecutionDuration: number | null | undefined,
    methodName: string | null | undefined,
    minExecutionDuration: number | null | undefined,
    serviceName: string | null | undefined,
    startDate: moment.Moment | undefined,
    userName: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLogsToExcel?';
    if (browserInfo !== undefined && browserInfo !== null) url_ += 'BrowserInfo=' + encodeURIComponent('' + browserInfo) + '&';
    if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    if (hasException !== undefined && hasException !== null) url_ += 'HasException=' + encodeURIComponent('' + hasException) + '&';
    if (maxExecutionDuration !== undefined && maxExecutionDuration !== null)
      url_ += 'MaxExecutionDuration=' + encodeURIComponent('' + maxExecutionDuration) + '&';
    if (methodName !== undefined && methodName !== null) url_ += 'MethodName=' + encodeURIComponent('' + methodName) + '&';
    if (minExecutionDuration !== undefined && minExecutionDuration !== null)
      url_ += 'MinExecutionDuration=' + encodeURIComponent('' + minExecutionDuration) + '&';
    if (serviceName !== undefined && serviceName !== null) url_ += 'ServiceName=' + encodeURIComponent('' + serviceName) + '&';
    if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (userName !== undefined && userName !== null) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAuditLogsToExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAuditLogsToExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param endDate (optional)
   * @param entityTypeFullName (optional)
   * @param startDate (optional)
   * @param userName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getEntityChanges(
    endDate: moment.Moment | undefined,
    entityTypeFullName: string | null | undefined,
    startDate: moment.Moment | undefined,
    userName: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<PagedResultDtoOfEntityChangeListDto> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetEntityChanges?';
    if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    if (entityTypeFullName !== undefined && entityTypeFullName !== null)
      url_ += 'EntityTypeFullName=' + encodeURIComponent('' + entityTypeFullName) + '&';
    if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (userName !== undefined && userName !== null) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEntityChanges(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEntityChanges(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }),
      );
  }

  protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param endDate (optional)
   * @param entityTypeFullName (optional)
   * @param startDate (optional)
   * @param userName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getEntityChangesToExcel(
    endDate: moment.Moment | undefined,
    entityTypeFullName: string | null | undefined,
    startDate: moment.Moment | undefined,
    userName: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetEntityChangesToExcel?';
    if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    if (entityTypeFullName !== undefined && entityTypeFullName !== null)
      url_ += 'EntityTypeFullName=' + encodeURIComponent('' + entityTypeFullName) + '&';
    if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (userName !== undefined && userName !== null) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEntityChangesToExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEntityChangesToExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetEntityHistoryObjectTypes';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEntityHistoryObjectTypes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEntityHistoryObjectTypes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NameValueDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }),
      );
  }

  protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(NameValueDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param entityChangeId (optional)
   * @return Success
   */
  getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetEntityPropertyChanges?';
    if (entityChangeId === null) throw new Error("The parameter 'entityChangeId' cannot be null.");
    else if (entityChangeId !== undefined) url_ += 'entityChangeId=' + encodeURIComponent('' + entityChangeId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEntityPropertyChanges(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEntityPropertyChanges(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }),
      );
  }

  protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(EntityPropertyChangeDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param entityId (optional)
   * @param entityTypeFullName (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getEntityTypeChanges(
    entityId: string | null | undefined,
    entityTypeFullName: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<PagedResultDtoOfEntityChangeListDto> {
    let url_ = this.baseUrl + '/api/services/app/AuditLog/GetEntityTypeChanges?';
    if (entityId !== undefined && entityId !== null) url_ += 'EntityId=' + encodeURIComponent('' + entityId) + '&';
    if (entityTypeFullName !== undefined && entityTypeFullName !== null)
      url_ += 'EntityTypeFullName=' + encodeURIComponent('' + entityTypeFullName) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEntityTypeChanges(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEntityTypeChanges(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }),
      );
  }

  protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class BriefingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getBriefing(): Observable<BriefingDto> {
    let url_ = this.baseUrl + '/api/services/app/Briefing/GetBriefing';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBriefing(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBriefing(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingDto>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingDto>;
        }),
      );
  }

  protected processGetBriefing(response: HttpResponseBase): Observable<BriefingDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BriefingDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addMapImage(body: AddMapImageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Briefing/AddMapImage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddMapImage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddMapImage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddMapImage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addSingleImage(body: AddSingleImageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Briefing/AddSingleImage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddSingleImage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddSingleImage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddSingleImage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param version (optional)
   * @param index (optional)
   * @param imageName (optional)
   * @return Success
   */
  deleteMapImage(version: number | undefined, index: number | undefined, imageName: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Briefing/DeleteMapImage?';
    if (version === null) throw new Error("The parameter 'version' cannot be null.");
    else if (version !== undefined) url_ += 'Version=' + encodeURIComponent('' + version) + '&';
    if (index === null) throw new Error("The parameter 'index' cannot be null.");
    else if (index !== undefined) url_ += 'Index=' + encodeURIComponent('' + index) + '&';
    if (imageName !== undefined && imageName !== null) url_ += 'ImageName=' + encodeURIComponent('' + imageName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteMapImage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteMapImage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteMapImage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param version (optional)
   * @param imageType (optional)
   * @return Success
   */
  deleteSingleImage(version: number | undefined, imageType: SingleImageType | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Briefing/DeleteSingleImage?';
    if (version === null) throw new Error("The parameter 'version' cannot be null.");
    else if (version !== undefined) url_ += 'Version=' + encodeURIComponent('' + version) + '&';
    if (imageType === null) throw new Error("The parameter 'imageType' cannot be null.");
    else if (imageType !== undefined) url_ += 'ImageType=' + encodeURIComponent('' + imageType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteSingleImage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteSingleImage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteSingleImage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class BriefingAirportServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addBriefingAirport(body: BriefingAirportDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingAirport/AddBriefingAirport';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddBriefingAirport(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddBriefingAirport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddBriefingAirport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteBriefingAirport(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingAirport/DeleteBriefingAirport?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteBriefingAirport(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteBriefingAirport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteBriefingAirport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getBriefingAirportById(id: number | undefined): Observable<BriefingAirportDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingAirport/GetBriefingAirportById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBriefingAirportById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBriefingAirportById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingAirportDto>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingAirportDto>;
        }),
      );
  }

  protected processGetBriefingAirportById(response: HttpResponseBase): Observable<BriefingAirportDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BriefingAirportDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listBriefingAirports(body: SearchBriefingAirportDto | undefined): Observable<PagedResultDtoOfBriefingAirportDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingAirport/ListBriefingAirports';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListBriefingAirports(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListBriefingAirports(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfBriefingAirportDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfBriefingAirportDto>;
        }),
      );
  }

  protected processListBriefingAirports(response: HttpResponseBase): Observable<PagedResultDtoOfBriefingAirportDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfBriefingAirportDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateBriefingAirport(body: BriefingAirportDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingAirport/UpdateBriefingAirport';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBriefingAirport(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBriefingAirport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateBriefingAirport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class BriefingGolServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addBriefingGol(body: BriefingGolDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/AddBriefingGol';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddBriefingGol(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddBriefingGol(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddBriefingGol(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteBriefingGol(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/DeleteBriefingGol?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteBriefingGol(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteBriefingGol(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteBriefingGol(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listBriefingGol(body: SearchBriefingGolDto | undefined): Observable<PagedResultDtoOfBriefingGolDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/ListBriefingGol';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListBriefingGol(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListBriefingGol(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfBriefingGolDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfBriefingGolDto>;
        }),
      );
  }

  protected processListBriefingGol(response: HttpResponseBase): Observable<PagedResultDtoOfBriefingGolDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfBriefingGolDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getBriefingGolById(id: number | undefined): Observable<BriefingGolDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/GetBriefingGolById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBriefingGolById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBriefingGolById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingGolDto>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingGolDto>;
        }),
      );
  }

  protected processGetBriefingGolById(response: HttpResponseBase): Observable<BriefingGolDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BriefingGolDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateBriefingGol(body: BriefingGolDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/UpdateBriefingGol';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBriefingGol(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBriefingGol(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateBriefingGol(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  commanderFlightXCrewNetLine(body: SearchBriefingGolDto | undefined): Observable<CommanderDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/CommanderFlightXCrewNetLine';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCommanderFlightXCrewNetLine(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCommanderFlightXCrewNetLine(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CommanderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CommanderDto>;
        }),
      );
  }

  protected processCommanderFlightXCrewNetLine(response: HttpResponseBase): Observable<CommanderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommanderDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  itensBriefingGol(body: SearchBriefingGolDto | undefined): Observable<ItensBriefingGolDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/ItensBriefingGol';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processItensBriefingGol(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processItensBriefingGol(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ItensBriefingGolDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ItensBriefingGolDto>;
        }),
      );
  }

  protected processItensBriefingGol(response: HttpResponseBase): Observable<ItensBriefingGolDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ItensBriefingGolDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  capturaLocalidades(body: SearchBriefingGolDto | undefined): Observable<string[]> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/CapturaLocalidades';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCapturaLocalidades(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCapturaLocalidades(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        }),
      );
  }

  protected processCapturaLocalidades(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listBriefingGolToExcel(body: SearchBriefingGolDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGol/ListBriefingGolToExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListBriefingGolToExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListBriefingGolToExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processListBriefingGolToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class BriefingGolAlternateServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addBriefingGolAlternate(body: BriefingGolAlternateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolAlternate/AddBriefingGolAlternate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddBriefingGolAlternate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddBriefingGolAlternate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddBriefingGolAlternate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteBriefingGolAlternate(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolAlternate/DeleteBriefingGolAlternate?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteBriefingGolAlternate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteBriefingGolAlternate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteBriefingGolAlternate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getBriefingGolAlternateById(id: number | undefined): Observable<BriefingGolAlternateDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolAlternate/GetBriefingGolAlternateById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBriefingGolAlternateById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBriefingGolAlternateById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingGolAlternateDto>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingGolAlternateDto>;
        }),
      );
  }

  protected processGetBriefingGolAlternateById(response: HttpResponseBase): Observable<BriefingGolAlternateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BriefingGolAlternateDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param briefingGolId (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    briefingGolId: number | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<BriefingGolAlternateDto[]> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolAlternate/GetAll?';
    if (briefingGolId !== undefined && briefingGolId !== null) url_ += 'BriefingGolId=' + encodeURIComponent('' + briefingGolId) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingGolAlternateDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingGolAlternateDto[]>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<BriefingGolAlternateDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BriefingGolAlternateDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateBriefingGolAlternate(body: BriefingGolAlternateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolAlternate/UpdateBriefingGolAlternate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBriefingGolAlternate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBriefingGolAlternate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateBriefingGolAlternate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class BriefingGolSuplemNotamServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addBriefingGolSuplemNotam(body: BriefingGolSuplemNotamDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolSuplemNotam/AddBriefingGolSuplemNotam';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddBriefingGolSuplemNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddBriefingGolSuplemNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddBriefingGolSuplemNotam(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteBriefingGolSuplemNotam(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolSuplemNotam/DeleteBriefingGolSuplemNotam?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteBriefingGolSuplemNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteBriefingGolSuplemNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteBriefingGolSuplemNotam(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param briefingGolId (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    briefingGolId: number | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<BriefingGolSuplemNotamDto[]> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolSuplemNotam/GetAll?';
    if (briefingGolId !== undefined && briefingGolId !== null) url_ += 'BriefingGolId=' + encodeURIComponent('' + briefingGolId) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingGolSuplemNotamDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingGolSuplemNotamDto[]>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<BriefingGolSuplemNotamDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(BriefingGolSuplemNotamDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getBriefingGolSuplemNotamById(id: number | undefined): Observable<BriefingGolSuplemNotamDto> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolSuplemNotam/GetBriefingGolSuplemNotamById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetBriefingGolSuplemNotamById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetBriefingGolSuplemNotamById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<BriefingGolSuplemNotamDto>;
            }
          } else return _observableThrow(response_) as any as Observable<BriefingGolSuplemNotamDto>;
        }),
      );
  }

  protected processGetBriefingGolSuplemNotamById(response: HttpResponseBase): Observable<BriefingGolSuplemNotamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BriefingGolSuplemNotamDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateBriefingGolSuplemNotam(body: BriefingGolSuplemNotamDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/BriefingGolSuplemNotam/UpdateBriefingGolSuplemNotam';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateBriefingGolSuplemNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateBriefingGolSuplemNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateBriefingGolSuplemNotam(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CachingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  clearAllCaches(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Caching/ClearAllCaches';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClearAllCaches(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClearAllCaches(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  clearCache(body: EntityDtoOfString | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Caching/ClearCache';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClearCache(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClearCache(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processClearCache(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllCaches(): Observable<ListResultDtoOfCacheDto> {
    let url_ = this.baseUrl + '/api/services/app/Caching/GetAllCaches';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllCaches(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllCaches(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }),
      );
  }

  protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ChatServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param fileId (optional)
   * @param fileName (optional)
   * @param contentType (optional)
   * @param enc_auth_token (optional)
   * @return Success
   */
  getUploadedObject(
    fileId: string | undefined,
    fileName: string | null | undefined,
    contentType: string | null | undefined,
    enc_auth_token: string | null | undefined,
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Chat/GetUploadedObject?';
    if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
    else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    if (contentType !== undefined && contentType !== null) url_ += 'contentType=' + encodeURIComponent('' + contentType) + '&';
    if (enc_auth_token !== undefined && enc_auth_token !== null) url_ += 'enc_auth_token=' + encodeURIComponent('' + enc_auth_token) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUploadedObject(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUploadedObject(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processGetUploadedObject(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  uploadFile(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Chat/UploadFile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUploadFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
    let url_ = this.baseUrl + '/api/services/app/Chat/GetUserChatFriendsWithSettings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserChatFriendsWithSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserChatFriendsWithSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }),
      );
  }

  protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param minMessageId (optional)
   * @param tenantId (optional)
   * @param userId (optional)
   * @param groupId (optional)
   * @return Success
   */
  getUserChatMessages(
    minMessageId: number | null | undefined,
    tenantId: number | null | undefined,
    userId: number | null | undefined,
    groupId: number | null | undefined,
  ): Observable<ListResultDtoOfChatMessageDto> {
    let url_ = this.baseUrl + '/api/services/app/Chat/GetUserChatMessages?';
    if (minMessageId !== undefined && minMessageId !== null) url_ += 'MinMessageId=' + encodeURIComponent('' + minMessageId) + '&';
    if (tenantId !== undefined && tenantId !== null) url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
    if (userId !== undefined && userId !== null) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
    if (groupId !== undefined && groupId !== null) url_ += 'GroupId=' + encodeURIComponent('' + groupId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserChatMessages(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserChatMessages(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }),
      );
  }

  protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ChatFeatureCheckerServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param sourceTenantId (optional)
   * @param targetTenantId (optional)
   * @return Success
   */
  checkChatFeatures(sourceTenantId: number | null | undefined, targetTenantId: number | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/ChatFeatureChecker/CheckChatFeatures?';
    if (sourceTenantId !== undefined && sourceTenantId !== null) url_ += 'sourceTenantId=' + encodeURIComponent('' + sourceTenantId) + '&';
    if (targetTenantId !== undefined && targetTenantId !== null) url_ += 'targetTenantId=' + encodeURIComponent('' + targetTenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckChatFeatures(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckChatFeatures(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCheckChatFeatures(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sourceTenantId (optional)
   * @return Success
   */
  checkChatGroupFeature(sourceTenantId: number | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/ChatFeatureChecker/CheckChatGroupFeature?';
    if (sourceTenantId !== undefined && sourceTenantId !== null) url_ += 'sourceTenantId=' + encodeURIComponent('' + sourceTenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCheckChatGroupFeature(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCheckChatGroupFeature(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processCheckChatGroupFeature(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CityPairServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addCityPair(body: CityPairDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CityPair/AddCityPair';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddCityPair(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddCityPair(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddCityPair(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteCityPair(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CityPair/DeleteCityPair?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteCityPair(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteCityPair(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteCityPair(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getCityPairById(id: number | undefined): Observable<CityPairDto> {
    let url_ = this.baseUrl + '/api/services/app/CityPair/GetCityPairById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCityPairById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCityPairById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityPairDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CityPairDto>;
        }),
      );
  }

  protected processGetCityPairById(response: HttpResponseBase): Observable<CityPairDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityPairDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listCityPair(body: SearchCityPairDto | undefined): Observable<PagedResultDtoOfCityPairDto> {
    let url_ = this.baseUrl + '/api/services/app/CityPair/ListCityPair';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListCityPair(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListCityPair(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfCityPairDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfCityPairDto>;
        }),
      );
  }

  protected processListCityPair(response: HttpResponseBase): Observable<PagedResultDtoOfCityPairDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfCityPairDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCityPair(body: CityPairDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CityPair/UpdateCityPair';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCityPair(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCityPair(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateCityPair(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CommanderServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addCommander(body: CommanderDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Commander/AddCommander';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddCommander(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddCommander(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddCommander(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCommander(body: CommanderDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Commander/UpdateCommander';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCommander(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCommander(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateCommander(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filterByName (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    filterByName: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfCommanderDto> {
    let url_ = this.baseUrl + '/api/services/app/Commander/GetAll?';
    if (filterByName !== undefined && filterByName !== null) url_ += 'FilterByName=' + encodeURIComponent('' + filterByName) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfCommanderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfCommanderDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCommanderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfCommanderDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteCommander(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Commander/DeleteCommander?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteCommander(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteCommander(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteCommander(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getCommanderById(id: number | undefined): Observable<CommanderDto> {
    let url_ = this.baseUrl + '/api/services/app/Commander/GetCommanderById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCommanderById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCommanderById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CommanderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CommanderDto>;
        }),
      );
  }

  protected processGetCommanderById(response: HttpResponseBase): Observable<CommanderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CommanderDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CommonLookupServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
    let url_ = this.baseUrl + '/api/services/app/CommonLookup/FindUsers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFindUsers(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFindUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }),
      );
  }

  protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ContactServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addContact(body: ContactDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Contact/AddContact';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddContact(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddContact(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddContact(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateContact(body: ContactDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Contact/UpdateContact';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateContact(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateContact(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateContact(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    filter: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfContactDto> {
    let url_ = this.baseUrl + '/api/services/app/Contact/GetAll?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfContactDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfContactDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfContactDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfContactDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteContact(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Contact/DeleteContact?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteContact(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteContact(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteContact(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getContactById(id: number | undefined): Observable<ContactDto> {
    let url_ = this.baseUrl + '/api/services/app/Contact/GetContactById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContactById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetContactById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContactDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContactDto>;
        }),
      );
  }

  protected processGetContactById(response: HttpResponseBase): Observable<ContactDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContactDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ContinuousImprovementServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addContinuousImprovement(body: ContinuousImprovementDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/ContinuousImprovement/AddContinuousImprovement';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddContinuousImprovement(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddContinuousImprovement(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddContinuousImprovement(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateContinuousImprovement(body: ContinuousImprovementDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/ContinuousImprovement/UpdateContinuousImprovement';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateContinuousImprovement(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateContinuousImprovement(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateContinuousImprovement(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteContinuousImprovement(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/ContinuousImprovement/DeleteContinuousImprovement?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteContinuousImprovement(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteContinuousImprovement(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteContinuousImprovement(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param filterByCollaborator (optional)
   * @param filterByApprover (optional)
   * @param filterByStatus (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    filter: string | null | undefined,
    filterByCollaborator: number | null | undefined,
    filterByApprover: number | null | undefined,
    filterByStatus: number | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfContinuousImprovementDto> {
    let url_ = this.baseUrl + '/api/services/app/ContinuousImprovement/GetAll?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (filterByCollaborator !== undefined && filterByCollaborator !== null)
      url_ += 'FilterByCollaborator=' + encodeURIComponent('' + filterByCollaborator) + '&';
    if (filterByApprover !== undefined && filterByApprover !== null)
      url_ += 'FilterByApprover=' + encodeURIComponent('' + filterByApprover) + '&';
    if (filterByStatus !== undefined && filterByStatus !== null) url_ += 'FilterByStatus=' + encodeURIComponent('' + filterByStatus) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfContinuousImprovementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfContinuousImprovementDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfContinuousImprovementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfContinuousImprovementDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getContinuousImprovementById(id: number | undefined): Observable<ContinuousImprovementDto> {
    let url_ = this.baseUrl + '/api/services/app/ContinuousImprovement/GetContinuousImprovementById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContinuousImprovementById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetContinuousImprovementById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContinuousImprovementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContinuousImprovementDto>;
        }),
      );
  }

  protected processGetContinuousImprovementById(response: HttpResponseBase): Observable<ContinuousImprovementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContinuousImprovementDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CorridorInformationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param namePt (optional)
   * @param nameEs (optional)
   * @param nameEn (optional)
   * @return Success
   */
  addCorridor(
    namePt: string | null | undefined,
    nameEs: string | null | undefined,
    nameEn: string | null | undefined,
  ): Observable<CorridorDto> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/AddCorridor?';
    if (namePt !== undefined && namePt !== null) url_ += 'namePt=' + encodeURIComponent('' + namePt) + '&';
    if (nameEs !== undefined && nameEs !== null) url_ += 'nameEs=' + encodeURIComponent('' + nameEs) + '&';
    if (nameEn !== undefined && nameEn !== null) url_ += 'nameEn=' + encodeURIComponent('' + nameEn) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddCorridor(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddCorridor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CorridorDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CorridorDto>;
        }),
      );
  }

  protected processAddCorridor(response: HttpResponseBase): Observable<CorridorDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CorridorDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addOrUpdateOccurrences(body: CorridorOccurrencesDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/AddOrUpdateOccurrences';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddOrUpdateOccurrences(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddOrUpdateOccurrences(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processAddOrUpdateOccurrences(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteCorridor(id: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/DeleteCorridor?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteCorridor(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteCorridor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processDeleteCorridor(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param occurrenceId (optional)
   * @return Success
   */
  deleteOccurrences(occurrenceId: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/DeleteOccurrences?';
    if (occurrenceId === null) throw new Error("The parameter 'occurrenceId' cannot be null.");
    else if (occurrenceId !== undefined) url_ += 'OccurrenceId=' + encodeURIComponent('' + occurrenceId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteOccurrences(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteOccurrences(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processDeleteOccurrences(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param dateTime (optional)
   * @return Success
   */
  getAll(dateTime: moment.Moment | null | undefined): Observable<CorridorDto[]> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/GetAll?';
    if (dateTime !== undefined && dateTime !== null)
      url_ += 'dateTime=' + encodeURIComponent(dateTime ? '' + dateTime.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CorridorDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CorridorDto[]>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<CorridorDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(CorridorDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getCorridorById(id: number | undefined): Observable<CorridorDto> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/GetCorridorById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCorridorById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCorridorById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CorridorDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CorridorDto>;
        }),
      );
  }

  protected processGetCorridorById(response: HttpResponseBase): Observable<CorridorDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CorridorDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param occurrenceType (optional)
   * @param corridorId (optional)
   * @param dateTime (optional)
   * @return Success
   */
  getllOccurrences(
    occurrenceType: _definitions_CorridorOccurrenceType | undefined,
    corridorId: number | null | undefined,
    dateTime: moment.Moment | null | undefined,
  ): Observable<CorridorOccurrencesDto[]> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/GetllOccurrences?';
    if (occurrenceType === null) throw new Error("The parameter 'occurrenceType' cannot be null.");
    else if (occurrenceType !== undefined) url_ += 'occurrenceType=' + encodeURIComponent('' + occurrenceType) + '&';
    if (corridorId !== undefined && corridorId !== null) url_ += 'CorridorId=' + encodeURIComponent('' + corridorId) + '&';
    if (dateTime !== undefined && dateTime !== null)
      url_ += 'dateTime=' + encodeURIComponent(dateTime ? '' + dateTime.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetllOccurrences(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetllOccurrences(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CorridorOccurrencesDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CorridorOccurrencesDto[]>;
        }),
      );
  }

  protected processGetllOccurrences(response: HttpResponseBase): Observable<CorridorOccurrencesDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(CorridorOccurrencesDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getMeterologyType(): Observable<CorridorOccurrencesTypeDto[]> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/GetMeterologyType';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMeterologyType(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMeterologyType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CorridorOccurrencesTypeDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CorridorOccurrencesTypeDto[]>;
        }),
      );
  }

  protected processGetMeterologyType(response: HttpResponseBase): Observable<CorridorOccurrencesTypeDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(CorridorOccurrencesTypeDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCorridor(body: CorridorDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/UpdateCorridor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCorridor(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCorridor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processUpdateCorridor(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @param icon (optional)
   * @return Success
   */
  updateIoconCorridor(id: number | undefined, icon: string | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/CorridorInformation/UpdateIoconCorridor?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    if (icon !== undefined && icon !== null) url_ += 'icon=' + encodeURIComponent('' + icon) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateIoconCorridor(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateIoconCorridor(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processUpdateIoconCorridor(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CostIndexServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addCostIndex(body: CostIndexDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CostIndex/AddCostIndex';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddCostIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCostIndex(body: CostIndexDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CostIndex/UpdateCostIndex';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateCostIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteCostIndex(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CostIndex/DeleteCostIndex?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteCostIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getCostIndexById(id: number | undefined): Observable<CostIndexDto> {
    let url_ = this.baseUrl + '/api/services/app/CostIndex/GetCostIndexById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCostIndexById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCostIndexById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CostIndexDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CostIndexDto>;
        }),
      );
  }

  protected processGetCostIndexById(response: HttpResponseBase): Observable<CostIndexDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CostIndexDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listCostIndex(body: SearchCostIndexDto | undefined): Observable<PagedResultDtoOfCostIndexDto> {
    let url_ = this.baseUrl + '/api/services/app/CostIndex/ListCostIndex';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfCostIndexDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfCostIndexDto>;
        }),
      );
  }

  protected processListCostIndex(response: HttpResponseBase): Observable<PagedResultDtoOfCostIndexDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfCostIndexDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class CostIndexOperationalServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addOperationalCostIndex(body: CostIndexOperationalDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CostIndexOperational/AddOperationalCostIndex';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddOperationalCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddOperationalCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddOperationalCostIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteOperationalCostIndex(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CostIndexOperational/DeleteOperationalCostIndex?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteOperationalCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteOperationalCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteOperationalCostIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOperationalCostIndexById(id: number | undefined): Observable<CostIndexOperationalDto> {
    let url_ = this.baseUrl + '/api/services/app/CostIndexOperational/GetOperationalCostIndexById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOperationalCostIndexById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOperationalCostIndexById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CostIndexOperationalDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CostIndexOperationalDto>;
        }),
      );
  }

  protected processGetOperationalCostIndexById(response: HttpResponseBase): Observable<CostIndexOperationalDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CostIndexOperationalDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listCostIndex(body: SearchCostIndexOperationalDto | undefined): Observable<PagedResultDtoOfCostIndexOperationalDto> {
    let url_ = this.baseUrl + '/api/services/app/CostIndexOperational/ListCostIndex';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListCostIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListCostIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfCostIndexOperationalDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfCostIndexOperationalDto>;
        }),
      );
  }

  protected processListCostIndex(response: HttpResponseBase): Observable<PagedResultDtoOfCostIndexOperationalDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfCostIndexOperationalDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCostIndexOperational(body: CostIndexOperationalDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/CostIndexOperational/UpdateCostIndexOperational';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCostIndexOperational(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCostIndexOperational(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateCostIndexOperational(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class DynamicSettingsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param name (optional)
   * @param value (optional)
   * @return Success
   */
  delete(name: string | null | undefined, value: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/DynamicSettings/Delete?';
    if (name !== undefined && name !== null) url_ += 'Name=' + encodeURIComponent('' + name) + '&';
    if (value !== undefined && value !== null) url_ += 'Value=' + encodeURIComponent('' + value) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  dynamicSettingsCacheKey(): Observable<string> {
    let url_ = this.baseUrl + '/api/services/app/DynamicSettings/DynamicSettingsCacheKey';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDynamicSettingsCacheKey(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDynamicSettingsCacheKey(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processDynamicSettingsCacheKey(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param name (optional)
   * @return Success
   */
  get(name: string | null | undefined): Observable<SettingsDto> {
    let url_ = this.baseUrl + '/api/services/app/DynamicSettings/Get?';
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SettingsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SettingsDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<SettingsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SettingsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    filter: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfSettingsDto> {
    let url_ = this.baseUrl + '/api/services/app/DynamicSettings/GetAll?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfSettingsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfSettingsDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfSettingsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfSettingsDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  set(body: SettingsDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/DynamicSettings/Set';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class EventServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addEvents(body: EventDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Event/AddEvents';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddEvents(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddEvents(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddEvents(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateEvent(body: EventDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Event/UpdateEvent';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateEvent(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateEvent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateEvent(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param startTime (optional)
   * @param endTime (optional)
   * @return Success
   */
  getCalendar(startTime: moment.Moment | null | undefined, endTime: moment.Moment | null | undefined): Observable<CalendarEventDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Event/GetCalendar?';
    if (startTime !== undefined && startTime !== null)
      url_ += 'StartTime=' + encodeURIComponent(startTime ? '' + startTime.toISOString() : '') + '&';
    if (endTime !== undefined && endTime !== null) url_ += 'EndTime=' + encodeURIComponent(endTime ? '' + endTime.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCalendar(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCalendar(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CalendarEventDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CalendarEventDto[]>;
        }),
      );
  }

  protected processGetCalendar(response: HttpResponseBase): Observable<CalendarEventDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(CalendarEventDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param startTime (optional)
   * @param endTime (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    startTime: moment.Moment | undefined,
    endTime: moment.Moment | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfEventDto> {
    let url_ = this.baseUrl + '/api/services/app/Event/GetAll?';
    if (startTime === null) throw new Error("The parameter 'startTime' cannot be null.");
    else if (startTime !== undefined) url_ += 'StartTime=' + encodeURIComponent(startTime ? '' + startTime.toISOString() : '') + '&';
    if (endTime === null) throw new Error("The parameter 'endTime' cannot be null.");
    else if (endTime !== undefined) url_ += 'EndTime=' + encodeURIComponent(endTime ? '' + endTime.toISOString() : '') + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfEventDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfEventDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfEventDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfEventDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteEvent(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Event/DeleteEvent?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteEvent(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteEvent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteEvent(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getEventById(id: number | undefined): Observable<EventDto> {
    let url_ = this.baseUrl + '/api/services/app/Event/GetEventById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetEventById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetEventById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EventDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EventDto>;
        }),
      );
  }

  protected processGetEventById(response: HttpResponseBase): Observable<EventDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EventDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ExportServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendMailBriefing(body: SendEmailDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/Export/SendMailBriefing';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendMailBriefing(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendMailBriefing(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processSendMailBriefing(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendImageToDownload(body: SendImageDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/Export/SendImageToDownload';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendImageToDownload(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendImageToDownload(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processSendImageToDownload(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class FileServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param fileType (optional)
   * @return Success
   */
  downloadTempFile(fileName: string | null, fileToken: string | null, fileType: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/File/DownloadTempFile?';
    if (fileName === undefined) throw new Error("The parameter 'fileName' must be defined.");
    else if (fileName !== null) url_ += 'FileName=' + encodeURIComponent('' + fileName) + '&';
    if (fileToken === undefined) throw new Error("The parameter 'fileToken' must be defined.");
    else if (fileToken !== null) url_ += 'FileToken=' + encodeURIComponent('' + fileToken) + '&';
    if (fileType !== undefined && fileType !== null) url_ += 'FileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadTempFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadTempFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDownloadTempFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @param contentType (optional)
   * @param fileName (optional)
   * @return Success
   */
  downloadBinaryFile(
    id: string | undefined,
    contentType: string | null | undefined,
    fileName: string | null | undefined,
  ): Observable<void> {
    let url_ = this.baseUrl + '/File/DownloadBinaryFile?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    if (contentType !== undefined && contentType !== null) url_ += 'contentType=' + encodeURIComponent('' + contentType) + '&';
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadBinaryFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadBinaryFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDownloadBinaryFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  uploadTempFile(): Observable<void> {
    let url_ = this.baseUrl + '/File/UploadTempFile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadTempFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadTempFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUploadTempFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  uploadBinaryFile(): Observable<void> {
    let url_ = this.baseUrl + '/File/UploadBinaryFile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadBinaryFile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadBinaryFile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUploadBinaryFile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class FirServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addFir(body: FirDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Fir/AddFir';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddFir(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddFir(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddFir(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteFir(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Fir/DeleteFir?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFir(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteFir(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteFir(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getFirById(id: number | undefined): Observable<FirDto> {
    let url_ = this.baseUrl + '/api/services/app/Fir/GetFirById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFirById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFirById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FirDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FirDto>;
        }),
      );
  }

  protected processGetFirById(response: HttpResponseBase): Observable<FirDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FirDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listFir(body: SearchFirDto | undefined): Observable<PagedResultDtoOfFirDto> {
    let url_ = this.baseUrl + '/api/services/app/Fir/ListFir';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListFir(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListFir(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfFirDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfFirDto>;
        }),
      );
  }

  protected processListFir(response: HttpResponseBase): Observable<PagedResultDtoOfFirDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfFirDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateFir(body: FirDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Fir/UpdateFir';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFir(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFir(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateFir(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  listFirRegistered(): Observable<FirDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Fir/ListFirRegistered';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListFirRegistered(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListFirRegistered(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FirDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<FirDto[]>;
        }),
      );
  }

  protected processListFirRegistered(response: HttpResponseBase): Observable<FirDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(FirDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class FlightLaunchesServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addFlightLaunch(body: FlightLaunchDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightLaunches/AddFlightLaunch';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddFlightLaunch(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddFlightLaunch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddFlightLaunch(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteFlightLaunch(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightLaunches/DeleteFlightLaunch?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFlightLaunch(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteFlightLaunch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteFlightLaunch(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getFlightLaunchById(id: number | undefined): Observable<FlightLaunchDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightLaunches/GetFlightLaunchById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFlightLaunchById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFlightLaunchById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FlightLaunchDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FlightLaunchDto>;
        }),
      );
  }

  protected processGetFlightLaunchById(response: HttpResponseBase): Observable<FlightLaunchDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FlightLaunchDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listFlightLaunches(body: SearchFlightLaunchDto | undefined): Observable<PagedResultDtoOfFlightLaunchDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightLaunches/ListFlightLaunches';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListFlightLaunches(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListFlightLaunches(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfFlightLaunchDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfFlightLaunchDto>;
        }),
      );
  }

  protected processListFlightLaunches(response: HttpResponseBase): Observable<PagedResultDtoOfFlightLaunchDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfFlightLaunchDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateFlightLaunch(body: FlightLaunchDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightLaunches/UpdateFlightLaunch';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFlightLaunch(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFlightLaunch(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateFlightLaunch(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class FlightMonitoringServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addFlightMonitoring(body: FlightMonitoringDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/AddFlightMonitoring';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddFlightMonitoring(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddFlightMonitoring(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddFlightMonitoring(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateFlightMonitoring(body: FlightMonitoringDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/UpdateFlightMonitoring';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFlightMonitoring(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFlightMonitoring(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateFlightMonitoring(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listFlightMonitoring(body: SearchFlightMonitoringDto | undefined): Observable<PagedResultDtoOfFlightMonitoringDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/ListFlightMonitoring';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListFlightMonitoring(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListFlightMonitoring(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfFlightMonitoringDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfFlightMonitoringDto>;
        }),
      );
  }

  protected processListFlightMonitoring(response: HttpResponseBase): Observable<PagedResultDtoOfFlightMonitoringDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfFlightMonitoringDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getFlightMonitoringById(id: number | undefined): Observable<FlightMonitoringDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/GetFlightMonitoringById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFlightMonitoringById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFlightMonitoringById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FlightMonitoringDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FlightMonitoringDto>;
        }),
      );
  }

  protected processGetFlightMonitoringById(response: HttpResponseBase): Observable<FlightMonitoringDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FlightMonitoringDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteFlightMonitoring(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/DeleteFlightMonitoring?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFlightMonitoring(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteFlightMonitoring(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteFlightMonitoring(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listFlightMonitoringToExcel(body: SearchFlightMonitoringDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/ListFlightMonitoringToExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListFlightMonitoringToExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListFlightMonitoringToExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processListFlightMonitoringToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAvailableRegistration(): Observable<string[]> {
    let url_ = this.baseUrl + '/api/services/app/FlightMonitoring/GetAvailableRegistration';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAvailableRegistration(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAvailableRegistration(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        }),
      );
  }

  protected processGetAvailableRegistration(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class FlightTimeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addFlightTime(body: FlightTimeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightTime/AddFlightTime';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddFlightTime(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddFlightTime(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddFlightTime(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteFlightTime(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightTime/DeleteFlightTime?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFlightTime(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteFlightTime(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteFlightTime(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listFlightTimes(body: SearchFlightTimeDto | undefined): Observable<PagedResultDtoOfFlightTimeDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightTime/ListFlightTimes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListFlightTimes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListFlightTimes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfFlightTimeDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfFlightTimeDto>;
        }),
      );
  }

  protected processListFlightTimes(response: HttpResponseBase): Observable<PagedResultDtoOfFlightTimeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfFlightTimeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getById(id: number | undefined): Observable<FlightTimeDto> {
    let url_ = this.baseUrl + '/api/services/app/FlightTime/GetById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FlightTimeDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FlightTimeDto>;
        }),
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<FlightTimeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FlightTimeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateFlightTime(body: FlightTimeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/FlightTime/UpdateFlightTime';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFlightTime(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateFlightTime(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateFlightTime(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class FriendshipServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Friendship/AcceptFriendshipRequest';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAcceptFriendshipRequest(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAcceptFriendshipRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  blockUser(body: BlockUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Friendship/BlockUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBlockUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBlockUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processBlockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendshipDto> {
    let url_ = this.baseUrl + '/api/services/app/Friendship/CreateFriendshipRequest';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFriendshipRequest(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateFriendshipRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FriendshipDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FriendshipDto>;
        }),
      );
  }

  protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendshipDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FriendshipDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendshipDto> {
    let url_ = this.baseUrl + '/api/services/app/Friendship/CreateFriendshipRequestByUserName';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFriendshipRequestByUserName(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateFriendshipRequestByUserName(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FriendshipDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FriendshipDto>;
        }),
      );
  }

  protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendshipDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FriendshipDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unblockUser(body: UnblockUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Friendship/UnblockUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnblockUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnblockUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUnblockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class GoogleServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getAnalytics(): Observable<string> {
    let url_ = this.baseUrl + '/api/services/app/Google/GetAnalytics';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAnalytics(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAnalytics(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processGetAnalytics(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getRecaptchaSiteKey(): Observable<string> {
    let url_ = this.baseUrl + '/api/services/app/Google/GetRecaptchaSiteKey';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRecaptchaSiteKey(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRecaptchaSiteKey(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processGetRecaptchaSiteKey(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getTagManager(): Observable<string> {
    let url_ = this.baseUrl + '/api/services/app/Google/GetTagManager';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTagManager(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTagManager(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processGetTagManager(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class HomeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  index(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Home/Index';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIndex(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class HostSettingsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getAllSettingsAnonymous(): Observable<HostSettingsEditDto> {
    let url_ = this.baseUrl + '/api/services/app/HostSettings/GetAllSettingsAnonymous';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllSettingsAnonymous(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllSettingsAnonymous(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
            }
          } else return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }),
      );
  }

  protected processGetAllSettingsAnonymous(response: HttpResponseBase): Observable<HostSettingsEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HostSettingsEditDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllSettings(): Observable<HostSettingsEditDto> {
    let url_ = this.baseUrl + '/api/services/app/HostSettings/GetAllSettings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
            }
          } else return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }),
      );
  }

  protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = HostSettingsEditDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/HostSettings/UpdateAllSettings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAllSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateAllSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/HostSettings/SendTestEmail';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendTestEmail(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendTestEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class LanguageServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Language/CreateOrUpdateLanguage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateLanguage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateLanguage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteLanguage(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Language/DeleteLanguage?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteLanguage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteLanguage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllLanguages(): Observable<LanguageInfo[]> {
    let url_ = this.baseUrl + '/api/services/app/Language/GetAllLanguages';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllLanguages(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllLanguages(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LanguageInfo[]>;
            }
          } else return _observableThrow(response_) as any as Observable<LanguageInfo[]>;
        }),
      );
  }

  protected processGetAllLanguages(response: HttpResponseBase): Observable<LanguageInfo[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LanguageInfo.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getLanguageForEdit(id: number | null | undefined): Observable<GetLanguageForEditOutput> {
    let url_ = this.baseUrl + '/api/services/app/Language/GetLanguageForEdit?';
    if (id !== undefined && id !== null) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLanguageForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLanguageForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }),
      );
  }

  protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetLanguageForEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @return Success
   */
  getLanguages(filter: string | null | undefined, sorting: string | null | undefined): Observable<GetLanguagesOutput> {
    let url_ = this.baseUrl + '/api/services/app/Language/GetLanguages?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLanguages(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLanguages(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }),
      );
  }

  protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetLanguagesOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param baseLanguageName (optional)
   * @param filterText (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @param sorting (optional)
   * @param targetValueFilter (optional)
   * @return Success
   */
  getLanguageTexts(
    baseLanguageName: string | null | undefined,
    filterText: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
    sorting: string | null | undefined,
    sourceName: string | null,
    targetLanguageName: string | null,
    targetValueFilter: string | null | undefined,
  ): Observable<PagedResultDtoOfLanguageTextListDto> {
    let url_ = this.baseUrl + '/api/services/app/Language/GetLanguageTexts?';
    if (baseLanguageName !== undefined && baseLanguageName !== null)
      url_ += 'BaseLanguageName=' + encodeURIComponent('' + baseLanguageName) + '&';
    if (filterText !== undefined && filterText !== null) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (sourceName === undefined) throw new Error("The parameter 'sourceName' must be defined.");
    else if (sourceName !== null) url_ += 'SourceName=' + encodeURIComponent('' + sourceName) + '&';
    if (targetLanguageName === undefined) throw new Error("The parameter 'targetLanguageName' must be defined.");
    else if (targetLanguageName !== null) url_ += 'TargetLanguageName=' + encodeURIComponent('' + targetLanguageName) + '&';
    if (targetValueFilter !== undefined && targetValueFilter !== null)
      url_ += 'TargetValueFilter=' + encodeURIComponent('' + targetValueFilter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLanguageTexts(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLanguageTexts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }),
      );
  }

  protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Language/SetDefaultLanguage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetDefaultLanguage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetDefaultLanguage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Language/UpdateLanguageText';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateLanguageText(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateLanguageText(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class MELItemServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addMELItem(body: MELItemDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/MELItem/AddMELItem';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddMELItem(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddMELItem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddMELItem(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteMELItem(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/MELItem/DeleteMELItem?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteMELItem(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteMELItem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteMELItem(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listMELItem(body: SearchMELItemDto | undefined): Observable<PagedResultDtoOfMELItemDto> {
    let url_ = this.baseUrl + '/api/services/app/MELItem/ListMELItem';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListMELItem(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListMELItem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfMELItemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfMELItemDto>;
        }),
      );
  }

  protected processListMELItem(response: HttpResponseBase): Observable<PagedResultDtoOfMELItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfMELItemDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getById(id: number | undefined): Observable<MELItemDto> {
    let url_ = this.baseUrl + '/api/services/app/MELItem/GetById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MELItemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<MELItemDto>;
        }),
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<MELItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MELItemDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateMELItem(body: MELItemDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/MELItem/UpdateMELItem';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateMELItem(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateMELItem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateMELItem(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class MELPainelServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addMEL(body: MELDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/MELPainel/AddMEL';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddMEL(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddMEL(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddMEL(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteMEL(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/MELPainel/DeleteMEL?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteMEL(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteMEL(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteMEL(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getMELById(id: number | undefined): Observable<MELDto> {
    let url_ = this.baseUrl + '/api/services/app/MELPainel/GetMELById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMELById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMELById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MELDto>;
            }
          } else return _observableThrow(response_) as any as Observable<MELDto>;
        }),
      );
  }

  protected processGetMELById(response: HttpResponseBase): Observable<MELDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MELDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listMEL(body: SearchMELDto | undefined): Observable<PagedResultDtoOfMELDto> {
    let url_ = this.baseUrl + '/api/services/app/MELPainel/ListMEL';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListMEL(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListMEL(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfMELDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfMELDto>;
        }),
      );
  }

  protected processListMEL(response: HttpResponseBase): Observable<PagedResultDtoOfMELDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfMELDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateMEL(body: MELDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/MELPainel/UpdateMEL';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateMEL(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateMEL(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateMEL(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class MinimumsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listCompleteMinimums(body: SearchMinimumsDto | undefined): Observable<PagedResultDtoOfMinimumsItemDto> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/ListCompleteMinimums';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListCompleteMinimums(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListCompleteMinimums(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfMinimumsItemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfMinimumsItemDto>;
        }),
      );
  }

  protected processListCompleteMinimums(response: HttpResponseBase): Observable<PagedResultDtoOfMinimumsItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfMinimumsItemDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param minimumsId (optional)
   * @return Success
   */
  getCompleteMinimumsById(minimumsId: number | undefined): Observable<CompleteObjectMinimumDto> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/GetCompleteMinimumsById?';
    if (minimumsId === null) throw new Error("The parameter 'minimumsId' cannot be null.");
    else if (minimumsId !== undefined) url_ += 'minimumsId=' + encodeURIComponent('' + minimumsId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCompleteMinimumsById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCompleteMinimumsById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompleteObjectMinimumDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CompleteObjectMinimumDto>;
        }),
      );
  }

  protected processGetCompleteMinimumsById(response: HttpResponseBase): Observable<CompleteObjectMinimumDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompleteObjectMinimumDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param minimumsItemId (optional)
   * @return Success
   */
  getToEdit(minimumsItemId: number | undefined): Observable<CompleteObjectMinimumDto> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/GetToEdit?';
    if (minimumsItemId === null) throw new Error("The parameter 'minimumsItemId' cannot be null.");
    else if (minimumsItemId !== undefined) url_ += 'minimumsItemId=' + encodeURIComponent('' + minimumsItemId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetToEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetToEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CompleteObjectMinimumDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CompleteObjectMinimumDto>;
        }),
      );
  }

  protected processGetToEdit(response: HttpResponseBase): Observable<CompleteObjectMinimumDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CompleteObjectMinimumDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateWithOrWithoutInsertMinimumsItems(body: MinimumsItemDto[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/UpdateWithOrWithoutInsertMinimumsItems';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateWithOrWithoutInsertMinimumsItems(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateWithOrWithoutInsertMinimumsItems(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateWithOrWithoutInsertMinimumsItems(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param minimumsItemId (optional)
   * @return Success
   */
  getMinimumsItemById(minimumsItemId: number | undefined): Observable<MinimumsItemDto> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/GetMinimumsItemById?';
    if (minimumsItemId === null) throw new Error("The parameter 'minimumsItemId' cannot be null.");
    else if (minimumsItemId !== undefined) url_ += 'minimumsItemId=' + encodeURIComponent('' + minimumsItemId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMinimumsItemById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetMinimumsItemById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MinimumsItemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<MinimumsItemDto>;
        }),
      );
  }

  protected processGetMinimumsItemById(response: HttpResponseBase): Observable<MinimumsItemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = MinimumsItemDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  insert(body: CompleteObjectMinimumDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/Insert';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInsert(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInsert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processInsert(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteMinimums(id: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/DeleteMinimums?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteMinimums(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteMinimums(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processDeleteMinimums(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param minimumsItemId (optional)
   * @return Success
   */
  deleteMinimumsItem(minimumsItemId: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/DeleteMinimumsItem?';
    if (minimumsItemId === null) throw new Error("The parameter 'minimumsItemId' cannot be null.");
    else if (minimumsItemId !== undefined) url_ += 'minimumsItemId=' + encodeURIComponent('' + minimumsItemId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteMinimumsItem(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteMinimumsItem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processDeleteMinimumsItem(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateMinimums(body: MinimumsDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/UpdateMinimums';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateMinimums(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateMinimums(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processUpdateMinimums(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateMinimumsItem(body: MinimumsItemDto | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/Minimums/UpdateMinimumsItem';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateMinimumsItem(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateMinimumsItem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processUpdateMinimumsItem(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class MIRCServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param dateTime (optional)
   * @return Success
   */
  getLastMengasse(dateTime: moment.Moment | undefined): Observable<MIRCMessageDto[]> {
    let url_ = this.baseUrl + '/api/services/app/mIRC/GetLastMengasse?';
    if (dateTime === null) throw new Error("The parameter 'dateTime' cannot be null.");
    else if (dateTime !== undefined) url_ += 'dateTime=' + encodeURIComponent(dateTime ? '' + dateTime.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLastMengasse(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLastMengasse(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<MIRCMessageDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<MIRCMessageDto[]>;
        }),
      );
  }

  protected processGetLastMengasse(response: HttpResponseBase): Observable<MIRCMessageDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(MIRCMessageDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class NotamServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addNotam(body: NotamDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notam/AddNotam';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddNotam(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteNotam(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notam/DeleteNotam?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteNotam(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getNotamById(id: number | undefined): Observable<NotamDto> {
    let url_ = this.baseUrl + '/api/services/app/Notam/GetNotamById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotamById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotamById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<NotamDto>;
            }
          } else return _observableThrow(response_) as any as Observable<NotamDto>;
        }),
      );
  }

  protected processGetNotamById(response: HttpResponseBase): Observable<NotamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = NotamDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listNotam(body: SearchNotamDto | undefined): Observable<PagedResultDtoOfNotamDto> {
    let url_ = this.baseUrl + '/api/services/app/Notam/ListNotam';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfNotamDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfNotamDto>;
        }),
      );
  }

  protected processListNotam(response: HttpResponseBase): Observable<PagedResultDtoOfNotamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfNotamDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateNotam(body: NotamDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notam/UpdateNotam';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateNotam(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateNotam(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateNotam(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAvailableRegistration(): Observable<string[]> {
    let url_ = this.baseUrl + '/api/services/app/Notam/GetAvailableRegistration';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAvailableRegistration(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAvailableRegistration(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        }),
      );
  }

  protected processGetAvailableRegistration(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class NotificationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteNotification(id: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notification/DeleteNotification?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteNotification(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteNotification(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
    let url_ = this.baseUrl + '/api/services/app/Notification/GetNotificationSettings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetNotificationSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetNotificationSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }),
      );
  }

  protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetNotificationSettingsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param state (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getUserNotifications(
    state: UserNotificationState | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<GetNotificationsOutput> {
    let url_ = this.baseUrl + '/api/services/app/Notification/GetUserNotifications?';
    if (state === null) throw new Error("The parameter 'state' cannot be null.");
    else if (state !== undefined) url_ += 'State=' + encodeURIComponent('' + state) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserNotifications(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserNotifications(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }),
      );
  }

  protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetNotificationsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  setAllNotificationsAsRead(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notification/SetAllNotificationsAsRead';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetAllNotificationsAsRead(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetAllNotificationsAsRead(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notification/SetNotificationAsRead';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSetNotificationAsRead(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSetNotificationAsRead(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Notification/UpdateNotificationSettings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateNotificationSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateNotificationSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class OccurrenceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addOccurrence(body: OccurrenceDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Occurrence/AddOccurrence';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddOccurrence(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddOccurrence(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddOccurrence(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteOccurrence(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Occurrence/DeleteOccurrence?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteOccurrence(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteOccurrence(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteOccurrence(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listOccurrences(body: SearchOccurrencesDto | undefined): Observable<PagedResultDtoOfOccurrenceDto> {
    let url_ = this.baseUrl + '/api/services/app/Occurrence/ListOccurrences';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListOccurrences(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListOccurrences(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfOccurrenceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfOccurrenceDto>;
        }),
      );
  }

  protected processListOccurrences(response: HttpResponseBase): Observable<PagedResultDtoOfOccurrenceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfOccurrenceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOccurrenceById(id: number | undefined): Observable<OccurrenceDto> {
    let url_ = this.baseUrl + '/api/services/app/Occurrence/GetOccurrenceById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOccurrenceById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOccurrenceById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OccurrenceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<OccurrenceDto>;
        }),
      );
  }

  protected processGetOccurrenceById(response: HttpResponseBase): Observable<OccurrenceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OccurrenceDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateOccurrence(body: OccurrenceDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Occurrence/UpdateOccurrence';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateOccurrence(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateOccurrence(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateOccurrence(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listOccurrenceDtoToExcel(body: SearchOccurrencesDto | undefined): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/Occurrence/ListOccurrenceDtoToExcel';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListOccurrenceDtoToExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListOccurrenceDtoToExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processListOccurrenceDtoToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class OperationalTacticalServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param date (optional)
   * @return Success
   */
  getAll(date: moment.Moment | null | undefined): Observable<OperationalTacticalDto[]> {
    let url_ = this.baseUrl + '/api/services/app/OperationalTactical/GetAll?';
    if (date !== undefined && date !== null) url_ += 'date=' + encodeURIComponent(date ? '' + date.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OperationalTacticalDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<OperationalTacticalDto[]>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<OperationalTacticalDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(OperationalTacticalDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param dateStart (optional)
   * @param dateEnd (optional)
   * @return Success
   */
  getAllFlightByHours(dateStart: moment.Moment | null | undefined, dateEnd: moment.Moment | null | undefined): Observable<LineChartDto[]> {
    let url_ = this.baseUrl + '/api/services/app/OperationalTactical/GetAllFlightByHours?';
    if (dateStart !== undefined && dateStart !== null)
      url_ += 'dateStart=' + encodeURIComponent(dateStart ? '' + dateStart.toISOString() : '') + '&';
    if (dateEnd !== undefined && dateEnd !== null) url_ += 'dateEnd=' + encodeURIComponent(dateEnd ? '' + dateEnd.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFlightByHours(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFlightByHours(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LineChartDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<LineChartDto[]>;
        }),
      );
  }

  protected processGetAllFlightByHours(response: HttpResponseBase): Observable<LineChartDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LineChartDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param dateStart (optional)
   * @param dateEnd (optional)
   * @return Success
   */
  getAllFlightSummaryByHours(
    dateStart: moment.Moment | null | undefined,
    dateEnd: moment.Moment | null | undefined,
  ): Observable<LineChartDto[]> {
    let url_ = this.baseUrl + '/api/services/app/OperationalTactical/GetAllFlightSummaryByHours?';
    if (dateStart !== undefined && dateStart !== null)
      url_ += 'dateStart=' + encodeURIComponent(dateStart ? '' + dateStart.toISOString() : '') + '&';
    if (dateEnd !== undefined && dateEnd !== null) url_ += 'dateEnd=' + encodeURIComponent(dateEnd ? '' + dateEnd.toISOString() : '') + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllFlightSummaryByHours(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllFlightSummaryByHours(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<LineChartDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<LineChartDto[]>;
        }),
      );
  }

  protected processGetAllFlightSummaryByHours(response: HttpResponseBase): Observable<LineChartDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LineChartDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class OrientationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addOrientation(body: OrientationDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Orientation/AddOrientation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddOrientation(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddOrientation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddOrientation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateOrientation(body: OrientationDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Orientation/UpdateOrientation';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateOrientation(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateOrientation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateOrientation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    filter: string | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfOrientationDto> {
    let url_ = this.baseUrl + '/api/services/app/Orientation/GetAll?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfOrientationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrientationDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfOrientationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfOrientationDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteOrientation(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Orientation/DeleteOrientation?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteOrientation(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteOrientation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteOrientation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getOrientationById(id: number | undefined): Observable<OrientationDto> {
    let url_ = this.baseUrl + '/api/services/app/Orientation/GetOrientationById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetOrientationById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetOrientationById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrientationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<OrientationDto>;
        }),
      );
  }

  protected processGetOrientationById(response: HttpResponseBase): Observable<OrientationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrientationDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class PermissionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
    let url_ = this.baseUrl + '/api/services/app/Permission/GetAllPermissions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllPermissions(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllPermissions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }),
      );
  }

  protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ProfileServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  uploadProfilePicture(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/UploadProfilePicture';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadProfilePicture(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUploadProfilePicture(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getDefaultProfilePicture(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetDefaultProfilePicture';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDefaultProfilePicture(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDefaultProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processGetDefaultProfilePicture(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  getProfilePictureByUserPost(userId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePictureByUser?';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProfilePictureByUserPost(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProfilePictureByUserPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processGetProfilePictureByUserPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  getProfilePictureByUserGet(userId: number | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePictureByUser?';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProfilePictureByUserGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProfilePictureByUserGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }),
      );
  }

  protected processGetProfilePictureByUserGet(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetProfilePictureOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/ChangeLanguage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangeLanguage(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangeLanguage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword(body: ChangePasswordInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/ChangePassword';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processChangePassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetCurrentUserProfileForEdit';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentUserProfileForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentUserProfileForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }),
      );
  }

  protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CurrentUserProfileEditDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetPasswordComplexitySetting';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetPasswordComplexitySetting(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetPasswordComplexitySetting(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }),
      );
  }

  protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getProfilePicture(): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePicture';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProfilePicture(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }),
      );
  }

  protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetProfilePictureOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param userId (optional)
   * @param tenantId (optional)
   * @return Success
   */
  getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetFriendProfilePicture?';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
    else if (tenantId !== undefined) url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFriendProfilePicture(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFriendProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }),
      );
  }

  protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetProfilePictureOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param profilePictureId (optional)
   * @return Success
   */
  getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePictureById?';
    if (profilePictureId === null) throw new Error("The parameter 'profilePictureId' cannot be null.");
    else if (profilePictureId !== undefined) url_ += 'profilePictureId=' + encodeURIComponent('' + profilePictureId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProfilePictureById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProfilePictureById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }),
      );
  }

  protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetProfilePictureOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/UpdateCurrentUserProfile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateCurrentUserProfile(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateCurrentUserProfile(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Profile/UpdateProfilePicture';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateProfilePicture(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param profilePictureId (optional)
   * @param userId (optional)
   * @param tenantId (optional)
   * @return Success
   */
  getFriendProfilePictureById(
    profilePictureId: string | undefined,
    userId: number | undefined,
    tenantId: number | undefined,
  ): Observable<GetProfilePictureOutput> {
    let url_ = this.baseUrl + '/api/services/app/Profile/GetFriendProfilePictureById?';
    if (profilePictureId === null) throw new Error("The parameter 'profilePictureId' cannot be null.");
    else if (profilePictureId !== undefined) url_ += 'profilePictureId=' + encodeURIComponent('' + profilePictureId) + '&';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
    else if (tenantId !== undefined) url_ += 'tenantId=' + encodeURIComponent('' + tenantId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFriendProfilePictureById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFriendProfilePictureById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }),
      );
  }

  protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetProfilePictureOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class RecaptchaValidatorServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param captchaResponse (optional)
   * @return Success
   */
  validate(captchaResponse: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/RecaptchaValidator/Validate?';
    if (captchaResponse !== undefined && captchaResponse !== null)
      url_ += 'captchaResponse=' + encodeURIComponent('' + captchaResponse) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processValidate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processValidate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processValidate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ReleaseInformationServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/ReleaseInformation/Delete?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAll(): Observable<ReleaseDto[]> {
    let url_ = this.baseUrl + '/api/services/app/ReleaseInformation/GetAll';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseDto[]>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<ReleaseDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ReleaseDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  insert(body: ReleaseDto | undefined): Observable<ReleaseDto> {
    let url_ = this.baseUrl + '/api/services/app/ReleaseInformation/Insert';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInsert(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInsert(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ReleaseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ReleaseDto>;
        }),
      );
  }

  protected processInsert(response: HttpResponseBase): Observable<ReleaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ReleaseDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class RoleServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Role/CreateOrUpdateRole';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateRole(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteRole(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Role/DeleteRole?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteRole(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteRole(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteRole(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetRoleForEdit?';
    if (id !== undefined && id !== null) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoleForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoleForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }),
      );
  }

  protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetRoleForEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @return Success
   */
  getRoles(filter: string | null | undefined, sorting: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
    let url_ = this.baseUrl + '/api/services/app/Role/GetRoles?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRoles(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }),
      );
  }

  protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class RootThemeServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addRootTheme(body: RootThemeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/RootTheme/AddRootTheme';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddRootTheme(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddRootTheme(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddRootTheme(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateRootTheme(body: RootThemeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/RootTheme/UpdateRootTheme';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateRootTheme(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateRootTheme(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateRootTheme(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteRootTheme(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/RootTheme/DeleteRootTheme?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteRootTheme(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteRootTheme(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteRootTheme(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  listRootThemes(body: SearchRootThemeDto | undefined): Observable<PagedResultDtoOfRootThemeDto> {
    let url_ = this.baseUrl + '/api/services/app/RootTheme/ListRootThemes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListRootThemes(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListRootThemes(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfRootThemeDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfRootThemeDto>;
        }),
      );
  }

  protected processListRootThemes(response: HttpResponseBase): Observable<PagedResultDtoOfRootThemeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfRootThemeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getRootThemeById(id: number | undefined): Observable<RootThemeDto> {
    let url_ = this.baseUrl + '/api/services/app/RootTheme/GetRootThemeById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRootThemeById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRootThemeById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<RootThemeDto>;
            }
          } else return _observableThrow(response_) as any as Observable<RootThemeDto>;
        }),
      );
  }

  protected processGetRootThemeById(response: HttpResponseBase): Observable<RootThemeDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RootThemeDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class SessionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
    let url_ = this.baseUrl + '/api/services/app/Session/GetCurrentLoginInformations';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetCurrentLoginInformations(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetCurrentLoginInformations(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }),
      );
  }

  protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
    let url_ = this.baseUrl + '/api/services/app/Session/UpdateUserSignInToken';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserSignInToken(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserSignInToken(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }),
      );
  }

  protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TenantServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createTenant(body: CreateTenantInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/CreateTenant';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateTenant(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateTenant(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCreateTenant(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteTenant(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/DeleteTenant?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteTenant(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteTenant(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenantFeaturesForEdit?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTenantFeaturesForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTenantFeaturesForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }),
      );
  }

  protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenantForEdit?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTenantForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTenantForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantEditDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }),
      );
  }

  protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantEditDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getTenants(
    filter: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<PagedResultDtoOfTenantListDto> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenants?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTenants(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTenants(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }),
      );
  }

  protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/ResetTenantSpecificFeatures';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetTenantSpecificFeatures(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetTenantSpecificFeatures(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/UnlockTenantAdmin';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnlockTenantAdmin(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnlockTenantAdmin(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateTenant(body: TenantEditDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateTenant';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTenant(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateTenant(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateTenantFeatures';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTenantFeatures(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateTenantFeatures(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TenantAddressServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  create(body: TenantAddressDto | undefined): Observable<TenantAddressDto> {
    let url_ = this.baseUrl + '/api/services/app/TenantAddress/Create';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantAddressDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantAddressDto>;
        }),
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<TenantAddressDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantAddressDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  delete(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/TenantAddress/Delete?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfTenantAddressDto> {
    let url_ = this.baseUrl + '/api/services/app/TenantAddress/GetAll?';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantAddressDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantAddressDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTenantAddressDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfTenantAddressDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: number | undefined): Observable<TenantAddressDto> {
    let url_ = this.baseUrl + '/api/services/app/TenantAddress/Get?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantAddressDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantAddressDto>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<TenantAddressDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantAddressDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  update(body: TenantAddressDto | undefined): Observable<TenantAddressDto> {
    let url_ = this.baseUrl + '/api/services/app/TenantAddress/Update';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantAddressDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantAddressDto>;
        }),
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<TenantAddressDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantAddressDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class ServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  result(): Observable<string> {
    let url_ = this.baseUrl + '/Result';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResult(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResult(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processResult(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class NotamPDServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  error(): Observable<string> {
    let url_ = this.baseUrl + '/NotamPD/Error';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processError(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processError(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processError(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TimingServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param defaultTimezoneScope (optional)
   * @param selectedTimezoneId (optional)
   * @return Success
   */
  getTimezoneComboboxItems(
    defaultTimezoneScope: SettingScopes | undefined,
    selectedTimezoneId: string | null | undefined,
  ): Observable<ComboboxItemDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Timing/GetTimezoneComboboxItems?';
    if (defaultTimezoneScope === null) throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
    else if (defaultTimezoneScope !== undefined) url_ += 'DefaultTimezoneScope=' + encodeURIComponent('' + defaultTimezoneScope) + '&';
    if (selectedTimezoneId !== undefined && selectedTimezoneId !== null)
      url_ += 'SelectedTimezoneId=' + encodeURIComponent('' + selectedTimezoneId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTimezoneComboboxItems(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTimezoneComboboxItems(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }),
      );
  }

  protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ComboboxItemDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param defaultTimezoneScope (optional)
   * @return Success
   */
  getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
    let url_ = this.baseUrl + '/api/services/app/Timing/GetTimezones?';
    if (defaultTimezoneScope === null) throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
    else if (defaultTimezoneScope !== undefined) url_ += 'DefaultTimezoneScope=' + encodeURIComponent('' + defaultTimezoneScope) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTimezones(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetTimezones(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }),
      );
  }

  protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class TokenAuthServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/Authenticate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
            }
          } else return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }),
      );
  }

  protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/ExternalAuthenticate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExternalAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExternalAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }),
      );
  }

  protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  teamsAuthenticate(body: string | undefined): Observable<ExternalAuthenticateResultModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/TeamsAuthenticate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTeamsAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTeamsAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }),
      );
  }

  protected processTeamsAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param usernameOrEmailAddress (optional)
   * @return Success
   */
  getAuthenticationProviders(usernameOrEmailAddress: string | null | undefined): Observable<ProviderModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/GetAuthenticationProviders?';
    if (usernameOrEmailAddress !== undefined && usernameOrEmailAddress !== null)
      url_ += 'usernameOrEmailAddress=' + encodeURIComponent('' + usernameOrEmailAddress) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAuthenticationProviders(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAuthenticationProviders(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProviderModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ProviderModel>;
        }),
      );
  }

  protected processGetAuthenticationProviders(response: HttpResponseBase): Observable<ProviderModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProviderModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
    let url_ = this.baseUrl + '/api/TokenAuth/GetExternalAuthenticationProviders';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExternalAuthenticationProviders(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetExternalAuthenticationProviders(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }),
      );
  }

  protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param impersonationToken (optional)
   * @return Success
   */
  impersonatedAuthenticate(impersonationToken: string | null | undefined): Observable<ImpersonatedAuthenticateResultModel> {
    let url_ = this.baseUrl + '/api/TokenAuth/ImpersonatedAuthenticate?';
    if (impersonationToken !== undefined && impersonationToken !== null)
      url_ += 'impersonationToken=' + encodeURIComponent('' + impersonationToken) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImpersonatedAuthenticate(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImpersonatedAuthenticate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
            }
          } else return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }),
      );
  }

  protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  logOut(): Observable<void> {
    let url_ = this.baseUrl + '/api/TokenAuth/LogOut';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLogOut(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLogOut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processLogOut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/TokenAuth/SendTwoFactorAuthCode';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendTwoFactorAuthCode(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendTwoFactorAuthCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
    let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/GetUiManagementSettings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUiManagementSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUiManagementSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }),
      );
  }

  protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ThemeSettingsDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDefaultUiManagementSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateDefaultUiManagementSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUiManagementSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUiManagementSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  useSystemDefaultSettings(): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUseSystemDefaultSettings(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUseSystemDefaultSettings(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class UserServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  closeSessionUser(userId: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/CloseSessionUser?';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCloseSessionUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCloseSessionUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCloseSessionUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/CreateOrUpdateUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateOrUpdateUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateOrUpdateUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createUsersByActiveDirectory(body: CreateActiveDirectoryUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/CreateUsersByActiveDirectory';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUsersByActiveDirectory(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUsersByActiveDirectory(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCreateUsersByActiveDirectory(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  createUsersByLdap(body: CreateLdapUserInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/CreateUsersByLdap';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUsersByLdap(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateUsersByLdap(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processCreateUsersByLdap(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteUser(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/DeleteUser?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param name (optional)
   * @return Success
   */
  getActiveDirectoryUsers(name: string | null | undefined): Observable<UserListDto[]> {
    let url_ = this.baseUrl + '/api/services/app/User/GetActiveDirectoryUsers?';
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetActiveDirectoryUsers(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetActiveDirectoryUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserListDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }),
      );
  }

  protected processGetActiveDirectoryUsers(response: HttpResponseBase): Observable<UserListDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserListDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param name (optional)
   * @return Success
   */
  getLdapUsers(name: string | null | undefined): Observable<UserListDto[]> {
    let url_ = this.baseUrl + '/api/services/app/User/GetLdapUsers?';
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLdapUsers(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLdapUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserListDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }),
      );
  }

  protected processGetLdapUsers(response: HttpResponseBase): Observable<UserListDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserListDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getUserForEdit(id: number | null | undefined): Observable<GetUserForEditOutput> {
    let url_ = this.baseUrl + '/api/services/app/User/GetUserForEdit?';
    if (id !== undefined && id !== null) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }),
      );
  }

  protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetUserForEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
    let url_ = this.baseUrl + '/api/services/app/User/GetUserPermissionsForEdit?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserPermissionsForEdit(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUserPermissionsForEdit(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }),
      );
  }

  protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getUsers(
    filter: string | null | undefined,
    sorting: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<PagedResultDtoOfUserListDto> {
    let url_ = this.baseUrl + '/api/services/app/User/GetUsers?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUsers(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }),
      );
  }

  protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getUsersToExcel(): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/User/GetUsersToExcel';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUsersToExcel(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetUsersToExcel(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/ResetUserSpecificPermissions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetUserSpecificPermissions(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetUserSpecificPermissions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/UnlockUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnlockUser(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnlockUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUnlockUser(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/User/UpdateUserPermissions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserPermissions(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateUserPermissions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class UserLoginServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
    let url_ = this.baseUrl + '/api/services/app/UserLogin/GetRecentUserLoginAttempts';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRecentUserLoginAttempts(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetRecentUserLoginAttempts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfUserLoginAttemptDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfUserLoginAttemptDto>;
        }),
      );
  }

  protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class UsersServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param filter (optional)
   * @return Success
   */
  getAllUsers(filter: string | null | undefined): Observable<UserListDto[]> {
    let url_ = this.baseUrl + '/api/services/app/Users/GetAllUsers?';
    if (filter !== undefined && filter !== null) url_ += 'filter=' + encodeURIComponent('' + filter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllUsers(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserListDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<UserListDto[]>;
        }),
      );
  }

  protected processGetAllUsers(response: HttpResponseBase): Observable<UserListDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(UserListDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class UtilServiceServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  downloadTempFileV2(body: FileDto | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/services/app/UtilService/DownloadTempFileV2';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        'Accept': 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadTempFileV2(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadTempFileV2(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        }),
      );
  }

  protected processDownloadTempFileV2(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class WebhookEventServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param id (optional)
   * @return Success
   */
  get(id: string | null | undefined): Observable<WebhookEvent> {
    let url_ = this.baseUrl + '/api/services/app/WebhookEvent/Get?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<WebhookEvent>;
            }
          } else return _observableThrow(response_) as any as Observable<WebhookEvent>;
        }),
      );
  }

  protected processGet(response: HttpResponseBase): Observable<WebhookEvent> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = WebhookEvent.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class WebhookSendAttemptServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param subscriptionId (optional)
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  getAllSendAttempts(
    subscriptionId: string | null | undefined,
    maxResultCount: number | undefined,
    skipCount: number | undefined,
  ): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSendAttempt/GetAllSendAttempts?';
    if (subscriptionId !== undefined && subscriptionId !== null) url_ += 'SubscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllSendAttempts(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllSendAttempts(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetAllSendAttemptsOutput>;
        }),
      );
  }

  protected processGetAllSendAttempts(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSendAttemptsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfGetAllSendAttemptsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getAllSendAttemptsOfWebhookEvent(id: string | null | undefined): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSendAttempt/GetAllSendAttemptsOfWebhookEvent?';
    if (id !== undefined && id !== null) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllSendAttemptsOfWebhookEvent(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllSendAttemptsOfWebhookEvent(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput>;
        }),
      );
  }

  protected processGetAllSendAttemptsOfWebhookEvent(
    response: HttpResponseBase,
  ): Observable<ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param sendAttemptId (optional)
   * @return Success
   */
  resend(sendAttemptId: string | null | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSendAttempt/Resend?';
    if (sendAttemptId !== undefined && sendAttemptId !== null) url_ += 'sendAttemptId=' + encodeURIComponent('' + sendAttemptId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResend(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResend(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processResend(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class WebhookSubscriptionServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  activateWebhookSubscription(body: ActivateWebhookSubscriptionInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/ActivateWebhookSubscription';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActivateWebhookSubscription(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActivateWebhookSubscription(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processActivateWebhookSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addSubscription(body: WebhookSubscription | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/AddSubscription';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddSubscription(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddSubscription(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllAvailableWebhooks(): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/GetAllAvailableWebhooks';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllAvailableWebhooks(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllAvailableWebhooks(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllAvailableWebhooksOutput>;
        }),
      );
  }

  protected processGetAllAvailableWebhooks(response: HttpResponseBase): Observable<ListResultDtoOfGetAllAvailableWebhooksOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfGetAllAvailableWebhooksOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getAllSubscriptions(): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/GetAllSubscriptions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllSubscriptions(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllSubscriptions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }),
      );
  }

  protected processGetAllSubscriptions(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param webhookName (optional)
   * @return Success
   */
  getAllSubscriptionsIfFeaturesGranted(webhookName: string | null | undefined): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/GetAllSubscriptionsIfFeaturesGranted?';
    if (webhookName !== undefined && webhookName !== null) url_ += 'webhookName=' + encodeURIComponent('' + webhookName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllSubscriptionsIfFeaturesGranted(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllSubscriptionsIfFeaturesGranted(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<ListResultDtoOfGetAllSubscriptionsOutput>;
        }),
      );
  }

  protected processGetAllSubscriptionsIfFeaturesGranted(response: HttpResponseBase): Observable<ListResultDtoOfGetAllSubscriptionsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ListResultDtoOfGetAllSubscriptionsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param subscriptionId (optional)
   * @return Success
   */
  getSubscription(subscriptionId: string | null | undefined): Observable<WebhookSubscription> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/GetSubscription?';
    if (subscriptionId !== undefined && subscriptionId !== null) url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSubscription(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetSubscription(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<WebhookSubscription>;
            }
          } else return _observableThrow(response_) as any as Observable<WebhookSubscription>;
        }),
      );
  }

  protected processGetSubscription(response: HttpResponseBase): Observable<WebhookSubscription> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = WebhookSubscription.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param webhookName (optional)
   * @return Success
   */
  isSubscribed(webhookName: string | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/IsSubscribed?';
    if (webhookName !== undefined && webhookName !== null) url_ += 'webhookName=' + encodeURIComponent('' + webhookName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsSubscribed(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsSubscribed(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processIsSubscribed(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateSubscription(body: WebhookSubscription | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WebhookSubscription/UpdateSubscription';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSubscription(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateSubscription(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateSubscription(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class WebLogServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @return Success
   */
  downloadWebLogs(): Observable<FileDto> {
    let url_ = this.baseUrl + '/api/services/app/WebLog/DownloadWebLogs';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadWebLogs(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadWebLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FileDto>;
        }),
      );
  }

  protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FileDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @return Success
   */
  getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
    let url_ = this.baseUrl + '/api/services/app/WebLog/GetLatestWebLogs';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLatestWebLogs(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetLatestWebLogs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
            }
          } else return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }),
      );
  }

  protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetLatestWebLogsOutput.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

@Injectable()
export class WorkShiftServiceProxy {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addWorkShift(body: WorkShiftDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/AddWorkShift';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAddWorkShift(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAddWorkShift(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processAddWorkShift(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  deleteWorkShift(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/DeleteWorkShift?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteWorkShift(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteWorkShift(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processDeleteWorkShift(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  getWorkShiftById(id: number | undefined): Observable<WorkShiftDto> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/GetWorkShiftById?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWorkShiftById(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetWorkShiftById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<WorkShiftDto>;
            }
          } else return _observableThrow(response_) as any as Observable<WorkShiftDto>;
        }),
      );
  }

  protected processGetWorkShiftById(response: HttpResponseBase): Observable<WorkShiftDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = WorkShiftDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateWorkShift(body: WorkShiftDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/UpdateWorkShift';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateWorkShift(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpdateWorkShift(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processUpdateWorkShift(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  consentWorkShift(id: number | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/ConsentWorkShift?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processConsentWorkShift(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processConsentWorkShift(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }

  protected processConsentWorkShift(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param workShiftStatus (optional)
   * @param requesterId (optional)
   * @param workShiftType (optional)
   * @param filterByInitialDate (optional)
   * @param filterByFinalDate (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAll(
    filter: string | null | undefined,
    workShiftStatus: number | null | undefined,
    requesterId: number | null | undefined,
    workShiftType: number | null | undefined,
    filterByInitialDate: moment.Moment | null | undefined,
    filterByFinalDate: moment.Moment | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfWorkShiftDto> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/GetAll?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (workShiftStatus !== undefined && workShiftStatus !== null)
      url_ += 'WorkShiftStatus=' + encodeURIComponent('' + workShiftStatus) + '&';
    if (requesterId !== undefined && requesterId !== null) url_ += 'RequesterId=' + encodeURIComponent('' + requesterId) + '&';
    if (workShiftType !== undefined && workShiftType !== null) url_ += 'WorkShiftType=' + encodeURIComponent('' + workShiftType) + '&';
    if (filterByInitialDate !== undefined && filterByInitialDate !== null)
      url_ += 'FilterByInitialDate=' + encodeURIComponent(filterByInitialDate ? '' + filterByInitialDate.toISOString() : '') + '&';
    if (filterByFinalDate !== undefined && filterByFinalDate !== null)
      url_ += 'FilterByFinalDate=' + encodeURIComponent(filterByFinalDate ? '' + filterByFinalDate.toISOString() : '') + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfWorkShiftDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfWorkShiftDto>;
        }),
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWorkShiftDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfWorkShiftDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param filter (optional)
   * @param workShiftStatus (optional)
   * @param requesterId (optional)
   * @param workShiftType (optional)
   * @param filterByInitialDate (optional)
   * @param filterByFinalDate (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  getAllReport(
    filter: string | null | undefined,
    workShiftStatus: number | null | undefined,
    requesterId: number | null | undefined,
    workShiftType: number | null | undefined,
    filterByInitialDate: moment.Moment | null | undefined,
    filterByFinalDate: moment.Moment | null | undefined,
    sorting: string | null | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
  ): Observable<PagedResultDtoOfWorkShiftDto> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/GetAllReport?';
    if (filter !== undefined && filter !== null) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (workShiftStatus !== undefined && workShiftStatus !== null)
      url_ += 'WorkShiftStatus=' + encodeURIComponent('' + workShiftStatus) + '&';
    if (requesterId !== undefined && requesterId !== null) url_ += 'RequesterId=' + encodeURIComponent('' + requesterId) + '&';
    if (workShiftType !== undefined && workShiftType !== null) url_ += 'WorkShiftType=' + encodeURIComponent('' + workShiftType) + '&';
    if (filterByInitialDate !== undefined && filterByInitialDate !== null)
      url_ += 'FilterByInitialDate=' + encodeURIComponent(filterByInitialDate ? '' + filterByInitialDate.toISOString() : '') + '&';
    if (filterByFinalDate !== undefined && filterByFinalDate !== null)
      url_ += 'FilterByFinalDate=' + encodeURIComponent(filterByFinalDate ? '' + filterByFinalDate.toISOString() : '') + '&';
    if (sorting !== undefined && sorting !== null) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAllReport(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAllReport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PagedResultDtoOfWorkShiftDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PagedResultDtoOfWorkShiftDto>;
        }),
      );
  }

  protected processGetAllReport(response: HttpResponseBase): Observable<PagedResultDtoOfWorkShiftDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PagedResultDtoOfWorkShiftDto.fromJS(resultData200);
          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  isDovLider(id: string | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/IsDovLider?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsDovLider(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsDovLider(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processIsDovLider(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  isDovLiderOrAdmin(id: string | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/api/services/app/WorkShift/IsDovLiderOrAdmin?';
    if (id !== undefined && id !== null) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsDovLiderOrAdmin(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsDovLiderOrAdmin(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        }),
      );
  }

  protected processIsDovLiderOrAdmin(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body : (response as any).error instanceof Blob ? (response as any).error : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }),
      );
    }
    return _observableOf(null as any);
  }
}

export enum _definitions_CorridorOccurrenceType {
  Meteorology = 0,
  Notam = 1,
  AirTraffic = 2,
  Operations = 3,
}

export class AbaAlternate implements IAbaAlternate {
  briefingGolId!: number;
  id!: string | undefined;
  destiny!: string | undefined;
  description!: string | undefined;
  etd!: string | undefined;
  eta!: string | undefined;
  status!: AlternateStatus;
  type!: AlternateType;
  wind!: string | undefined;
  visibility!: string | undefined;
  roof!: string | undefined;
  meteorologicalEvents!: string | undefined;
  leaderDOVSupervision!: string | undefined;
  descricaoStatus!: string | undefined;

  constructor(data?: IAbaAlternate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.briefingGolId = _data['briefingGolId'];
      this.id = _data['id'];
      this.destiny = _data['destiny'];
      this.description = _data['description'];
      this.etd = _data['etd'];
      this.eta = _data['eta'];
      this.status = _data['status'];
      this.type = _data['type'];
      this.wind = _data['wind'];
      this.visibility = _data['visibility'];
      this.roof = _data['roof'];
      this.meteorologicalEvents = _data['meteorologicalEvents'];
      this.leaderDOVSupervision = _data['leaderDOVSupervision'];
      this.descricaoStatus = _data['descricaoStatus'];
    }
  }

  static fromJS(data: any): AbaAlternate {
    data = typeof data === 'object' ? data : {};
    let result = new AbaAlternate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['briefingGolId'] = this.briefingGolId;
    data['id'] = this.id;
    data['destiny'] = this.destiny;
    data['description'] = this.description;
    data['etd'] = this.etd;
    data['eta'] = this.eta;
    data['status'] = this.status;
    data['type'] = this.type;
    data['wind'] = this.wind;
    data['visibility'] = this.visibility;
    data['roof'] = this.roof;
    data['meteorologicalEvents'] = this.meteorologicalEvents;
    data['leaderDOVSupervision'] = this.leaderDOVSupervision;
    data['descricaoStatus'] = this.descricaoStatus;
    return data;
  }
}

export interface IAbaAlternate {
  briefingGolId: number;
  id: string | undefined;
  destiny: string | undefined;
  description: string | undefined;
  etd: string | undefined;
  eta: string | undefined;
  status: AlternateStatus;
  type: AlternateType;
  wind: string | undefined;
  visibility: string | undefined;
  roof: string | undefined;
  meteorologicalEvents: string | undefined;
  leaderDOVSupervision: string | undefined;
  descricaoStatus: string | undefined;
}

export class AbaBriefing implements IAbaBriefing {
  idNotamSup!: number;
  flight!: string | undefined;
  startValidate!: string | undefined;
  endValidate!: string | undefined;
  description!: string | undefined;
  fir!: string | undefined;

  constructor(data?: IAbaBriefing) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idNotamSup = _data['idNotamSup'];
      this.flight = _data['flight'];
      this.startValidate = _data['startValidate'];
      this.endValidate = _data['endValidate'];
      this.description = _data['description'];
      this.fir = _data['fir'];
    }
  }

  static fromJS(data: any): AbaBriefing {
    data = typeof data === 'object' ? data : {};
    let result = new AbaBriefing();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idNotamSup'] = this.idNotamSup;
    data['flight'] = this.flight;
    data['startValidate'] = this.startValidate;
    data['endValidate'] = this.endValidate;
    data['description'] = this.description;
    data['fir'] = this.fir;
    return data;
  }
}

export interface IAbaBriefing {
  idNotamSup: number;
  flight: string | undefined;
  startValidate: string | undefined;
  endValidate: string | undefined;
  description: string | undefined;
  fir: string | undefined;
}

export class AbaExtraFual implements IAbaExtraFual {
  idNotamSup!: number;
  flight!: string | undefined;
  startValidate!: string | undefined;
  endValidate!: string | undefined;
  supervisorSuggestion!: string | undefined;
  statisticalSuggestion!: string | undefined;
  statisticalSuggestionDetails!: string[] | undefined;
  statisticalSuggestionHistorico!: string[] | undefined;
  fir!: string | undefined;

  constructor(data?: IAbaExtraFual) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idNotamSup = _data['idNotamSup'];
      this.flight = _data['flight'];
      this.startValidate = _data['startValidate'];
      this.endValidate = _data['endValidate'];
      this.supervisorSuggestion = _data['supervisorSuggestion'];
      this.statisticalSuggestion = _data['statisticalSuggestion'];
      if (Array.isArray(_data['statisticalSuggestionDetails'])) {
        this.statisticalSuggestionDetails = [] as any;
        for (let item of _data['statisticalSuggestionDetails']) this.statisticalSuggestionDetails!.push(item);
      }
      if (Array.isArray(_data['statisticalSuggestionHistorico'])) {
        this.statisticalSuggestionHistorico = [] as any;
        for (let item of _data['statisticalSuggestionHistorico']) this.statisticalSuggestionHistorico!.push(item);
      }
      this.fir = _data['fir'];
    }
  }

  static fromJS(data: any): AbaExtraFual {
    data = typeof data === 'object' ? data : {};
    let result = new AbaExtraFual();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idNotamSup'] = this.idNotamSup;
    data['flight'] = this.flight;
    data['startValidate'] = this.startValidate;
    data['endValidate'] = this.endValidate;
    data['supervisorSuggestion'] = this.supervisorSuggestion;
    data['statisticalSuggestion'] = this.statisticalSuggestion;
    if (Array.isArray(this.statisticalSuggestionDetails)) {
      data['statisticalSuggestionDetails'] = [];
      for (let item of this.statisticalSuggestionDetails) data['statisticalSuggestionDetails'].push(item);
    }
    if (Array.isArray(this.statisticalSuggestionHistorico)) {
      data['statisticalSuggestionHistorico'] = [];
      for (let item of this.statisticalSuggestionHistorico) data['statisticalSuggestionHistorico'].push(item);
    }
    data['fir'] = this.fir;
    return data;
  }
}

export interface IAbaExtraFual {
  idNotamSup: number;
  flight: string | undefined;
  startValidate: string | undefined;
  endValidate: string | undefined;
  supervisorSuggestion: string | undefined;
  statisticalSuggestion: string | undefined;
  statisticalSuggestionDetails: string[] | undefined;
  statisticalSuggestionHistorico: string[] | undefined;
  fir: string | undefined;
}

export class AbaNotam implements IAbaNotam {
  idNotamSup!: number;
  flight!: string | undefined;
  startValidate!: string | undefined;
  endValidate!: string | undefined;
  description!: string | undefined;
  fir!: string | undefined;

  constructor(data?: IAbaNotam) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idNotamSup = _data['idNotamSup'];
      this.flight = _data['flight'];
      this.startValidate = _data['startValidate'];
      this.endValidate = _data['endValidate'];
      this.description = _data['description'];
      this.fir = _data['fir'];
    }
  }

  static fromJS(data: any): AbaNotam {
    data = typeof data === 'object' ? data : {};
    let result = new AbaNotam();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idNotamSup'] = this.idNotamSup;
    data['flight'] = this.flight;
    data['startValidate'] = this.startValidate;
    data['endValidate'] = this.endValidate;
    data['description'] = this.description;
    data['fir'] = this.fir;
    return data;
  }
}

export interface IAbaNotam {
  idNotamSup: number;
  flight: string | undefined;
  startValidate: string | undefined;
  endValidate: string | undefined;
  description: string | undefined;
  fir: string | undefined;
}

export class AbaNotamSupl implements IAbaNotamSupl {
  idNotamSup!: number;
  flight!: string | undefined;
  startValidate!: string | undefined;
  endValidate!: string | undefined;
  description!: string | undefined;
  fir!: string | undefined;

  constructor(data?: IAbaNotamSupl) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.idNotamSup = _data['idNotamSup'];
      this.flight = _data['flight'];
      this.startValidate = _data['startValidate'];
      this.endValidate = _data['endValidate'];
      this.description = _data['description'];
      this.fir = _data['fir'];
    }
  }

  static fromJS(data: any): AbaNotamSupl {
    data = typeof data === 'object' ? data : {};
    let result = new AbaNotamSupl();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['idNotamSup'] = this.idNotamSup;
    data['flight'] = this.flight;
    data['startValidate'] = this.startValidate;
    data['endValidate'] = this.endValidate;
    data['description'] = this.description;
    data['fir'] = this.fir;
    return data;
  }
}

export interface IAbaNotamSupl {
  idNotamSup: number;
  flight: string | undefined;
  startValidate: string | undefined;
  endValidate: string | undefined;
  description: string | undefined;
  fir: string | undefined;
}

export class AboutModel implements IAboutModel {
  version!: string | undefined;
  osVersion!: string | undefined;
  os!: string | undefined;
  numberOfProcessors!: string | undefined;
  machineName!: string | undefined;
  architecture!: string | undefined;
  runtimeIdentifier!: string | undefined;
  frameworkDescription!: string | undefined;
  totalAvailableMemory!: string | undefined;
  currentCulture!: string | undefined;
  currentTimeZoneLocal!: string | undefined;
  currentEnviromment!: string | undefined;
  currentDirectory!: string | undefined;
  processName!: string | undefined;
  pagedMemorySize!: string | undefined;
  privateMemorySize!: string | undefined;
  virtualMemorySize!: string | undefined;
  workingMemoryUsed!: string | undefined;
  modules!: string[] | undefined;
  environments!: { [key: string]: string } | undefined;

  constructor(data?: IAboutModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data['version'];
      this.osVersion = _data['osVersion'];
      this.os = _data['os'];
      this.numberOfProcessors = _data['numberOfProcessors'];
      this.machineName = _data['machineName'];
      this.architecture = _data['architecture'];
      this.runtimeIdentifier = _data['runtimeIdentifier'];
      this.frameworkDescription = _data['frameworkDescription'];
      this.totalAvailableMemory = _data['totalAvailableMemory'];
      this.currentCulture = _data['currentCulture'];
      this.currentTimeZoneLocal = _data['currentTimeZoneLocal'];
      this.currentEnviromment = _data['currentEnviromment'];
      this.currentDirectory = _data['currentDirectory'];
      this.processName = _data['processName'];
      this.pagedMemorySize = _data['pagedMemorySize'];
      this.privateMemorySize = _data['privateMemorySize'];
      this.virtualMemorySize = _data['virtualMemorySize'];
      this.workingMemoryUsed = _data['workingMemoryUsed'];
      if (Array.isArray(_data['modules'])) {
        this.modules = [] as any;
        for (let item of _data['modules']) this.modules!.push(item);
      }
      if (_data['environments']) {
        this.environments = {} as any;
        for (let key in _data['environments']) {
          if (_data['environments'].hasOwnProperty(key)) (<any>this.environments)![key] = _data['environments'][key];
        }
      }
    }
  }

  static fromJS(data: any): AboutModel {
    data = typeof data === 'object' ? data : {};
    let result = new AboutModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['version'] = this.version;
    data['osVersion'] = this.osVersion;
    data['os'] = this.os;
    data['numberOfProcessors'] = this.numberOfProcessors;
    data['machineName'] = this.machineName;
    data['architecture'] = this.architecture;
    data['runtimeIdentifier'] = this.runtimeIdentifier;
    data['frameworkDescription'] = this.frameworkDescription;
    data['totalAvailableMemory'] = this.totalAvailableMemory;
    data['currentCulture'] = this.currentCulture;
    data['currentTimeZoneLocal'] = this.currentTimeZoneLocal;
    data['currentEnviromment'] = this.currentEnviromment;
    data['currentDirectory'] = this.currentDirectory;
    data['processName'] = this.processName;
    data['pagedMemorySize'] = this.pagedMemorySize;
    data['privateMemorySize'] = this.privateMemorySize;
    data['virtualMemorySize'] = this.virtualMemorySize;
    data['workingMemoryUsed'] = this.workingMemoryUsed;
    if (Array.isArray(this.modules)) {
      data['modules'] = [];
      for (let item of this.modules) data['modules'].push(item);
    }
    if (this.environments) {
      data['environments'] = {};
      for (let key in this.environments) {
        if (this.environments.hasOwnProperty(key)) (<any>data['environments'])[key] = (<any>this.environments)[key];
      }
    }
    return data;
  }
}

export interface IAboutModel {
  version: string | undefined;
  osVersion: string | undefined;
  os: string | undefined;
  numberOfProcessors: string | undefined;
  machineName: string | undefined;
  architecture: string | undefined;
  runtimeIdentifier: string | undefined;
  frameworkDescription: string | undefined;
  totalAvailableMemory: string | undefined;
  currentCulture: string | undefined;
  currentTimeZoneLocal: string | undefined;
  currentEnviromment: string | undefined;
  currentDirectory: string | undefined;
  processName: string | undefined;
  pagedMemorySize: string | undefined;
  privateMemorySize: string | undefined;
  virtualMemorySize: string | undefined;
  workingMemoryUsed: string | undefined;
  modules: string[] | undefined;
  environments: { [key: string]: string } | undefined;
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IAcceptFriendshipRequestInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): AcceptFriendshipRequestInput {
    data = typeof data === 'object' ? data : {};
    let result = new AcceptFriendshipRequestInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IAcceptFriendshipRequestInput {
  tenantId: number | undefined;
  userId: number;
}

export class ActivateEmailInput implements IActivateEmailInput {
  c!: string | undefined;
  confirmationCode!: string | undefined;
  userId!: number;

  constructor(data?: IActivateEmailInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.c = _data['c'];
      this.confirmationCode = _data['confirmationCode'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ActivateEmailInput {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateEmailInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['c'] = this.c;
    data['confirmationCode'] = this.confirmationCode;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IActivateEmailInput {
  c: string | undefined;
  confirmationCode: string | undefined;
  userId: number;
}

export class ActivateWebhookSubscriptionInput implements IActivateWebhookSubscriptionInput {
  isActive!: boolean;
  subscriptionId!: string;

  constructor(data?: IActivateWebhookSubscriptionInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
      this.subscriptionId = _data['subscriptionId'];
    }
  }

  static fromJS(data: any): ActivateWebhookSubscriptionInput {
    data = typeof data === 'object' ? data : {};
    let result = new ActivateWebhookSubscriptionInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    data['subscriptionId'] = this.subscriptionId;
    return data;
  }
}

export interface IActivateWebhookSubscriptionInput {
  isActive: boolean;
  subscriptionId: string;
}

export class AddMapImageDto implements IAddMapImageDto {
  version!: number;
  image!: string | undefined;

  constructor(data?: IAddMapImageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data['version'];
      this.image = _data['image'];
    }
  }

  static fromJS(data: any): AddMapImageDto {
    data = typeof data === 'object' ? data : {};
    let result = new AddMapImageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['version'] = this.version;
    data['image'] = this.image;
    return data;
  }
}

export interface IAddMapImageDto {
  version: number;
  image: string | undefined;
}

export class AddSingleImageDto implements IAddSingleImageDto {
  version!: number;
  imageType!: SingleImageType;
  image!: string | undefined;

  constructor(data?: IAddSingleImageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data['version'];
      this.imageType = _data['imageType'];
      this.image = _data['image'];
    }
  }

  static fromJS(data: any): AddSingleImageDto {
    data = typeof data === 'object' ? data : {};
    let result = new AddSingleImageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['version'] = this.version;
    data['imageType'] = this.imageType;
    data['image'] = this.image;
    return data;
  }
}

export interface IAddSingleImageDto {
  version: number;
  imageType: SingleImageType;
  image: string | undefined;
}

export class AirportItemDto implements IAirportItemDto {
  id!: number;
  iataCode!: string | undefined;
  icaoCode!: string | undefined;
  name!: string | undefined;

  constructor(data?: IAirportItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.iataCode = _data['iataCode'];
      this.icaoCode = _data['icaoCode'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): AirportItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new AirportItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['iataCode'] = this.iataCode;
    data['icaoCode'] = this.icaoCode;
    data['name'] = this.name;
    return data;
  }
}

export interface IAirportItemDto {
  id: number;
  iataCode: string | undefined;
  icaoCode: string | undefined;
  name: string | undefined;
}

export class AirportsDto implements IAirportsDto {
  iataCode!: string | undefined;
  namePT!: string | undefined;
  shortNamePT!: string | undefined;
  nameES!: string | undefined;
  shortNameES!: string | undefined;
  nameEN!: string | undefined;
  shortNameEN!: string | undefined;
  icaoCode!: string | undefined;
  timeZone!: string | undefined;
  latitude!: string | undefined;
  longitude!: string | undefined;
  countryCode!: string | undefined;
  macCode!: string | undefined;
  enabled!: boolean;
  operatedByGOL!: boolean;
  allowShopping!: boolean;
  allowOnlineCheckIn!: boolean;
  email!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IAirportsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.iataCode = _data['iataCode'];
      this.namePT = _data['namePT'];
      this.shortNamePT = _data['shortNamePT'];
      this.nameES = _data['nameES'];
      this.shortNameES = _data['shortNameES'];
      this.nameEN = _data['nameEN'];
      this.shortNameEN = _data['shortNameEN'];
      this.icaoCode = _data['icaoCode'];
      this.timeZone = _data['timeZone'];
      this.latitude = _data['latitude'];
      this.longitude = _data['longitude'];
      this.countryCode = _data['countryCode'];
      this.macCode = _data['macCode'];
      this.enabled = _data['enabled'];
      this.operatedByGOL = _data['operatedByGOL'];
      this.allowShopping = _data['allowShopping'];
      this.allowOnlineCheckIn = _data['allowOnlineCheckIn'];
      this.email = _data['email'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): AirportsDto {
    data = typeof data === 'object' ? data : {};
    let result = new AirportsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['iataCode'] = this.iataCode;
    data['namePT'] = this.namePT;
    data['shortNamePT'] = this.shortNamePT;
    data['nameES'] = this.nameES;
    data['shortNameES'] = this.shortNameES;
    data['nameEN'] = this.nameEN;
    data['shortNameEN'] = this.shortNameEN;
    data['icaoCode'] = this.icaoCode;
    data['timeZone'] = this.timeZone;
    data['latitude'] = this.latitude;
    data['longitude'] = this.longitude;
    data['countryCode'] = this.countryCode;
    data['macCode'] = this.macCode;
    data['enabled'] = this.enabled;
    data['operatedByGOL'] = this.operatedByGOL;
    data['allowShopping'] = this.allowShopping;
    data['allowOnlineCheckIn'] = this.allowOnlineCheckIn;
    data['email'] = this.email;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IAirportsDto {
  iataCode: string | undefined;
  namePT: string | undefined;
  shortNamePT: string | undefined;
  nameES: string | undefined;
  shortNameES: string | undefined;
  nameEN: string | undefined;
  shortNameEN: string | undefined;
  icaoCode: string | undefined;
  timeZone: string | undefined;
  latitude: string | undefined;
  longitude: string | undefined;
  countryCode: string | undefined;
  macCode: string | undefined;
  enabled: boolean;
  operatedByGOL: boolean;
  allowShopping: boolean;
  allowOnlineCheckIn: boolean;
  email: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class AlertDto implements IAlertDto {
  user!: User;
  userId!: number;
  registration!: string | undefined;
  alertDescription!: string | undefined;
  startValidate!: moment.Moment;
  endValidate!: moment.Moment;
  alertTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IAlertDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.registration = _data['registration'];
      this.alertDescription = _data['alertDescription'];
      this.startValidate = _data['startValidate'] ? moment(_data['startValidate'].toString()) : <any>undefined;
      this.endValidate = _data['endValidate'] ? moment(_data['endValidate'].toString()) : <any>undefined;
      this.alertTime = _data['alertTime'] ? moment(_data['alertTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): AlertDto {
    data = typeof data === 'object' ? data : {};
    let result = new AlertDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['registration'] = this.registration;
    data['alertDescription'] = this.alertDescription;
    data['startValidate'] = this.startValidate ? this.startValidate.toISOString() : <any>undefined;
    data['endValidate'] = this.endValidate ? this.endValidate.toISOString() : <any>undefined;
    data['alertTime'] = this.alertTime ? this.alertTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IAlertDto {
  user: User;
  userId: number;
  registration: string | undefined;
  alertDescription: string | undefined;
  startValidate: moment.Moment;
  endValidate: moment.Moment;
  alertTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class AlternateFlightDto implements IAlternateFlightDto {
  user!: User;
  userId!: number;
  flightDestiny!: string | undefined;
  firstAlternateDestiny!: string | undefined;
  secondAlternateDestiny!: string | undefined;
  thirdAlternateDestiny!: string | undefined;
  alternateSelection!: boolean;
  alternateFlightTime!: moment.Moment;
  alternateSelectionSupervision!: boolean;
  leaderDOVSupervision!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IAlternateFlightDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.flightDestiny = _data['flightDestiny'];
      this.firstAlternateDestiny = _data['firstAlternateDestiny'];
      this.secondAlternateDestiny = _data['secondAlternateDestiny'];
      this.thirdAlternateDestiny = _data['thirdAlternateDestiny'];
      this.alternateSelection = _data['alternateSelection'];
      this.alternateFlightTime = _data['alternateFlightTime'] ? moment(_data['alternateFlightTime'].toString()) : <any>undefined;
      this.alternateSelectionSupervision = _data['alternateSelectionSupervision'];
      this.leaderDOVSupervision = _data['leaderDOVSupervision'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): AlternateFlightDto {
    data = typeof data === 'object' ? data : {};
    let result = new AlternateFlightDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['flightDestiny'] = this.flightDestiny;
    data['firstAlternateDestiny'] = this.firstAlternateDestiny;
    data['secondAlternateDestiny'] = this.secondAlternateDestiny;
    data['thirdAlternateDestiny'] = this.thirdAlternateDestiny;
    data['alternateSelection'] = this.alternateSelection;
    data['alternateFlightTime'] = this.alternateFlightTime ? this.alternateFlightTime.toISOString() : <any>undefined;
    data['alternateSelectionSupervision'] = this.alternateSelectionSupervision;
    data['leaderDOVSupervision'] = this.leaderDOVSupervision;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IAlternateFlightDto {
  user: User;
  userId: number;
  flightDestiny: string | undefined;
  firstAlternateDestiny: string | undefined;
  secondAlternateDestiny: string | undefined;
  thirdAlternateDestiny: string | undefined;
  alternateSelection: boolean;
  alternateFlightTime: moment.Moment;
  alternateSelectionSupervision: boolean;
  leaderDOVSupervision: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum AlternateStatus {
  AlternateProhibited = 0,
  ReleasedAlternate = 1,
  AlternateProhibitedSupervision = 2,
  AlternateProhibitedDouble = 3,
}

export enum AlternateType {
  Metar = 0,
  Taf = 1,
}

export class ApplicationInfoDto implements IApplicationInfoDto {
  currency!: string | undefined;
  currencySign!: string | undefined;
  features!: { [key: string]: boolean } | undefined;
  releaseDate!: moment.Moment;
  twoFactorCodeExpireSeconds!: number;
  version!: string | undefined;

  constructor(data?: IApplicationInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currency = _data['currency'];
      this.currencySign = _data['currencySign'];
      if (_data['features']) {
        this.features = {} as any;
        for (let key in _data['features']) {
          if (_data['features'].hasOwnProperty(key)) (<any>this.features)![key] = _data['features'][key];
        }
      }
      this.releaseDate = _data['releaseDate'] ? moment(_data['releaseDate'].toString()) : <any>undefined;
      this.twoFactorCodeExpireSeconds = _data['twoFactorCodeExpireSeconds'];
      this.version = _data['version'];
    }
  }

  static fromJS(data: any): ApplicationInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currency'] = this.currency;
    data['currencySign'] = this.currencySign;
    if (this.features) {
      data['features'] = {};
      for (let key in this.features) {
        if (this.features.hasOwnProperty(key)) (<any>data['features'])[key] = (<any>this.features)[key];
      }
    }
    data['releaseDate'] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
    data['twoFactorCodeExpireSeconds'] = this.twoFactorCodeExpireSeconds;
    data['version'] = this.version;
    return data;
  }
}

export interface IApplicationInfoDto {
  currency: string | undefined;
  currencySign: string | undefined;
  features: { [key: string]: boolean } | undefined;
  releaseDate: moment.Moment;
  twoFactorCodeExpireSeconds: number;
  version: string | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
  icon!: string | undefined;
  id!: number | undefined;
  isEnabled!: boolean;
  name!: string;

  constructor(data?: IApplicationLanguageEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.icon = _data['icon'];
      this.id = _data['id'];
      this.isEnabled = _data['isEnabled'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): ApplicationLanguageEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationLanguageEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['icon'] = this.icon;
    data['id'] = this.id;
    data['isEnabled'] = this.isEnabled;
    data['name'] = this.name;
    return data;
  }
}

export interface IApplicationLanguageEditDto {
  icon: string | undefined;
  id: number | undefined;
  isEnabled: boolean;
  name: string;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
  displayName!: string | undefined;
  icon!: string | undefined;
  isDisabled!: boolean;
  readonly lastModificationDate!: moment.Moment;
  name!: string | undefined;
  tenantId!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IApplicationLanguageListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data['displayName'];
      this.icon = _data['icon'];
      this.isDisabled = _data['isDisabled'];
      (<any>this).lastModificationDate = _data['lastModificationDate'] ? moment(_data['lastModificationDate'].toString()) : <any>undefined;
      this.name = _data['name'];
      this.tenantId = _data['tenantId'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ApplicationLanguageListDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationLanguageListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayName'] = this.displayName;
    data['icon'] = this.icon;
    data['isDisabled'] = this.isDisabled;
    data['lastModificationDate'] = this.lastModificationDate ? this.lastModificationDate.toISOString() : <any>undefined;
    data['name'] = this.name;
    data['tenantId'] = this.tenantId;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IApplicationLanguageListDto {
  displayName: string | undefined;
  icon: string | undefined;
  isDisabled: boolean;
  lastModificationDate: moment.Moment;
  name: string | undefined;
  tenantId: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class ArticleDto implements IArticleDto {
  title!: string | undefined;
  content!: string | undefined;
  preview!: string | undefined;
  tags!: string | undefined;
  referenceManual!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IArticleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.content = _data['content'];
      this.preview = _data['preview'];
      this.tags = _data['tags'];
      this.referenceManual = _data['referenceManual'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ArticleDto {
    data = typeof data === 'object' ? data : {};
    let result = new ArticleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['content'] = this.content;
    data['preview'] = this.preview;
    data['tags'] = this.tags;
    data['referenceManual'] = this.referenceManual;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IArticleDto {
  title: string | undefined;
  content: string | undefined;
  preview: string | undefined;
  tags: string | undefined;
  referenceManual: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class AuditLogListDto implements IAuditLogListDto {
  browserInfo!: string | undefined;
  clientIpAddress!: string | undefined;
  clientName!: string | undefined;
  customData!: string | undefined;
  exception!: string | undefined;
  executionDuration!: number;
  executionTime!: moment.Moment;
  impersonatorTenantId!: number | undefined;
  impersonatorUserId!: number | undefined;
  methodName!: string | undefined;
  parameters!: string | undefined;
  serviceName!: string | undefined;
  userId!: number | undefined;
  userName!: string | undefined;
  id!: number;

  constructor(data?: IAuditLogListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.browserInfo = _data['browserInfo'];
      this.clientIpAddress = _data['clientIpAddress'];
      this.clientName = _data['clientName'];
      this.customData = _data['customData'];
      this.exception = _data['exception'];
      this.executionDuration = _data['executionDuration'];
      this.executionTime = _data['executionTime'] ? moment(_data['executionTime'].toString()) : <any>undefined;
      this.impersonatorTenantId = _data['impersonatorTenantId'];
      this.impersonatorUserId = _data['impersonatorUserId'];
      this.methodName = _data['methodName'];
      this.parameters = _data['parameters'];
      this.serviceName = _data['serviceName'];
      this.userId = _data['userId'];
      this.userName = _data['userName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): AuditLogListDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditLogListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['browserInfo'] = this.browserInfo;
    data['clientIpAddress'] = this.clientIpAddress;
    data['clientName'] = this.clientName;
    data['customData'] = this.customData;
    data['exception'] = this.exception;
    data['executionDuration'] = this.executionDuration;
    data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
    data['impersonatorTenantId'] = this.impersonatorTenantId;
    data['impersonatorUserId'] = this.impersonatorUserId;
    data['methodName'] = this.methodName;
    data['parameters'] = this.parameters;
    data['serviceName'] = this.serviceName;
    data['userId'] = this.userId;
    data['userName'] = this.userName;
    data['id'] = this.id;
    return data;
  }
}

export interface IAuditLogListDto {
  browserInfo: string | undefined;
  clientIpAddress: string | undefined;
  clientName: string | undefined;
  customData: string | undefined;
  exception: string | undefined;
  executionDuration: number;
  executionTime: moment.Moment;
  impersonatorTenantId: number | undefined;
  impersonatorUserId: number | undefined;
  methodName: string | undefined;
  parameters: string | undefined;
  serviceName: string | undefined;
  userId: number | undefined;
  userName: string | undefined;
  id: number;
}

export class AuthZeroExternalLoginProviderSettings implements IAuthZeroExternalLoginProviderSettings {
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  endpoint!: string | undefined;

  constructor(data?: IAuthZeroExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientSecret = _data['clientSecret'];
      this.endpoint = _data['endpoint'];
    }
  }

  static fromJS(data: any): AuthZeroExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new AuthZeroExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientSecret'] = this.clientSecret;
    data['endpoint'] = this.endpoint;
    return data;
  }
}

export interface IAuthZeroExternalLoginProviderSettings {
  clientId: string | undefined;
  clientSecret: string | undefined;
  endpoint: string | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
  captchaResponse!: string | undefined;
  password!: string;
  rememberClient!: boolean;
  returnUrl!: string | undefined;
  singleSignIn!: boolean | undefined;
  twoFactorRememberClientToken!: string | undefined;
  twoFactorVerificationCode!: string | undefined;
  userNameOrEmailAddress!: string;

  constructor(data?: IAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.captchaResponse = _data['captchaResponse'];
      this.password = _data['password'];
      this.rememberClient = _data['rememberClient'];
      this.returnUrl = _data['returnUrl'];
      this.singleSignIn = _data['singleSignIn'];
      this.twoFactorRememberClientToken = _data['twoFactorRememberClientToken'];
      this.twoFactorVerificationCode = _data['twoFactorVerificationCode'];
      this.userNameOrEmailAddress = _data['userNameOrEmailAddress'];
    }
  }

  static fromJS(data: any): AuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new AuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['captchaResponse'] = this.captchaResponse;
    data['password'] = this.password;
    data['rememberClient'] = this.rememberClient;
    data['returnUrl'] = this.returnUrl;
    data['singleSignIn'] = this.singleSignIn;
    data['twoFactorRememberClientToken'] = this.twoFactorRememberClientToken;
    data['twoFactorVerificationCode'] = this.twoFactorVerificationCode;
    data['userNameOrEmailAddress'] = this.userNameOrEmailAddress;
    return data;
  }
}

export interface IAuthenticateModel {
  captchaResponse: string | undefined;
  password: string;
  rememberClient: boolean;
  returnUrl: string | undefined;
  singleSignIn: boolean | undefined;
  twoFactorRememberClientToken: string | undefined;
  twoFactorVerificationCode: string | undefined;
  userNameOrEmailAddress: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  passwordResetCode!: string | undefined;
  requiresTwoFactorVerification!: boolean;
  returnUrl!: string | undefined;
  shouldResetPassword!: boolean;
  twoFactorAuthProviders!: string[] | undefined;
  twoFactorRememberClientToken!: string | undefined;
  userId!: number;

  constructor(data?: IAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data['accessToken'];
      this.encryptedAccessToken = _data['encryptedAccessToken'];
      this.expireInSeconds = _data['expireInSeconds'];
      this.passwordResetCode = _data['passwordResetCode'];
      this.requiresTwoFactorVerification = _data['requiresTwoFactorVerification'];
      this.returnUrl = _data['returnUrl'];
      this.shouldResetPassword = _data['shouldResetPassword'];
      if (Array.isArray(_data['twoFactorAuthProviders'])) {
        this.twoFactorAuthProviders = [] as any;
        for (let item of _data['twoFactorAuthProviders']) this.twoFactorAuthProviders!.push(item);
      }
      this.twoFactorRememberClientToken = _data['twoFactorRememberClientToken'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): AuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new AuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['accessToken'] = this.accessToken;
    data['encryptedAccessToken'] = this.encryptedAccessToken;
    data['expireInSeconds'] = this.expireInSeconds;
    data['passwordResetCode'] = this.passwordResetCode;
    data['requiresTwoFactorVerification'] = this.requiresTwoFactorVerification;
    data['returnUrl'] = this.returnUrl;
    data['shouldResetPassword'] = this.shouldResetPassword;
    if (Array.isArray(this.twoFactorAuthProviders)) {
      data['twoFactorAuthProviders'] = [];
      for (let item of this.twoFactorAuthProviders) data['twoFactorAuthProviders'].push(item);
    }
    data['twoFactorRememberClientToken'] = this.twoFactorRememberClientToken;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  passwordResetCode: string | undefined;
  requiresTwoFactorVerification: boolean;
  returnUrl: string | undefined;
  shouldResetPassword: boolean;
  twoFactorAuthProviders: string[] | undefined;
  twoFactorRememberClientToken: string | undefined;
  userId: number;
}

export class AzureActiveDirectorySettingsEditDto implements IAzureActiveDirectorySettingsEditDto {
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  isEnabled!: boolean;
  isModuleEnabled!: boolean;
  tenant!: string | undefined;

  constructor(data?: IAzureActiveDirectorySettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientSecret = _data['clientSecret'];
      this.isEnabled = _data['isEnabled'];
      this.isModuleEnabled = _data['isModuleEnabled'];
      this.tenant = _data['tenant'];
    }
  }

  static fromJS(data: any): AzureActiveDirectorySettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new AzureActiveDirectorySettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientSecret'] = this.clientSecret;
    data['isEnabled'] = this.isEnabled;
    data['isModuleEnabled'] = this.isModuleEnabled;
    data['tenant'] = this.tenant;
    return data;
  }
}

export interface IAzureActiveDirectorySettingsEditDto {
  clientId: string | undefined;
  clientSecret: string | undefined;
  isEnabled: boolean;
  isModuleEnabled: boolean;
  tenant: string | undefined;
}

export class BlockUserInput implements IBlockUserInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IBlockUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): BlockUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new BlockUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IBlockUserInput {
  tenantId: number | undefined;
  userId: number;
}

export class BriefingAirportDto implements IBriefingAirportDto {
  user!: User;
  userId!: number;
  flightDestiny!: string | undefined;
  firstAlternateDestiny!: string | undefined;
  secondAlternateDestiny!: string | undefined;
  thirdAlternateDestiny!: string | undefined;
  fourthAlternateDestiny!: string | undefined;
  fifthAlternateDestiny!: string | undefined;
  sixthAlternateDestiny!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IBriefingAirportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.flightDestiny = _data['flightDestiny'];
      this.firstAlternateDestiny = _data['firstAlternateDestiny'];
      this.secondAlternateDestiny = _data['secondAlternateDestiny'];
      this.thirdAlternateDestiny = _data['thirdAlternateDestiny'];
      this.fourthAlternateDestiny = _data['fourthAlternateDestiny'];
      this.fifthAlternateDestiny = _data['fifthAlternateDestiny'];
      this.sixthAlternateDestiny = _data['sixthAlternateDestiny'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): BriefingAirportDto {
    data = typeof data === 'object' ? data : {};
    let result = new BriefingAirportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['flightDestiny'] = this.flightDestiny;
    data['firstAlternateDestiny'] = this.firstAlternateDestiny;
    data['secondAlternateDestiny'] = this.secondAlternateDestiny;
    data['thirdAlternateDestiny'] = this.thirdAlternateDestiny;
    data['fourthAlternateDestiny'] = this.fourthAlternateDestiny;
    data['fifthAlternateDestiny'] = this.fifthAlternateDestiny;
    data['sixthAlternateDestiny'] = this.sixthAlternateDestiny;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IBriefingAirportDto {
  user: User;
  userId: number;
  flightDestiny: string | undefined;
  firstAlternateDestiny: string | undefined;
  secondAlternateDestiny: string | undefined;
  thirdAlternateDestiny: string | undefined;
  fourthAlternateDestiny: string | undefined;
  fifthAlternateDestiny: string | undefined;
  sixthAlternateDestiny: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class BriefingDto implements IBriefingDto {
  regions!: string | undefined;
  version!: number;
  melImage!: string | undefined;
  tacticalImage!: string | undefined;
  trackImage!: string | undefined;
  letterImage!: string | undefined;
  sateleteImage!: string | undefined;
  letterUpdate!: moment.Moment;
  updatedTime!: moment.Moment;
  warnings!: string | undefined;
  mapImages!: string[] | undefined;

  constructor(data?: IBriefingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.regions = _data['regions'];
      this.version = _data['version'];
      this.melImage = _data['melImage'];
      this.tacticalImage = _data['tacticalImage'];
      this.trackImage = _data['trackImage'];
      this.letterImage = _data['letterImage'];
      this.sateleteImage = _data['sateleteImage'];
      this.letterUpdate = _data['letterUpdate'] ? moment(_data['letterUpdate'].toString()) : <any>undefined;
      this.updatedTime = _data['updatedTime'] ? moment(_data['updatedTime'].toString()) : <any>undefined;
      this.warnings = _data['warnings'];
      if (Array.isArray(_data['mapImages'])) {
        this.mapImages = [] as any;
        for (let item of _data['mapImages']) this.mapImages!.push(item);
      }
    }
  }

  static fromJS(data: any): BriefingDto {
    data = typeof data === 'object' ? data : {};
    let result = new BriefingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['regions'] = this.regions;
    data['version'] = this.version;
    data['melImage'] = this.melImage;
    data['tacticalImage'] = this.tacticalImage;
    data['trackImage'] = this.trackImage;
    data['letterImage'] = this.letterImage;
    data['sateleteImage'] = this.sateleteImage;
    data['letterUpdate'] = this.letterUpdate ? this.letterUpdate.toISOString() : <any>undefined;
    data['updatedTime'] = this.updatedTime ? this.updatedTime.toISOString() : <any>undefined;
    data['warnings'] = this.warnings;
    if (Array.isArray(this.mapImages)) {
      data['mapImages'] = [];
      for (let item of this.mapImages) data['mapImages'].push(item);
    }
    return data;
  }
}

export interface IBriefingDto {
  regions: string | undefined;
  version: number;
  melImage: string | undefined;
  tacticalImage: string | undefined;
  trackImage: string | undefined;
  letterImage: string | undefined;
  sateleteImage: string | undefined;
  letterUpdate: moment.Moment;
  updatedTime: moment.Moment;
  warnings: string | undefined;
  mapImages: string[] | undefined;
}

export class BriefingGolAlternateDto implements IBriefingGolAlternateDto {
  briefingGolId!: number;
  destiny!: string | undefined;
  time!: string | undefined;
  status!: AlternateStatus;
  type!: AlternateType;
  wind!: string | undefined;
  visibility!: string | undefined;
  roof!: string | undefined;
  meteorologicalEvents!: string | undefined;
  leaderDOVSupervision!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IBriefingGolAlternateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.briefingGolId = _data['briefingGolId'];
      this.destiny = _data['destiny'];
      this.time = _data['time'];
      this.status = _data['status'];
      this.type = _data['type'];
      this.wind = _data['wind'];
      this.visibility = _data['visibility'];
      this.roof = _data['roof'];
      this.meteorologicalEvents = _data['meteorologicalEvents'];
      this.leaderDOVSupervision = _data['leaderDOVSupervision'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): BriefingGolAlternateDto {
    data = typeof data === 'object' ? data : {};
    let result = new BriefingGolAlternateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['briefingGolId'] = this.briefingGolId;
    data['destiny'] = this.destiny;
    data['time'] = this.time;
    data['status'] = this.status;
    data['type'] = this.type;
    data['wind'] = this.wind;
    data['visibility'] = this.visibility;
    data['roof'] = this.roof;
    data['meteorologicalEvents'] = this.meteorologicalEvents;
    data['leaderDOVSupervision'] = this.leaderDOVSupervision;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IBriefingGolAlternateDto {
  briefingGolId: number;
  destiny: string | undefined;
  time: string | undefined;
  status: AlternateStatus;
  type: AlternateType;
  wind: string | undefined;
  visibility: string | undefined;
  roof: string | undefined;
  meteorologicalEvents: string | undefined;
  leaderDOVSupervision: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class BriefingGolDto implements IBriefingGolDto {
  flightDate!: moment.Moment;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  prefix!: string | undefined;
  costIndex!: string | undefined;
  probability!: string | undefined;
  importantAlert!: string | undefined;
  remFuel!: string | undefined;
  commander!: CommanderDto;
  commanderId!: number | undefined;
  briefingGolAlternates!: BriefingGolAlternateDto[] | undefined;
  listAbaBriefing!: AbaBriefing[] | undefined;
  listAbaNotam!: AbaNotam[] | undefined;
  listAbaNotamSupl!: AbaNotamSupl[] | undefined;
  suplemNotamText!: string | undefined;
  listAbaExtraFual!: AbaExtraFual[] | undefined;
  listAbaMinimumsDEP!: CompleteObjectMinimumDto[] | undefined;
  listAbaMinimumsARR!: CompleteObjectMinimumDto[] | undefined;
  listAbaAlternate!: AbaAlternate[] | undefined;
  feedback!: FeedbackType;
  justificativa!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IBriefingGolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.flightDate = _data['flightDate'] ? moment(_data['flightDate'].toString()) : <any>undefined;
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.prefix = _data['prefix'];
      this.costIndex = _data['costIndex'];
      this.probability = _data['probability'];
      this.importantAlert = _data['importantAlert'];
      this.remFuel = _data['remFuel'];
      this.commander = _data['commander'] ? CommanderDto.fromJS(_data['commander']) : <any>undefined;
      this.commanderId = _data['commanderId'];
      if (Array.isArray(_data['briefingGolAlternates'])) {
        this.briefingGolAlternates = [] as any;
        for (let item of _data['briefingGolAlternates']) this.briefingGolAlternates!.push(BriefingGolAlternateDto.fromJS(item));
      }
      if (Array.isArray(_data['listAbaBriefing'])) {
        this.listAbaBriefing = [] as any;
        for (let item of _data['listAbaBriefing']) this.listAbaBriefing!.push(AbaBriefing.fromJS(item));
      }
      if (Array.isArray(_data['listAbaNotam'])) {
        this.listAbaNotam = [] as any;
        for (let item of _data['listAbaNotam']) this.listAbaNotam!.push(AbaNotam.fromJS(item));
      }
      if (Array.isArray(_data['listAbaNotamSupl'])) {
        this.listAbaNotamSupl = [] as any;
        for (let item of _data['listAbaNotamSupl']) this.listAbaNotamSupl!.push(AbaNotamSupl.fromJS(item));
      }
      this.suplemNotamText = _data['suplemNotamText'];
      if (Array.isArray(_data['listAbaExtraFual'])) {
        this.listAbaExtraFual = [] as any;
        for (let item of _data['listAbaExtraFual']) this.listAbaExtraFual!.push(AbaExtraFual.fromJS(item));
      }
      if (Array.isArray(_data['listAbaMinimumsDEP'])) {
        this.listAbaMinimumsDEP = [] as any;
        for (let item of _data['listAbaMinimumsDEP']) this.listAbaMinimumsDEP!.push(CompleteObjectMinimumDto.fromJS(item));
      }
      if (Array.isArray(_data['listAbaMinimumsARR'])) {
        this.listAbaMinimumsARR = [] as any;
        for (let item of _data['listAbaMinimumsARR']) this.listAbaMinimumsARR!.push(CompleteObjectMinimumDto.fromJS(item));
      }
      if (Array.isArray(_data['listAbaAlternate'])) {
        this.listAbaAlternate = [] as any;
        for (let item of _data['listAbaAlternate']) this.listAbaAlternate!.push(AbaAlternate.fromJS(item));
      }
      this.feedback = _data['feedback'];
      this.justificativa = _data['justificativa'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): BriefingGolDto {
    data = typeof data === 'object' ? data : {};
    let result = new BriefingGolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['flightDate'] = this.flightDate ? this.flightDate.toISOString() : <any>undefined;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['prefix'] = this.prefix;
    data['costIndex'] = this.costIndex;
    data['probability'] = this.probability;
    data['importantAlert'] = this.importantAlert;
    data['remFuel'] = this.remFuel;
    data['commander'] = this.commander ? this.commander.toJSON() : <any>undefined;
    data['commanderId'] = this.commanderId;
    if (Array.isArray(this.briefingGolAlternates)) {
      data['briefingGolAlternates'] = [];
      for (let item of this.briefingGolAlternates) data['briefingGolAlternates'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaBriefing)) {
      data['listAbaBriefing'] = [];
      for (let item of this.listAbaBriefing) data['listAbaBriefing'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaNotam)) {
      data['listAbaNotam'] = [];
      for (let item of this.listAbaNotam) data['listAbaNotam'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaNotamSupl)) {
      data['listAbaNotamSupl'] = [];
      for (let item of this.listAbaNotamSupl) data['listAbaNotamSupl'].push(item.toJSON());
    }
    data['suplemNotamText'] = this.suplemNotamText;
    if (Array.isArray(this.listAbaExtraFual)) {
      data['listAbaExtraFual'] = [];
      for (let item of this.listAbaExtraFual) data['listAbaExtraFual'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaMinimumsDEP)) {
      data['listAbaMinimumsDEP'] = [];
      for (let item of this.listAbaMinimumsDEP) data['listAbaMinimumsDEP'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaMinimumsARR)) {
      data['listAbaMinimumsARR'] = [];
      for (let item of this.listAbaMinimumsARR) data['listAbaMinimumsARR'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaAlternate)) {
      data['listAbaAlternate'] = [];
      for (let item of this.listAbaAlternate) data['listAbaAlternate'].push(item.toJSON());
    }
    data['feedback'] = this.feedback;
    data['justificativa'] = this.justificativa;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IBriefingGolDto {
  flightDate: moment.Moment;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  prefix: string | undefined;
  costIndex: string | undefined;
  probability: string | undefined;
  importantAlert: string | undefined;
  remFuel: string | undefined;
  commander: CommanderDto;
  commanderId: number | undefined;
  briefingGolAlternates: BriefingGolAlternateDto[] | undefined;
  listAbaBriefing: AbaBriefing[] | undefined;
  listAbaNotam: AbaNotam[] | undefined;
  listAbaNotamSupl: AbaNotamSupl[] | undefined;
  suplemNotamText: string | undefined;
  listAbaExtraFual: AbaExtraFual[] | undefined;
  listAbaMinimumsDEP: CompleteObjectMinimumDto[] | undefined;
  listAbaMinimumsARR: CompleteObjectMinimumDto[] | undefined;
  listAbaAlternate: AbaAlternate[] | undefined;
  feedback: FeedbackType;
  justificativa: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class BriefingGolSuplemNotamDto implements IBriefingGolSuplemNotamDto {
  briefingGolId!: number | undefined;
  flightDate!: moment.Moment;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  suplemNotamText!: string | undefined;
  suplemNotamPDF!: SuplemNotamType;
  attempt!: number;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IBriefingGolSuplemNotamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.briefingGolId = _data['briefingGolId'];
      this.flightDate = _data['flightDate'] ? moment(_data['flightDate'].toString()) : <any>undefined;
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.suplemNotamText = _data['suplemNotamText'];
      this.suplemNotamPDF = _data['suplemNotamPDF'];
      this.attempt = _data['attempt'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): BriefingGolSuplemNotamDto {
    data = typeof data === 'object' ? data : {};
    let result = new BriefingGolSuplemNotamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['briefingGolId'] = this.briefingGolId;
    data['flightDate'] = this.flightDate ? this.flightDate.toISOString() : <any>undefined;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['suplemNotamText'] = this.suplemNotamText;
    data['suplemNotamPDF'] = this.suplemNotamPDF;
    data['attempt'] = this.attempt;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IBriefingGolSuplemNotamDto {
  briefingGolId: number | undefined;
  flightDate: moment.Moment;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  suplemNotamText: string | undefined;
  suplemNotamPDF: SuplemNotamType;
  attempt: number;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CacheDto implements ICacheDto {
  name!: string | undefined;

  constructor(data?: ICacheDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): CacheDto {
    data = typeof data === 'object' ? data : {};
    let result = new CacheDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface ICacheDto {
  name: string | undefined;
}

export class CalendarEventDto implements ICalendarEventDto {
  start!: moment.Moment;
  end!: moment.Moment | undefined;
  title!: string | undefined;
  allDay!: boolean | undefined;
  draggable!: boolean | undefined;
  cssClass!: string | undefined;
  id!: number;

  constructor(data?: ICalendarEventDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.start = _data['start'] ? moment(_data['start'].toString()) : <any>undefined;
      this.end = _data['end'] ? moment(_data['end'].toString()) : <any>undefined;
      this.title = _data['title'];
      this.allDay = _data['allDay'];
      this.draggable = _data['draggable'];
      this.cssClass = _data['cssClass'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CalendarEventDto {
    data = typeof data === 'object' ? data : {};
    let result = new CalendarEventDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['start'] = this.start ? this.start.toISOString() : <any>undefined;
    data['end'] = this.end ? this.end.toISOString() : <any>undefined;
    data['title'] = this.title;
    data['allDay'] = this.allDay;
    data['draggable'] = this.draggable;
    data['cssClass'] = this.cssClass;
    data['id'] = this.id;
    return data;
  }
}

export interface ICalendarEventDto {
  start: moment.Moment;
  end: moment.Moment | undefined;
  title: string | undefined;
  allDay: boolean | undefined;
  draggable: boolean | undefined;
  cssClass: string | undefined;
  id: number;
}

export class ChangePasswordInput implements IChangePasswordInput {
  currentPassword!: string;
  newPassword!: string;

  constructor(data?: IChangePasswordInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data['currentPassword'];
      this.newPassword = _data['newPassword'];
    }
  }

  static fromJS(data: any): ChangePasswordInput {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPassword'] = this.currentPassword;
    data['newPassword'] = this.newPassword;
    return data;
  }
}

export interface IChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
  languageName!: string;

  constructor(data?: IChangeUserLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.languageName = _data['languageName'];
    }
  }

  static fromJS(data: any): ChangeUserLanguageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChangeUserLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['languageName'] = this.languageName;
    return data;
  }
}

export interface IChangeUserLanguageDto {
  languageName: string;
}

export class ChatMessageDto implements IChatMessageDto {
  creationTime!: moment.Moment;
  message!: string | undefined;
  readState!: ChatMessageReadState;
  receiverReadState!: ChatMessageReadState;
  sharedMessageId!: string | undefined;
  side!: ChatSide;
  targetTenantId!: number | undefined;
  targetUserId!: number;
  targetUserName!: string | undefined;
  tenantId!: number | undefined;
  userId!: number;
  id!: number;

  constructor(data?: IChatMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.message = _data['message'];
      this.readState = _data['readState'];
      this.receiverReadState = _data['receiverReadState'];
      this.sharedMessageId = _data['sharedMessageId'];
      this.side = _data['side'];
      this.targetTenantId = _data['targetTenantId'];
      this.targetUserId = _data['targetUserId'];
      this.targetUserName = _data['targetUserName'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ChatMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ChatMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['message'] = this.message;
    data['readState'] = this.readState;
    data['receiverReadState'] = this.receiverReadState;
    data['sharedMessageId'] = this.sharedMessageId;
    data['side'] = this.side;
    data['targetTenantId'] = this.targetTenantId;
    data['targetUserId'] = this.targetUserId;
    data['targetUserName'] = this.targetUserName;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['id'] = this.id;
    return data;
  }
}

export interface IChatMessageDto {
  creationTime: moment.Moment;
  message: string | undefined;
  readState: ChatMessageReadState;
  receiverReadState: ChatMessageReadState;
  sharedMessageId: string | undefined;
  side: ChatSide;
  targetTenantId: number | undefined;
  targetUserId: number;
  targetUserName: string | undefined;
  tenantId: number | undefined;
  userId: number;
  id: number;
}

export enum ChatMessageReadState {
  Unread = 1,
  Read = 2,
}

export enum ChatSide {
  Sender = 1,
  Receiver = 2,
}

export class CityPairDto implements ICityPairDto {
  user!: User;
  userId!: number;
  arrival!: string | undefined;
  departure!: string | undefined;
  fir1!: string | undefined;
  fir2!: string | undefined;
  fir3!: string | undefined;
  fir4!: string | undefined;
  fir5!: string | undefined;
  fir6!: string | undefined;
  fir7!: string | undefined;
  fir8!: string | undefined;
  fir9!: string | undefined;
  fir10!: string | undefined;
  fir11!: string | undefined;
  fir12!: string | undefined;
  fir13!: string | undefined;
  fir14!: string | undefined;
  fir15!: string | undefined;
  fir16!: string | undefined;
  fir17!: string | undefined;
  fir18!: string | undefined;
  fir19!: string | undefined;
  fir20!: string | undefined;
  fir21!: string | undefined;
  fir22!: string | undefined;
  fir23!: string | undefined;
  fir24!: string | undefined;
  fir25!: string | undefined;
  cityPairTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICityPairDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.arrival = _data['arrival'];
      this.departure = _data['departure'];
      this.fir1 = _data['fir1'];
      this.fir2 = _data['fir2'];
      this.fir3 = _data['fir3'];
      this.fir4 = _data['fir4'];
      this.fir5 = _data['fir5'];
      this.fir6 = _data['fir6'];
      this.fir7 = _data['fir7'];
      this.fir8 = _data['fir8'];
      this.fir9 = _data['fir9'];
      this.fir10 = _data['fir10'];
      this.fir11 = _data['fir11'];
      this.fir12 = _data['fir12'];
      this.fir13 = _data['fir13'];
      this.fir14 = _data['fir14'];
      this.fir15 = _data['fir15'];
      this.fir16 = _data['fir16'];
      this.fir17 = _data['fir17'];
      this.fir18 = _data['fir18'];
      this.fir19 = _data['fir19'];
      this.fir20 = _data['fir20'];
      this.fir21 = _data['fir21'];
      this.fir22 = _data['fir22'];
      this.fir23 = _data['fir23'];
      this.fir24 = _data['fir24'];
      this.fir25 = _data['fir25'];
      this.cityPairTime = _data['cityPairTime'] ? moment(_data['cityPairTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CityPairDto {
    data = typeof data === 'object' ? data : {};
    let result = new CityPairDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['arrival'] = this.arrival;
    data['departure'] = this.departure;
    data['fir1'] = this.fir1;
    data['fir2'] = this.fir2;
    data['fir3'] = this.fir3;
    data['fir4'] = this.fir4;
    data['fir5'] = this.fir5;
    data['fir6'] = this.fir6;
    data['fir7'] = this.fir7;
    data['fir8'] = this.fir8;
    data['fir9'] = this.fir9;
    data['fir10'] = this.fir10;
    data['fir11'] = this.fir11;
    data['fir12'] = this.fir12;
    data['fir13'] = this.fir13;
    data['fir14'] = this.fir14;
    data['fir15'] = this.fir15;
    data['fir16'] = this.fir16;
    data['fir17'] = this.fir17;
    data['fir18'] = this.fir18;
    data['fir19'] = this.fir19;
    data['fir20'] = this.fir20;
    data['fir21'] = this.fir21;
    data['fir22'] = this.fir22;
    data['fir23'] = this.fir23;
    data['fir24'] = this.fir24;
    data['fir25'] = this.fir25;
    data['cityPairTime'] = this.cityPairTime ? this.cityPairTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICityPairDto {
  user: User;
  userId: number;
  arrival: string | undefined;
  departure: string | undefined;
  fir1: string | undefined;
  fir2: string | undefined;
  fir3: string | undefined;
  fir4: string | undefined;
  fir5: string | undefined;
  fir6: string | undefined;
  fir7: string | undefined;
  fir8: string | undefined;
  fir9: string | undefined;
  fir10: string | undefined;
  fir11: string | undefined;
  fir12: string | undefined;
  fir13: string | undefined;
  fir14: string | undefined;
  fir15: string | undefined;
  fir16: string | undefined;
  fir17: string | undefined;
  fir18: string | undefined;
  fir19: string | undefined;
  fir20: string | undefined;
  fir21: string | undefined;
  fir22: string | undefined;
  fir23: string | undefined;
  fir24: string | undefined;
  fir25: string | undefined;
  cityPairTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class ComboboxItemDto implements IComboboxItemDto {
  displayText!: string | undefined;
  isSelected!: boolean;
  value!: string | undefined;

  constructor(data?: IComboboxItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayText = _data['displayText'];
      this.isSelected = _data['isSelected'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): ComboboxItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ComboboxItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayText'] = this.displayText;
    data['isSelected'] = this.isSelected;
    data['value'] = this.value;
    return data;
  }
}

export interface IComboboxItemDto {
  displayText: string | undefined;
  isSelected: boolean;
  value: string | undefined;
}

export class Commander implements ICommander {
  name!: string | undefined;
  cif!: string | undefined;
  occurrences!: Occurrence[] | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICommander) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.cif = _data['cif'];
      if (Array.isArray(_data['occurrences'])) {
        this.occurrences = [] as any;
        for (let item of _data['occurrences']) this.occurrences!.push(Occurrence.fromJS(item));
      }
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): Commander {
    data = typeof data === 'object' ? data : {};
    let result = new Commander();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['cif'] = this.cif;
    if (Array.isArray(this.occurrences)) {
      data['occurrences'] = [];
      for (let item of this.occurrences) data['occurrences'].push(item.toJSON());
    }
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICommander {
  name: string | undefined;
  cif: string | undefined;
  occurrences: Occurrence[] | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CommanderDto implements ICommanderDto {
  name!: string | undefined;
  cif!: string | undefined;
  codAnac!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICommanderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.cif = _data['cif'];
      this.codAnac = _data['codAnac'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CommanderDto {
    data = typeof data === 'object' ? data : {};
    let result = new CommanderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['cif'] = this.cif;
    data['codAnac'] = this.codAnac;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICommanderDto {
  name: string | undefined;
  cif: string | undefined;
  codAnac: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CompleteObjectMinimumDto implements ICompleteObjectMinimumDto {
  minimum!: MinimumsDto;
  minimumsItems!: MinimumsItemDto[] | undefined;

  constructor(data?: ICompleteObjectMinimumDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.minimum = _data['minimum'] ? MinimumsDto.fromJS(_data['minimum']) : <any>undefined;
      if (Array.isArray(_data['minimumsItems'])) {
        this.minimumsItems = [] as any;
        for (let item of _data['minimumsItems']) this.minimumsItems!.push(MinimumsItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CompleteObjectMinimumDto {
    data = typeof data === 'object' ? data : {};
    let result = new CompleteObjectMinimumDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['minimum'] = this.minimum ? this.minimum.toJSON() : <any>undefined;
    if (Array.isArray(this.minimumsItems)) {
      data['minimumsItems'] = [];
      for (let item of this.minimumsItems) data['minimumsItems'].push(item.toJSON());
    }
    return data;
  }
}

export interface ICompleteObjectMinimumDto {
  minimum: MinimumsDto;
  minimumsItems: MinimumsItemDto[] | undefined;
}

export class ContactDto implements IContactDto {
  name!: string | undefined;
  primaryPhone!: number;
  secondaryPhone!: number | undefined;
  email!: string | undefined;
  company!: string | undefined;
  createdBy!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.primaryPhone = _data['primaryPhone'];
      this.secondaryPhone = _data['secondaryPhone'];
      this.email = _data['email'];
      this.company = _data['company'];
      this.createdBy = _data['createdBy'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ContactDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['primaryPhone'] = this.primaryPhone;
    data['secondaryPhone'] = this.secondaryPhone;
    data['email'] = this.email;
    data['company'] = this.company;
    data['createdBy'] = this.createdBy;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IContactDto {
  name: string | undefined;
  primaryPhone: number;
  secondaryPhone: number | undefined;
  email: string | undefined;
  company: string | undefined;
  createdBy: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class ContinuousImprovementDto implements IContinuousImprovementDto {
  user!: User;
  userId!: number;
  data!: moment.Moment;
  collaborator!: User;
  collaboratorId!: number | undefined;
  rootTheme!: RootThemeDto;
  rootThemeId!: number;
  proposal!: string | undefined;
  status!: ContinuousImprovementStatus;
  feedback!: string | undefined;
  approver!: User;
  approverId!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IContinuousImprovementDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.data = _data['data'] ? moment(_data['data'].toString()) : <any>undefined;
      this.collaborator = _data['collaborator'] ? User.fromJS(_data['collaborator']) : <any>undefined;
      this.collaboratorId = _data['collaboratorId'];
      this.rootTheme = _data['rootTheme'] ? RootThemeDto.fromJS(_data['rootTheme']) : <any>undefined;
      this.rootThemeId = _data['rootThemeId'];
      this.proposal = _data['proposal'];
      this.status = _data['status'];
      this.feedback = _data['feedback'];
      this.approver = _data['approver'] ? User.fromJS(_data['approver']) : <any>undefined;
      this.approverId = _data['approverId'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ContinuousImprovementDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContinuousImprovementDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['data'] = this.data ? this.data.toISOString() : <any>undefined;
    data['collaborator'] = this.collaborator ? this.collaborator.toJSON() : <any>undefined;
    data['collaboratorId'] = this.collaboratorId;
    data['rootTheme'] = this.rootTheme ? this.rootTheme.toJSON() : <any>undefined;
    data['rootThemeId'] = this.rootThemeId;
    data['proposal'] = this.proposal;
    data['status'] = this.status;
    data['feedback'] = this.feedback;
    data['approver'] = this.approver ? this.approver.toJSON() : <any>undefined;
    data['approverId'] = this.approverId;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IContinuousImprovementDto {
  user: User;
  userId: number;
  data: moment.Moment;
  collaborator: User;
  collaboratorId: number | undefined;
  rootTheme: RootThemeDto;
  rootThemeId: number;
  proposal: string | undefined;
  status: ContinuousImprovementStatus;
  feedback: string | undefined;
  approver: User;
  approverId: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum ContinuousImprovementStatus {
  Submit = 0,
  UnderReview = 1,
  Concluded = 2,
}

export class CorridorDto implements ICorridorDto {
  namePT!: string | undefined;
  nameES!: string | undefined;
  nameEN!: string | undefined;
  occurrences!: CorridorOccurrencesDto[] | undefined;
  icons!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICorridorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.namePT = _data['namePT'];
      this.nameES = _data['nameES'];
      this.nameEN = _data['nameEN'];
      if (Array.isArray(_data['occurrences'])) {
        this.occurrences = [] as any;
        for (let item of _data['occurrences']) this.occurrences!.push(CorridorOccurrencesDto.fromJS(item));
      }
      this.icons = _data['icons'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CorridorDto {
    data = typeof data === 'object' ? data : {};
    let result = new CorridorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['namePT'] = this.namePT;
    data['nameES'] = this.nameES;
    data['nameEN'] = this.nameEN;
    if (Array.isArray(this.occurrences)) {
      data['occurrences'] = [];
      for (let item of this.occurrences) data['occurrences'].push(item.toJSON());
    }
    data['icons'] = this.icons;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICorridorDto {
  namePT: string | undefined;
  nameES: string | undefined;
  nameEN: string | undefined;
  occurrences: CorridorOccurrencesDto[] | undefined;
  icons: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CorridorOccurrencesDto implements ICorridorOccurrencesDto {
  corridorId!: number;
  dateOccurrence!: moment.Moment;
  airports!: AirportItemDto[] | undefined;
  meterologyTypeId!: number | undefined;
  meterologyType!: CorridorOccurrencesTypeDto;
  occurrenceType!: _definitions_CorridorOccurrenceType;
  prominence!: boolean;
  occurrenceNote!: string | undefined;
  readonly occurrenceHtml!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICorridorOccurrencesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.corridorId = _data['corridorId'];
      this.dateOccurrence = _data['dateOccurrence'] ? moment(_data['dateOccurrence'].toString()) : <any>undefined;
      if (Array.isArray(_data['airports'])) {
        this.airports = [] as any;
        for (let item of _data['airports']) this.airports!.push(AirportItemDto.fromJS(item));
      }
      this.meterologyTypeId = _data['meterologyTypeId'];
      this.meterologyType = _data['meterologyType'] ? CorridorOccurrencesTypeDto.fromJS(_data['meterologyType']) : <any>undefined;
      this.occurrenceType = _data['occurrenceType'];
      this.prominence = _data['prominence'];
      this.occurrenceNote = _data['occurrenceNote'];
      (<any>this).occurrenceHtml = _data['occurrenceHtml'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CorridorOccurrencesDto {
    data = typeof data === 'object' ? data : {};
    let result = new CorridorOccurrencesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['corridorId'] = this.corridorId;
    data['dateOccurrence'] = this.dateOccurrence ? this.dateOccurrence.toISOString() : <any>undefined;
    if (Array.isArray(this.airports)) {
      data['airports'] = [];
      for (let item of this.airports) data['airports'].push(item.toJSON());
    }
    data['meterologyTypeId'] = this.meterologyTypeId;
    data['meterologyType'] = this.meterologyType ? this.meterologyType.toJSON() : <any>undefined;
    data['occurrenceType'] = this.occurrenceType;
    data['prominence'] = this.prominence;
    data['occurrenceNote'] = this.occurrenceNote;
    data['occurrenceHtml'] = this.occurrenceHtml;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICorridorOccurrencesDto {
  corridorId: number;
  dateOccurrence: moment.Moment;
  airports: AirportItemDto[] | undefined;
  meterologyTypeId: number | undefined;
  meterologyType: CorridorOccurrencesTypeDto;
  occurrenceType: _definitions_CorridorOccurrenceType;
  prominence: boolean;
  occurrenceNote: string | undefined;
  occurrenceHtml: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CorridorOccurrencesTypeDto implements ICorridorOccurrencesTypeDto {
  code!: string | undefined;
  description!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICorridorOccurrencesTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.description = _data['description'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CorridorOccurrencesTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new CorridorOccurrencesTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['description'] = this.description;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICorridorOccurrencesTypeDto {
  code: string | undefined;
  description: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CostIndexDto implements ICostIndexDto {
  user!: User;
  userId!: number;
  index!: number;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  startValidate!: moment.Moment;
  endValidate!: moment.Moment;
  costIndexTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICostIndexDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.index = _data['index'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.startValidate = _data['startValidate'] ? moment(_data['startValidate'].toString()) : <any>undefined;
      this.endValidate = _data['endValidate'] ? moment(_data['endValidate'].toString()) : <any>undefined;
      this.costIndexTime = _data['costIndexTime'] ? moment(_data['costIndexTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CostIndexDto {
    data = typeof data === 'object' ? data : {};
    let result = new CostIndexDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['index'] = this.index;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['startValidate'] = this.startValidate ? this.startValidate.toISOString() : <any>undefined;
    data['endValidate'] = this.endValidate ? this.endValidate.toISOString() : <any>undefined;
    data['costIndexTime'] = this.costIndexTime ? this.costIndexTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICostIndexDto {
  user: User;
  userId: number;
  index: number;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  startValidate: moment.Moment;
  endValidate: moment.Moment;
  costIndexTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CostIndexOperationalDto implements ICostIndexOperationalDto {
  user!: User;
  userId!: number;
  indexOperational!: number;
  flightNumber!: string | undefined;
  startValidate!: moment.Moment;
  endValidate!: moment.Moment;
  costIndexTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ICostIndexOperationalDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.indexOperational = _data['indexOperational'];
      this.flightNumber = _data['flightNumber'];
      this.startValidate = _data['startValidate'] ? moment(_data['startValidate'].toString()) : <any>undefined;
      this.endValidate = _data['endValidate'] ? moment(_data['endValidate'].toString()) : <any>undefined;
      this.costIndexTime = _data['costIndexTime'] ? moment(_data['costIndexTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): CostIndexOperationalDto {
    data = typeof data === 'object' ? data : {};
    let result = new CostIndexOperationalDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['indexOperational'] = this.indexOperational;
    data['flightNumber'] = this.flightNumber;
    data['startValidate'] = this.startValidate ? this.startValidate.toISOString() : <any>undefined;
    data['endValidate'] = this.endValidate ? this.endValidate.toISOString() : <any>undefined;
    data['costIndexTime'] = this.costIndexTime ? this.costIndexTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ICostIndexOperationalDto {
  user: User;
  userId: number;
  indexOperational: number;
  flightNumber: string | undefined;
  startValidate: moment.Moment;
  endValidate: moment.Moment;
  costIndexTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class CreateActiveDirectoryUserInput implements ICreateActiveDirectoryUserInput {
  assignedRoleNames!: string[];
  isActive!: boolean;
  userNames!: string[];

  constructor(data?: ICreateActiveDirectoryUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.assignedRoleNames = [];
      this.userNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['assignedRoleNames'])) {
        this.assignedRoleNames = [] as any;
        for (let item of _data['assignedRoleNames']) this.assignedRoleNames!.push(item);
      }
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['userNames'])) {
        this.userNames = [] as any;
        for (let item of _data['userNames']) this.userNames!.push(item);
      }
    }
  }

  static fromJS(data: any): CreateActiveDirectoryUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateActiveDirectoryUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.assignedRoleNames)) {
      data['assignedRoleNames'] = [];
      for (let item of this.assignedRoleNames) data['assignedRoleNames'].push(item);
    }
    data['isActive'] = this.isActive;
    if (Array.isArray(this.userNames)) {
      data['userNames'] = [];
      for (let item of this.userNames) data['userNames'].push(item);
    }
    return data;
  }
}

export interface ICreateActiveDirectoryUserInput {
  assignedRoleNames: string[];
  isActive: boolean;
  userNames: string[];
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
  tenancyName!: string;
  userName!: string | undefined;

  constructor(data?: ICreateFriendshipRequestByUserNameInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data['tenancyName'];
      this.userName = _data['userName'];
    }
  }

  static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateFriendshipRequestByUserNameInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenancyName'] = this.tenancyName;
    data['userName'] = this.userName;
    return data;
  }
}

export interface ICreateFriendshipRequestByUserNameInput {
  tenancyName: string;
  userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: ICreateFriendshipRequestInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): CreateFriendshipRequestInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateFriendshipRequestInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface ICreateFriendshipRequestInput {
  tenantId: number | undefined;
  userId: number;
}

export class CreateLdapUserInput implements ICreateLdapUserInput {
  assignedRoleNames!: string[];
  isActive!: boolean;
  userNames!: string[];

  constructor(data?: ICreateLdapUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.assignedRoleNames = [];
      this.userNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['assignedRoleNames'])) {
        this.assignedRoleNames = [] as any;
        for (let item of _data['assignedRoleNames']) this.assignedRoleNames!.push(item);
      }
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['userNames'])) {
        this.userNames = [] as any;
        for (let item of _data['userNames']) this.userNames!.push(item);
      }
    }
  }

  static fromJS(data: any): CreateLdapUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateLdapUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.assignedRoleNames)) {
      data['assignedRoleNames'] = [];
      for (let item of this.assignedRoleNames) data['assignedRoleNames'].push(item);
    }
    data['isActive'] = this.isActive;
    if (Array.isArray(this.userNames)) {
      data['userNames'] = [];
      for (let item of this.userNames) data['userNames'].push(item);
    }
    return data;
  }
}

export interface ICreateLdapUserInput {
  assignedRoleNames: string[];
  isActive: boolean;
  userNames: string[];
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
  language!: ApplicationLanguageEditDto;

  constructor(data?: ICreateOrUpdateLanguageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.language = new ApplicationLanguageEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.language = _data['language'] ? ApplicationLanguageEditDto.fromJS(_data['language']) : new ApplicationLanguageEditDto();
    }
  }

  static fromJS(data: any): CreateOrUpdateLanguageInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateLanguageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['language'] = this.language ? this.language.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreateOrUpdateLanguageInput {
  language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
  grantedPermissionNames!: string[];
  role!: RoleEditDto;

  constructor(data?: ICreateOrUpdateRoleInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.grantedPermissionNames = [];
      this.role = new RoleEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['grantedPermissionNames'])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames!.push(item);
      }
      this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : new RoleEditDto();
    }
  }

  static fromJS(data: any): CreateOrUpdateRoleInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateRoleInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.grantedPermissionNames)) {
      data['grantedPermissionNames'] = [];
      for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
    }
    data['role'] = this.role ? this.role.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreateOrUpdateRoleInput {
  grantedPermissionNames: string[];
  role: RoleEditDto;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
  assignedRoleNames!: string[];
  sendActivationEmail!: boolean;
  setRandomPassword!: boolean;
  user!: UserEditDto;

  constructor(data?: ICreateOrUpdateUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.assignedRoleNames = [];
      this.user = new UserEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['assignedRoleNames'])) {
        this.assignedRoleNames = [] as any;
        for (let item of _data['assignedRoleNames']) this.assignedRoleNames!.push(item);
      }
      this.sendActivationEmail = _data['sendActivationEmail'];
      this.setRandomPassword = _data['setRandomPassword'];
      this.user = _data['user'] ? UserEditDto.fromJS(_data['user']) : new UserEditDto();
    }
  }

  static fromJS(data: any): CreateOrUpdateUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.assignedRoleNames)) {
      data['assignedRoleNames'] = [];
      for (let item of this.assignedRoleNames) data['assignedRoleNames'].push(item);
    }
    data['sendActivationEmail'] = this.sendActivationEmail;
    data['setRandomPassword'] = this.setRandomPassword;
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreateOrUpdateUserInput {
  assignedRoleNames: string[];
  sendActivationEmail: boolean;
  setRandomPassword: boolean;
  user: UserEditDto;
}

export class CreateTenantInput implements ICreateTenantInput {
  adminEmailAddress!: string;
  adminPassword!: string | undefined;
  isActive!: boolean;
  name!: string;
  sendActivationEmail!: boolean;
  shouldChangePasswordOnNextLogin!: boolean;
  tenancyName!: string;

  constructor(data?: ICreateTenantInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.adminEmailAddress = _data['adminEmailAddress'];
      this.adminPassword = _data['adminPassword'];
      this.isActive = _data['isActive'];
      this.name = _data['name'];
      this.sendActivationEmail = _data['sendActivationEmail'];
      this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
      this.tenancyName = _data['tenancyName'];
    }
  }

  static fromJS(data: any): CreateTenantInput {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTenantInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['adminEmailAddress'] = this.adminEmailAddress;
    data['adminPassword'] = this.adminPassword;
    data['isActive'] = this.isActive;
    data['name'] = this.name;
    data['sendActivationEmail'] = this.sendActivationEmail;
    data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
    data['tenancyName'] = this.tenancyName;
    return data;
  }
}

export interface ICreateTenantInput {
  adminEmailAddress: string;
  adminPassword: string | undefined;
  isActive: boolean;
  name: string;
  sendActivationEmail: boolean;
  shouldChangePasswordOnNextLogin: boolean;
  tenancyName: string;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
  emailAddress!: string;
  name!: string;
  surname!: string;
  timezone!: string | undefined;
  userName!: string;

  constructor(data?: ICurrentUserProfileEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.timezone = _data['timezone'];
      this.userName = _data['userName'];
    }
  }

  static fromJS(data: any): CurrentUserProfileEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new CurrentUserProfileEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['timezone'] = this.timezone;
    data['userName'] = this.userName;
    return data;
  }
}

export interface ICurrentUserProfileEditDto {
  emailAddress: string;
  name: string;
  surname: string;
  timezone: string | undefined;
  userName: string;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
  defaultFromAddress!: string | undefined;
  defaultFromDisplayName!: string | undefined;
  smtpDomain!: string | undefined;
  smtpEnableSsl!: boolean;
  smtpHost!: string | undefined;
  smtpPassword!: string | undefined;
  smtpPort!: number;
  smtpUseDefaultCredentials!: boolean;
  smtpUserName!: string | undefined;

  constructor(data?: IEmailSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultFromAddress = _data['defaultFromAddress'];
      this.defaultFromDisplayName = _data['defaultFromDisplayName'];
      this.smtpDomain = _data['smtpDomain'];
      this.smtpEnableSsl = _data['smtpEnableSsl'];
      this.smtpHost = _data['smtpHost'];
      this.smtpPassword = _data['smtpPassword'];
      this.smtpPort = _data['smtpPort'];
      this.smtpUseDefaultCredentials = _data['smtpUseDefaultCredentials'];
      this.smtpUserName = _data['smtpUserName'];
    }
  }

  static fromJS(data: any): EmailSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmailSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['defaultFromAddress'] = this.defaultFromAddress;
    data['defaultFromDisplayName'] = this.defaultFromDisplayName;
    data['smtpDomain'] = this.smtpDomain;
    data['smtpEnableSsl'] = this.smtpEnableSsl;
    data['smtpHost'] = this.smtpHost;
    data['smtpPassword'] = this.smtpPassword;
    data['smtpPort'] = this.smtpPort;
    data['smtpUseDefaultCredentials'] = this.smtpUseDefaultCredentials;
    data['smtpUserName'] = this.smtpUserName;
    return data;
  }
}

export interface IEmailSettingsEditDto {
  defaultFromAddress: string | undefined;
  defaultFromDisplayName: string | undefined;
  smtpDomain: string | undefined;
  smtpEnableSsl: boolean;
  smtpHost: string | undefined;
  smtpPassword: string | undefined;
  smtpPort: number;
  smtpUseDefaultCredentials: boolean;
  smtpUserName: string | undefined;
}

export class EntityChangeListDto implements IEntityChangeListDto {
  changeTime!: moment.Moment;
  changeType!: EntityChangeType;
  readonly changeTypeName!: string | undefined;
  entityChangeSetId!: number;
  entityTypeFullName!: string | undefined;
  userId!: number | undefined;
  userName!: string | undefined;
  id!: number;

  constructor(data?: IEntityChangeListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.changeTime = _data['changeTime'] ? moment(_data['changeTime'].toString()) : <any>undefined;
      this.changeType = _data['changeType'];
      (<any>this).changeTypeName = _data['changeTypeName'];
      this.entityChangeSetId = _data['entityChangeSetId'];
      this.entityTypeFullName = _data['entityTypeFullName'];
      this.userId = _data['userId'];
      this.userName = _data['userName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EntityChangeListDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityChangeListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['changeTime'] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
    data['changeType'] = this.changeType;
    data['changeTypeName'] = this.changeTypeName;
    data['entityChangeSetId'] = this.entityChangeSetId;
    data['entityTypeFullName'] = this.entityTypeFullName;
    data['userId'] = this.userId;
    data['userName'] = this.userName;
    data['id'] = this.id;
    return data;
  }
}

export interface IEntityChangeListDto {
  changeTime: moment.Moment;
  changeType: EntityChangeType;
  changeTypeName: string | undefined;
  entityChangeSetId: number;
  entityTypeFullName: string | undefined;
  userId: number | undefined;
  userName: string | undefined;
  id: number;
}

export enum EntityChangeType {
  Created = 0,
  Updated = 1,
  Deleted = 2,
}

export class EntityDto implements IEntityDto {
  id!: number;

  constructor(data?: IEntityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EntityDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    return data;
  }
}

export interface IEntityDto {
  id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
  id!: string;

  constructor(data?: IEntityDtoOfGuid) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EntityDtoOfGuid {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDtoOfGuid();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    return data;
  }
}

export interface IEntityDtoOfGuid {
  id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
  id!: number;

  constructor(data?: IEntityDtoOfInt64) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EntityDtoOfInt64 {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDtoOfInt64();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    return data;
  }
}

export interface IEntityDtoOfInt64 {
  id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
  id!: string | undefined;

  constructor(data?: IEntityDtoOfString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EntityDtoOfString {
    data = typeof data === 'object' ? data : {};
    let result = new EntityDtoOfString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    return data;
  }
}

export interface IEntityDtoOfString {
  id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
  entityChangeId!: number;
  newValue!: string | undefined;
  originalValue!: string | undefined;
  propertyName!: string | undefined;
  propertyTypeFullName!: string | undefined;
  tenantId!: number | undefined;
  id!: number;

  constructor(data?: IEntityPropertyChangeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityChangeId = _data['entityChangeId'];
      this.newValue = _data['newValue'];
      this.originalValue = _data['originalValue'];
      this.propertyName = _data['propertyName'];
      this.propertyTypeFullName = _data['propertyTypeFullName'];
      this.tenantId = _data['tenantId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EntityPropertyChangeDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityPropertyChangeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['entityChangeId'] = this.entityChangeId;
    data['newValue'] = this.newValue;
    data['originalValue'] = this.originalValue;
    data['propertyName'] = this.propertyName;
    data['propertyTypeFullName'] = this.propertyTypeFullName;
    data['tenantId'] = this.tenantId;
    data['id'] = this.id;
    return data;
  }
}

export interface IEntityPropertyChangeDto {
  entityChangeId: number;
  newValue: string | undefined;
  originalValue: string | undefined;
  propertyName: string | undefined;
  propertyTypeFullName: string | undefined;
  tenantId: number | undefined;
  id: number;
}

export class EventDto implements IEventDto {
  title!: string | undefined;
  content!: string | undefined;
  startTime!: moment.Moment;
  endTime!: moment.Moment;
  repeatDays!: number | undefined;
  repeatMode!: RepeatMode;
  createdBy!: string | undefined;
  isRepetition!: boolean;
  firstStartTime!: moment.Moment | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IEventDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.content = _data['content'];
      this.startTime = _data['startTime'] ? moment(_data['startTime'].toString()) : <any>undefined;
      this.endTime = _data['endTime'] ? moment(_data['endTime'].toString()) : <any>undefined;
      this.repeatDays = _data['repeatDays'];
      this.repeatMode = _data['repeatMode'];
      this.createdBy = _data['createdBy'];
      this.isRepetition = _data['isRepetition'];
      this.firstStartTime = _data['firstStartTime'] ? moment(_data['firstStartTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): EventDto {
    data = typeof data === 'object' ? data : {};
    let result = new EventDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['content'] = this.content;
    data['startTime'] = this.startTime ? this.startTime.toISOString() : <any>undefined;
    data['endTime'] = this.endTime ? this.endTime.toISOString() : <any>undefined;
    data['repeatDays'] = this.repeatDays;
    data['repeatMode'] = this.repeatMode;
    data['createdBy'] = this.createdBy;
    data['isRepetition'] = this.isRepetition;
    data['firstStartTime'] = this.firstStartTime ? this.firstStartTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IEventDto {
  title: string | undefined;
  content: string | undefined;
  startTime: moment.Moment;
  endTime: moment.Moment;
  repeatDays: number | undefined;
  repeatMode: RepeatMode;
  createdBy: string | undefined;
  isRepetition: boolean;
  firstStartTime: moment.Moment | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class ExpiredEntityLogDeleterSettingsEditDto implements IExpiredEntityLogDeleterSettingsEditDto {
  expiredDays!: number | undefined;
  enabled!: boolean | undefined;
  deletedQuantity!: number | undefined;

  constructor(data?: IExpiredEntityLogDeleterSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.expiredDays = _data['expiredDays'];
      this.enabled = _data['enabled'];
      this.deletedQuantity = _data['deletedQuantity'];
    }
  }

  static fromJS(data: any): ExpiredEntityLogDeleterSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExpiredEntityLogDeleterSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['expiredDays'] = this.expiredDays;
    data['enabled'] = this.enabled;
    data['deletedQuantity'] = this.deletedQuantity;
    return data;
  }
}

export interface IExpiredEntityLogDeleterSettingsEditDto {
  expiredDays: number | undefined;
  enabled: boolean | undefined;
  deletedQuantity: number | undefined;
}

export class ExpiredEntityLoginImpersonatorSettingsEditDto implements IExpiredEntityLoginImpersonatorSettingsEditDto {
  enabled!: boolean | undefined;

  constructor(data?: IExpiredEntityLoginImpersonatorSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.enabled = _data['enabled'];
    }
  }

  static fromJS(data: any): ExpiredEntityLoginImpersonatorSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExpiredEntityLoginImpersonatorSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['enabled'] = this.enabled;
    return data;
  }
}

export interface IExpiredEntityLoginImpersonatorSettingsEditDto {
  enabled: boolean | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
  authProvider!: string;
  providerAccessCode!: string;
  providerKey!: string;
  returnUrl!: string | undefined;
  singleSignIn!: boolean | undefined;

  constructor(data?: IExternalAuthenticateModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authProvider = _data['authProvider'];
      this.providerAccessCode = _data['providerAccessCode'];
      this.providerKey = _data['providerKey'];
      this.returnUrl = _data['returnUrl'];
      this.singleSignIn = _data['singleSignIn'];
    }
  }

  static fromJS(data: any): ExternalAuthenticateModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authProvider'] = this.authProvider;
    data['providerAccessCode'] = this.providerAccessCode;
    data['providerKey'] = this.providerKey;
    data['returnUrl'] = this.returnUrl;
    data['singleSignIn'] = this.singleSignIn;
    return data;
  }
}

export interface IExternalAuthenticateModel {
  authProvider: string;
  providerAccessCode: string;
  providerKey: string;
  returnUrl: string | undefined;
  singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;
  returnUrl!: string | undefined;
  waitingForActivation!: boolean;
  userId!: number;

  constructor(data?: IExternalAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data['accessToken'];
      this.encryptedAccessToken = _data['encryptedAccessToken'];
      this.expireInSeconds = _data['expireInSeconds'];
      this.returnUrl = _data['returnUrl'];
      this.waitingForActivation = _data['waitingForActivation'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ExternalAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['accessToken'] = this.accessToken;
    data['encryptedAccessToken'] = this.encryptedAccessToken;
    data['expireInSeconds'] = this.expireInSeconds;
    data['returnUrl'] = this.returnUrl;
    data['waitingForActivation'] = this.waitingForActivation;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IExternalAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
  returnUrl: string | undefined;
  waitingForActivation: boolean;
  userId: number;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
  additionalParams!: { [key: string]: string } | undefined;
  clientId!: string | undefined;
  name!: string | undefined;
  tenantId!: string | undefined;

  constructor(data?: IExternalLoginProviderInfoModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['additionalParams']) {
        this.additionalParams = {} as any;
        for (let key in _data['additionalParams']) {
          if (_data['additionalParams'].hasOwnProperty(key)) (<any>this.additionalParams)![key] = _data['additionalParams'][key];
        }
      }
      this.clientId = _data['clientId'];
      this.name = _data['name'];
      this.tenantId = _data['tenantId'];
    }
  }

  static fromJS(data: any): ExternalLoginProviderInfoModel {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginProviderInfoModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.additionalParams) {
      data['additionalParams'] = {};
      for (let key in this.additionalParams) {
        if (this.additionalParams.hasOwnProperty(key)) (<any>data['additionalParams'])[key] = (<any>this.additionalParams)[key];
      }
    }
    data['clientId'] = this.clientId;
    data['name'] = this.name;
    data['tenantId'] = this.tenantId;
    return data;
  }
}

export interface IExternalLoginProviderInfoModel {
  additionalParams: { [key: string]: string } | undefined;
  clientId: string | undefined;
  name: string | undefined;
  tenantId: string | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
  google!: GoogleExternalLoginProviderSettings;
  google_IsEnabled!: boolean;
  microsoft!: MicrosoftExternalLoginProviderSettings;
  microsoft_IsEnabled!: boolean;
  openIdConnect!: OpenIdConnectExternalLoginProviderSettings;
  openIdConnect_IsEnabled!: boolean;
  openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
  authZero!: AuthZeroExternalLoginProviderSettings;
  authZero_IsEnabled!: boolean;

  constructor(data?: IExternalLoginProviderSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.google = _data['google'] ? GoogleExternalLoginProviderSettings.fromJS(_data['google']) : <any>undefined;
      this.google_IsEnabled = _data['google_IsEnabled'];
      this.microsoft = _data['microsoft'] ? MicrosoftExternalLoginProviderSettings.fromJS(_data['microsoft']) : <any>undefined;
      this.microsoft_IsEnabled = _data['microsoft_IsEnabled'];
      this.openIdConnect = _data['openIdConnect']
        ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data['openIdConnect'])
        : <any>undefined;
      this.openIdConnect_IsEnabled = _data['openIdConnect_IsEnabled'];
      if (Array.isArray(_data['openIdConnectClaimsMapping'])) {
        this.openIdConnectClaimsMapping = [] as any;
        for (let item of _data['openIdConnectClaimsMapping']) this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
      }
      this.authZero = _data['authZero'] ? AuthZeroExternalLoginProviderSettings.fromJS(_data['authZero']) : <any>undefined;
      this.authZero_IsEnabled = _data['authZero_IsEnabled'];
    }
  }

  static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExternalLoginProviderSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['google'] = this.google ? this.google.toJSON() : <any>undefined;
    data['google_IsEnabled'] = this.google_IsEnabled;
    data['microsoft'] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
    data['microsoft_IsEnabled'] = this.microsoft_IsEnabled;
    data['openIdConnect'] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
    data['openIdConnect_IsEnabled'] = this.openIdConnect_IsEnabled;
    if (Array.isArray(this.openIdConnectClaimsMapping)) {
      data['openIdConnectClaimsMapping'] = [];
      for (let item of this.openIdConnectClaimsMapping) data['openIdConnectClaimsMapping'].push(item.toJSON());
    }
    data['authZero'] = this.authZero ? this.authZero.toJSON() : <any>undefined;
    data['authZero_IsEnabled'] = this.authZero_IsEnabled;
    return data;
  }
}

export interface IExternalLoginProviderSettingsEditDto {
  google: GoogleExternalLoginProviderSettings;
  google_IsEnabled: boolean;
  microsoft: MicrosoftExternalLoginProviderSettings;
  microsoft_IsEnabled: boolean;
  openIdConnect: OpenIdConnectExternalLoginProviderSettings;
  openIdConnect_IsEnabled: boolean;
  openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
  authZero: AuthZeroExternalLoginProviderSettings;
  authZero_IsEnabled: boolean;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
  attributes!: { [key: string]: any } | undefined;
  itemSource!: LocalizableComboboxItemSourceDto;
  name!: string | undefined;
  validator!: IValueValidator;

  constructor(data?: IFeatureInputTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['attributes']) {
        this.attributes = {} as any;
        for (let key in _data['attributes']) {
          if (_data['attributes'].hasOwnProperty(key)) (<any>this.attributes)![key] = _data['attributes'][key];
        }
      }
      this.itemSource = _data['itemSource'] ? LocalizableComboboxItemSourceDto.fromJS(_data['itemSource']) : <any>undefined;
      this.name = _data['name'];
      this.validator = _data['validator'] ? IValueValidator.fromJS(_data['validator']) : <any>undefined;
    }
  }

  static fromJS(data: any): FeatureInputTypeDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeatureInputTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.attributes) {
      data['attributes'] = {};
      for (let key in this.attributes) {
        if (this.attributes.hasOwnProperty(key)) (<any>data['attributes'])[key] = (<any>this.attributes)[key];
      }
    }
    data['itemSource'] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
    data['name'] = this.name;
    data['validator'] = this.validator ? this.validator.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFeatureInputTypeDto {
  attributes: { [key: string]: any } | undefined;
  itemSource: LocalizableComboboxItemSourceDto;
  name: string | undefined;
  validator: IValueValidator;
}

export enum FeedbackType {
  Applied = 0,
  NotApplied = 1,
  None = 2,
}

export class FileDto implements IFileDto {
  fileName!: string;
  fileToken!: string;
  fileType!: string | undefined;

  constructor(data?: IFileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileName = _data['fileName'];
      this.fileToken = _data['fileToken'];
      this.fileType = _data['fileType'];
    }
  }

  static fromJS(data: any): FileDto {
    data = typeof data === 'object' ? data : {};
    let result = new FileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fileName'] = this.fileName;
    data['fileToken'] = this.fileToken;
    data['fileType'] = this.fileType;
    return data;
  }
}

export interface IFileDto {
  fileName: string;
  fileToken: string;
  fileType: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
  tenantId!: number | undefined;
  filter!: string | undefined;
  maxResultCount!: number;
  skipCount!: number;

  constructor(data?: IFindUsersInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.filter = _data['filter'];
      this.maxResultCount = _data['maxResultCount'];
      this.skipCount = _data['skipCount'];
    }
  }

  static fromJS(data: any): FindUsersInput {
    data = typeof data === 'object' ? data : {};
    let result = new FindUsersInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['filter'] = this.filter;
    data['maxResultCount'] = this.maxResultCount;
    data['skipCount'] = this.skipCount;
    return data;
  }
}

export interface IFindUsersInput {
  tenantId: number | undefined;
  filter: string | undefined;
  maxResultCount: number;
  skipCount: number;
}

export class FirDto implements IFirDto {
  user!: User;
  userId!: number;
  description!: string | undefined;
  apt1!: string | undefined;
  apt2!: string | undefined;
  apt3!: string | undefined;
  apt4!: string | undefined;
  apt5!: string | undefined;
  apt6!: string | undefined;
  apt7!: string | undefined;
  apt8!: string | undefined;
  apt9!: string | undefined;
  apt10!: string | undefined;
  apt11!: string | undefined;
  apt12!: string | undefined;
  apt13!: string | undefined;
  apt14!: string | undefined;
  apt15!: string | undefined;
  apt16!: string | undefined;
  apt17!: string | undefined;
  apt18!: string | undefined;
  apt19!: string | undefined;
  apt20!: string | undefined;
  apt21!: string | undefined;
  apt22!: string | undefined;
  apt23!: string | undefined;
  apt24!: string | undefined;
  apt25!: string | undefined;
  firTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IFirDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.description = _data['description'];
      this.apt1 = _data['apt1'];
      this.apt2 = _data['apt2'];
      this.apt3 = _data['apt3'];
      this.apt4 = _data['apt4'];
      this.apt5 = _data['apt5'];
      this.apt6 = _data['apt6'];
      this.apt7 = _data['apt7'];
      this.apt8 = _data['apt8'];
      this.apt9 = _data['apt9'];
      this.apt10 = _data['apt10'];
      this.apt11 = _data['apt11'];
      this.apt12 = _data['apt12'];
      this.apt13 = _data['apt13'];
      this.apt14 = _data['apt14'];
      this.apt15 = _data['apt15'];
      this.apt16 = _data['apt16'];
      this.apt17 = _data['apt17'];
      this.apt18 = _data['apt18'];
      this.apt19 = _data['apt19'];
      this.apt20 = _data['apt20'];
      this.apt21 = _data['apt21'];
      this.apt22 = _data['apt22'];
      this.apt23 = _data['apt23'];
      this.apt24 = _data['apt24'];
      this.apt25 = _data['apt25'];
      this.firTime = _data['firTime'] ? moment(_data['firTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): FirDto {
    data = typeof data === 'object' ? data : {};
    let result = new FirDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['description'] = this.description;
    data['apt1'] = this.apt1;
    data['apt2'] = this.apt2;
    data['apt3'] = this.apt3;
    data['apt4'] = this.apt4;
    data['apt5'] = this.apt5;
    data['apt6'] = this.apt6;
    data['apt7'] = this.apt7;
    data['apt8'] = this.apt8;
    data['apt9'] = this.apt9;
    data['apt10'] = this.apt10;
    data['apt11'] = this.apt11;
    data['apt12'] = this.apt12;
    data['apt13'] = this.apt13;
    data['apt14'] = this.apt14;
    data['apt15'] = this.apt15;
    data['apt16'] = this.apt16;
    data['apt17'] = this.apt17;
    data['apt18'] = this.apt18;
    data['apt19'] = this.apt19;
    data['apt20'] = this.apt20;
    data['apt21'] = this.apt21;
    data['apt22'] = this.apt22;
    data['apt23'] = this.apt23;
    data['apt24'] = this.apt24;
    data['apt25'] = this.apt25;
    data['firTime'] = this.firTime ? this.firTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IFirDto {
  user: User;
  userId: number;
  description: string | undefined;
  apt1: string | undefined;
  apt2: string | undefined;
  apt3: string | undefined;
  apt4: string | undefined;
  apt5: string | undefined;
  apt6: string | undefined;
  apt7: string | undefined;
  apt8: string | undefined;
  apt9: string | undefined;
  apt10: string | undefined;
  apt11: string | undefined;
  apt12: string | undefined;
  apt13: string | undefined;
  apt14: string | undefined;
  apt15: string | undefined;
  apt16: string | undefined;
  apt17: string | undefined;
  apt18: string | undefined;
  apt19: string | undefined;
  apt20: string | undefined;
  apt21: string | undefined;
  apt22: string | undefined;
  apt23: string | undefined;
  apt24: string | undefined;
  apt25: string | undefined;
  firTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class FlatFeatureDto implements IFlatFeatureDto {
  defaultValue!: string | undefined;
  description!: string | undefined;
  displayName!: string | undefined;
  inputType!: FeatureInputTypeDto;
  name!: string | undefined;
  parentName!: string | undefined;

  constructor(data?: IFlatFeatureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultValue = _data['defaultValue'];
      this.description = _data['description'];
      this.displayName = _data['displayName'];
      this.inputType = _data['inputType'] ? FeatureInputTypeDto.fromJS(_data['inputType']) : <any>undefined;
      this.name = _data['name'];
      this.parentName = _data['parentName'];
    }
  }

  static fromJS(data: any): FlatFeatureDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatFeatureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['defaultValue'] = this.defaultValue;
    data['description'] = this.description;
    data['displayName'] = this.displayName;
    data['inputType'] = this.inputType ? this.inputType.toJSON() : <any>undefined;
    data['name'] = this.name;
    data['parentName'] = this.parentName;
    return data;
  }
}

export interface IFlatFeatureDto {
  defaultValue: string | undefined;
  description: string | undefined;
  displayName: string | undefined;
  inputType: FeatureInputTypeDto;
  name: string | undefined;
  parentName: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
  description!: string | undefined;
  displayName!: string | undefined;
  isGrantedByDefault!: boolean;
  name!: string | undefined;
  parentName!: string | undefined;

  constructor(data?: IFlatPermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.description = _data['description'];
      this.displayName = _data['displayName'];
      this.isGrantedByDefault = _data['isGrantedByDefault'];
      this.name = _data['name'];
      this.parentName = _data['parentName'];
    }
  }

  static fromJS(data: any): FlatPermissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatPermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['description'] = this.description;
    data['displayName'] = this.displayName;
    data['isGrantedByDefault'] = this.isGrantedByDefault;
    data['name'] = this.name;
    data['parentName'] = this.parentName;
    return data;
  }
}

export interface IFlatPermissionDto {
  description: string | undefined;
  displayName: string | undefined;
  isGrantedByDefault: boolean;
  name: string | undefined;
  parentName: string | undefined;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
  level!: number;
  description!: string | undefined;
  displayName!: string | undefined;
  isGrantedByDefault!: boolean;
  name!: string | undefined;
  parentName!: string | undefined;

  constructor(data?: IFlatPermissionWithLevelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.level = _data['level'];
      this.description = _data['description'];
      this.displayName = _data['displayName'];
      this.isGrantedByDefault = _data['isGrantedByDefault'];
      this.name = _data['name'];
      this.parentName = _data['parentName'];
    }
  }

  static fromJS(data: any): FlatPermissionWithLevelDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlatPermissionWithLevelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['level'] = this.level;
    data['description'] = this.description;
    data['displayName'] = this.displayName;
    data['isGrantedByDefault'] = this.isGrantedByDefault;
    data['name'] = this.name;
    data['parentName'] = this.parentName;
    return data;
  }
}

export interface IFlatPermissionWithLevelDto {
  level: number;
  description: string | undefined;
  displayName: string | undefined;
  isGrantedByDefault: boolean;
  name: string | undefined;
  parentName: string | undefined;
}

export class FlightLaunchDto implements IFlightLaunchDto {
  user!: User;
  userId!: number;
  origin!: string | undefined;
  destiny!: string | undefined;
  routeType!: RouteType;
  normalRoute!: string | undefined;
  swapRoute!: string | undefined;
  flightLaunchTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IFlightLaunchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.origin = _data['origin'];
      this.destiny = _data['destiny'];
      this.routeType = _data['routeType'];
      this.normalRoute = _data['normalRoute'];
      this.swapRoute = _data['swapRoute'];
      this.flightLaunchTime = _data['flightLaunchTime'] ? moment(_data['flightLaunchTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): FlightLaunchDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlightLaunchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['origin'] = this.origin;
    data['destiny'] = this.destiny;
    data['routeType'] = this.routeType;
    data['normalRoute'] = this.normalRoute;
    data['swapRoute'] = this.swapRoute;
    data['flightLaunchTime'] = this.flightLaunchTime ? this.flightLaunchTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IFlightLaunchDto {
  user: User;
  userId: number;
  origin: string | undefined;
  destiny: string | undefined;
  routeType: RouteType;
  normalRoute: string | undefined;
  swapRoute: string | undefined;
  flightLaunchTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum FlightMonitoringArea {
  Alternated = 0,
  QgoBase = 1,
  ReclearenceDomestic = 2,
  ReclearenceInternational = 3,
  VfrFlight = 4,
  RouteDiversion = 5,
  Communication = 6,
  Etops = 7,
  ScelFlight = 8,
  AcarsInop = 9,
  Debriefing = 10,
  Others = 11,
}

export class FlightMonitoringDto implements IFlightMonitoringDto {
  title!: string | undefined;
  monitoringDate!: moment.Moment;
  period!: string | undefined;
  monitoringType!: FlightMonitoringType;
  monitoringArea!: FlightMonitoringArea;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  prefix!: string | undefined;
  description!: string | undefined;
  communication!: boolean;
  userLeaderDov!: User;
  userLeaderDovId!: number | undefined;
  userDov!: User;
  userDovId!: number | undefined;
  flightRecalculated!: boolean;
  descriptionNewRoute!: string | undefined;
  flightRecalculatedConfirmation!: boolean;
  descriptionNewDOV!: string | undefined;
  leaderDOVMonitoring!: string | undefined;
  userCreator!: string | undefined;
  userLastModified!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IFlightMonitoringDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.monitoringDate = _data['monitoringDate'] ? moment(_data['monitoringDate'].toString()) : <any>undefined;
      this.period = _data['period'];
      this.monitoringType = _data['monitoringType'];
      this.monitoringArea = _data['monitoringArea'];
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.prefix = _data['prefix'];
      this.description = _data['description'];
      this.communication = _data['communication'];
      this.userLeaderDov = _data['userLeaderDov'] ? User.fromJS(_data['userLeaderDov']) : <any>undefined;
      this.userLeaderDovId = _data['userLeaderDovId'];
      this.userDov = _data['userDov'] ? User.fromJS(_data['userDov']) : <any>undefined;
      this.userDovId = _data['userDovId'];
      this.flightRecalculated = _data['flightRecalculated'];
      this.descriptionNewRoute = _data['descriptionNewRoute'];
      this.flightRecalculatedConfirmation = _data['flightRecalculatedConfirmation'];
      this.descriptionNewDOV = _data['descriptionNewDOV'];
      this.leaderDOVMonitoring = _data['leaderDOVMonitoring'];
      this.userCreator = _data['userCreator'];
      this.userLastModified = _data['userLastModified'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): FlightMonitoringDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlightMonitoringDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['monitoringDate'] = this.monitoringDate ? this.monitoringDate.toISOString() : <any>undefined;
    data['period'] = this.period;
    data['monitoringType'] = this.monitoringType;
    data['monitoringArea'] = this.monitoringArea;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['prefix'] = this.prefix;
    data['description'] = this.description;
    data['communication'] = this.communication;
    data['userLeaderDov'] = this.userLeaderDov ? this.userLeaderDov.toJSON() : <any>undefined;
    data['userLeaderDovId'] = this.userLeaderDovId;
    data['userDov'] = this.userDov ? this.userDov.toJSON() : <any>undefined;
    data['userDovId'] = this.userDovId;
    data['flightRecalculated'] = this.flightRecalculated;
    data['descriptionNewRoute'] = this.descriptionNewRoute;
    data['flightRecalculatedConfirmation'] = this.flightRecalculatedConfirmation;
    data['descriptionNewDOV'] = this.descriptionNewDOV;
    data['leaderDOVMonitoring'] = this.leaderDOVMonitoring;
    data['userCreator'] = this.userCreator;
    data['userLastModified'] = this.userLastModified;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IFlightMonitoringDto {
  title: string | undefined;
  monitoringDate: moment.Moment;
  period: string | undefined;
  monitoringType: FlightMonitoringType;
  monitoringArea: FlightMonitoringArea;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  prefix: string | undefined;
  description: string | undefined;
  communication: boolean;
  userLeaderDov: User;
  userLeaderDovId: number | undefined;
  userDov: User;
  userDovId: number | undefined;
  flightRecalculated: boolean;
  descriptionNewRoute: string | undefined;
  flightRecalculatedConfirmation: boolean;
  descriptionNewDOV: string | undefined;
  leaderDOVMonitoring: string | undefined;
  userCreator: string | undefined;
  userLastModified: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum FlightMonitoringType {
  Hf = 0,
  HfAcars = 1,
  Acars = 2,
  HfSatcom = 3,
  HfSatcomAcars = 4,
}

export class FlightTimeDto implements IFlightTimeDto {
  user!: User;
  userId!: number;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  time!: number;
  registrationTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IFlightTimeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.time = _data['time'];
      this.registrationTime = _data['registrationTime'] ? moment(_data['registrationTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): FlightTimeDto {
    data = typeof data === 'object' ? data : {};
    let result = new FlightTimeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['time'] = this.time;
    data['registrationTime'] = this.registrationTime ? this.registrationTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IFlightTimeDto {
  user: User;
  userId: number;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  time: number;
  registrationTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class FriendshipDto implements IFriendshipDto {
  friendProfilePictureId!: string | undefined;
  friendTenancyName!: string | undefined;
  friendTenantId!: number | undefined;
  friendUserId!: number;
  friendUserName!: string | undefined;
  isOnline!: boolean;
  state!: FriendshipState;
  unreadMessageCount!: number;
  name!: string | undefined;
  surname!: string | undefined;
  email!: string | undefined;
  groupId!: number | undefined;

  constructor(data?: IFriendshipDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.friendProfilePictureId = _data['friendProfilePictureId'];
      this.friendTenancyName = _data['friendTenancyName'];
      this.friendTenantId = _data['friendTenantId'];
      this.friendUserId = _data['friendUserId'];
      this.friendUserName = _data['friendUserName'];
      this.isOnline = _data['isOnline'];
      this.state = _data['state'];
      this.unreadMessageCount = _data['unreadMessageCount'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.groupId = _data['groupId'];
    }
  }

  static fromJS(data: any): FriendshipDto {
    data = typeof data === 'object' ? data : {};
    let result = new FriendshipDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['friendProfilePictureId'] = this.friendProfilePictureId;
    data['friendTenancyName'] = this.friendTenancyName;
    data['friendTenantId'] = this.friendTenantId;
    data['friendUserId'] = this.friendUserId;
    data['friendUserName'] = this.friendUserName;
    data['isOnline'] = this.isOnline;
    data['state'] = this.state;
    data['unreadMessageCount'] = this.unreadMessageCount;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['groupId'] = this.groupId;
    return data;
  }
}

export interface IFriendshipDto {
  friendProfilePictureId: string | undefined;
  friendTenancyName: string | undefined;
  friendTenantId: number | undefined;
  friendUserId: number;
  friendUserName: string | undefined;
  isOnline: boolean;
  state: FriendshipState;
  unreadMessageCount: number;
  name: string | undefined;
  surname: string | undefined;
  email: string | undefined;
  groupId: number | undefined;
}

export enum FriendshipState {
  Accepted = 1,
  Blocked = 2,
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
  timezone!: string | undefined;
  timezoneForComparison!: string | undefined;

  constructor(data?: IGeneralSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timezone = _data['timezone'];
      this.timezoneForComparison = _data['timezoneForComparison'];
    }
  }

  static fromJS(data: any): GeneralSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new GeneralSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['timezone'] = this.timezone;
    data['timezoneForComparison'] = this.timezoneForComparison;
    return data;
  }
}

export interface IGeneralSettingsEditDto {
  timezone: string | undefined;
  timezoneForComparison: string | undefined;
}

export class GetAllAvailableWebhooksOutput implements IGetAllAvailableWebhooksOutput {
  description!: string | undefined;
  displayName!: string | undefined;
  name!: string | undefined;

  constructor(data?: IGetAllAvailableWebhooksOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.description = _data['description'];
      this.displayName = _data['displayName'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): GetAllAvailableWebhooksOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllAvailableWebhooksOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['description'] = this.description;
    data['displayName'] = this.displayName;
    data['name'] = this.name;
    return data;
  }
}

export interface IGetAllAvailableWebhooksOutput {
  description: string | undefined;
  displayName: string | undefined;
  name: string | undefined;
}

export class GetAllSendAttemptsOfWebhookEventOutput implements IGetAllSendAttemptsOfWebhookEventOutput {
  creationTime!: moment.Moment;
  id!: string;
  lastModificationTime!: moment.Moment | undefined;
  response!: string | undefined;
  responseStatusCode!: HttpStatusCode;
  webhookSubscriptionId!: string;
  webhookUri!: string | undefined;

  constructor(data?: IGetAllSendAttemptsOfWebhookEventOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.id = _data['id'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.response = _data['response'];
      this.responseStatusCode = _data['responseStatusCode'];
      this.webhookSubscriptionId = _data['webhookSubscriptionId'];
      this.webhookUri = _data['webhookUri'];
    }
  }

  static fromJS(data: any): GetAllSendAttemptsOfWebhookEventOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllSendAttemptsOfWebhookEventOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['id'] = this.id;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['response'] = this.response;
    data['responseStatusCode'] = this.responseStatusCode;
    data['webhookSubscriptionId'] = this.webhookSubscriptionId;
    data['webhookUri'] = this.webhookUri;
    return data;
  }
}

export interface IGetAllSendAttemptsOfWebhookEventOutput {
  creationTime: moment.Moment;
  id: string;
  lastModificationTime: moment.Moment | undefined;
  response: string | undefined;
  responseStatusCode: HttpStatusCode;
  webhookSubscriptionId: string;
  webhookUri: string | undefined;
}

export class GetAllSendAttemptsOutput implements IGetAllSendAttemptsOutput {
  creationTime!: moment.Moment;
  data!: string | undefined;
  id!: string;
  response!: string | undefined;
  responseStatusCode!: HttpStatusCode;
  webhookEventId!: string;
  webhookName!: string | undefined;

  constructor(data?: IGetAllSendAttemptsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.data = _data['data'];
      this.id = _data['id'];
      this.response = _data['response'];
      this.responseStatusCode = _data['responseStatusCode'];
      this.webhookEventId = _data['webhookEventId'];
      this.webhookName = _data['webhookName'];
    }
  }

  static fromJS(data: any): GetAllSendAttemptsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllSendAttemptsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['data'] = this.data;
    data['id'] = this.id;
    data['response'] = this.response;
    data['responseStatusCode'] = this.responseStatusCode;
    data['webhookEventId'] = this.webhookEventId;
    data['webhookName'] = this.webhookName;
    return data;
  }
}

export interface IGetAllSendAttemptsOutput {
  creationTime: moment.Moment;
  data: string | undefined;
  id: string;
  response: string | undefined;
  responseStatusCode: HttpStatusCode;
  webhookEventId: string;
  webhookName: string | undefined;
}

export class GetAllSubscriptionsOutput implements IGetAllSubscriptionsOutput {
  isActive!: boolean;
  webhooks!: string[] | undefined;
  webhookUri!: string | undefined;
  id!: string;

  constructor(data?: IGetAllSubscriptionsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
      if (Array.isArray(_data['webhooks'])) {
        this.webhooks = [] as any;
        for (let item of _data['webhooks']) this.webhooks!.push(item);
      }
      this.webhookUri = _data['webhookUri'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): GetAllSubscriptionsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetAllSubscriptionsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    if (Array.isArray(this.webhooks)) {
      data['webhooks'] = [];
      for (let item of this.webhooks) data['webhooks'].push(item);
    }
    data['webhookUri'] = this.webhookUri;
    data['id'] = this.id;
    return data;
  }
}

export interface IGetAllSubscriptionsOutput {
  isActive: boolean;
  webhooks: string[] | undefined;
  webhookUri: string | undefined;
  id: string;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
  application!: ApplicationInfoDto;
  tenant!: TenantLoginInfoDto;
  theme!: UiCustomizationSettingsDto;
  user!: UserLoginInfoDto;

  constructor(data?: IGetCurrentLoginInformationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.application = _data['application'] ? ApplicationInfoDto.fromJS(_data['application']) : <any>undefined;
      this.tenant = _data['tenant'] ? TenantLoginInfoDto.fromJS(_data['tenant']) : <any>undefined;
      this.theme = _data['theme'] ? UiCustomizationSettingsDto.fromJS(_data['theme']) : <any>undefined;
      this.user = _data['user'] ? UserLoginInfoDto.fromJS(_data['user']) : <any>undefined;
    }
  }

  static fromJS(data: any): GetCurrentLoginInformationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetCurrentLoginInformationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['application'] = this.application ? this.application.toJSON() : <any>undefined;
    data['tenant'] = this.tenant ? this.tenant.toJSON() : <any>undefined;
    data['theme'] = this.theme ? this.theme.toJSON() : <any>undefined;
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetCurrentLoginInformationsOutput {
  application: ApplicationInfoDto;
  tenant: TenantLoginInfoDto;
  theme: UiCustomizationSettingsDto;
  user: UserLoginInfoDto;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
  flags!: ComboboxItemDto[] | undefined;
  language!: ApplicationLanguageEditDto;
  languageNames!: ComboboxItemDto[] | undefined;

  constructor(data?: IGetLanguageForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['flags'])) {
        this.flags = [] as any;
        for (let item of _data['flags']) this.flags!.push(ComboboxItemDto.fromJS(item));
      }
      this.language = _data['language'] ? ApplicationLanguageEditDto.fromJS(_data['language']) : <any>undefined;
      if (Array.isArray(_data['languageNames'])) {
        this.languageNames = [] as any;
        for (let item of _data['languageNames']) this.languageNames!.push(ComboboxItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetLanguageForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetLanguageForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.flags)) {
      data['flags'] = [];
      for (let item of this.flags) data['flags'].push(item.toJSON());
    }
    data['language'] = this.language ? this.language.toJSON() : <any>undefined;
    if (Array.isArray(this.languageNames)) {
      data['languageNames'] = [];
      for (let item of this.languageNames) data['languageNames'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetLanguageForEditOutput {
  flags: ComboboxItemDto[] | undefined;
  language: ApplicationLanguageEditDto;
  languageNames: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
  defaultLanguageName!: string | undefined;
  items!: ApplicationLanguageListDto[] | undefined;

  constructor(data?: IGetLanguagesOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultLanguageName = _data['defaultLanguageName'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ApplicationLanguageListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetLanguagesOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetLanguagesOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['defaultLanguageName'] = this.defaultLanguageName;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetLanguagesOutput {
  defaultLanguageName: string | undefined;
  items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
  latestWebLogLines!: string[] | undefined;

  constructor(data?: IGetLatestWebLogsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['latestWebLogLines'])) {
        this.latestWebLogLines = [] as any;
        for (let item of _data['latestWebLogLines']) this.latestWebLogLines!.push(item);
      }
    }
  }

  static fromJS(data: any): GetLatestWebLogsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetLatestWebLogsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.latestWebLogLines)) {
      data['latestWebLogLines'] = [];
      for (let item of this.latestWebLogLines) data['latestWebLogLines'].push(item);
    }
    return data;
  }
}

export interface IGetLatestWebLogsOutput {
  latestWebLogLines: string[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
  notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;
  receiveNotifications!: boolean;

  constructor(data?: IGetNotificationSettingsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['notifications'])) {
        this.notifications = [] as any;
        for (let item of _data['notifications']) this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
      }
      this.receiveNotifications = _data['receiveNotifications'];
    }
  }

  static fromJS(data: any): GetNotificationSettingsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetNotificationSettingsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.notifications)) {
      data['notifications'] = [];
      for (let item of this.notifications) data['notifications'].push(item.toJSON());
    }
    data['receiveNotifications'] = this.receiveNotifications;
    return data;
  }
}

export interface IGetNotificationSettingsOutput {
  notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
  receiveNotifications: boolean;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
  unreadCount!: number;
  totalCount!: number;
  items!: UserNotification[] | undefined;

  constructor(data?: IGetNotificationsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.unreadCount = _data['unreadCount'];
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(UserNotification.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetNotificationsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetNotificationsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['unreadCount'] = this.unreadCount;
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetNotificationsOutput {
  unreadCount: number;
  totalCount: number;
  items: UserNotification[] | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
  setting!: PasswordComplexitySetting;

  constructor(data?: IGetPasswordComplexitySettingOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.setting = _data['setting'] ? PasswordComplexitySetting.fromJS(_data['setting']) : <any>undefined;
    }
  }

  static fromJS(data: any): GetPasswordComplexitySettingOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetPasswordComplexitySettingOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['setting'] = this.setting ? this.setting.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetPasswordComplexitySettingOutput {
  setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
  profilePicture!: string | undefined;

  constructor(data?: IGetProfilePictureOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profilePicture = _data['profilePicture'];
    }
  }

  static fromJS(data: any): GetProfilePictureOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetProfilePictureOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profilePicture'] = this.profilePicture;
    return data;
  }
}

export interface IGetProfilePictureOutput {
  profilePicture: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
  grantedPermissionNames!: string[] | undefined;
  permissions!: FlatPermissionDto[] | undefined;
  role!: RoleEditDto;

  constructor(data?: IGetRoleForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['grantedPermissionNames'])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames!.push(item);
      }
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(FlatPermissionDto.fromJS(item));
      }
      this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : <any>undefined;
    }
  }

  static fromJS(data: any): GetRoleForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetRoleForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.grantedPermissionNames)) {
      data['grantedPermissionNames'] = [];
      for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
    }
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item.toJSON());
    }
    data['role'] = this.role ? this.role.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetRoleForEditOutput {
  grantedPermissionNames: string[] | undefined;
  permissions: FlatPermissionDto[] | undefined;
  role: RoleEditDto;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
  features!: FlatFeatureDto[] | undefined;
  featureValues!: NameValueDto[] | undefined;

  constructor(data?: IGetTenantFeaturesEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['features'])) {
        this.features = [] as any;
        for (let item of _data['features']) this.features!.push(FlatFeatureDto.fromJS(item));
      }
      if (Array.isArray(_data['featureValues'])) {
        this.featureValues = [] as any;
        for (let item of _data['featureValues']) this.featureValues!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetTenantFeaturesEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetTenantFeaturesEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.features)) {
      data['features'] = [];
      for (let item of this.features) data['features'].push(item.toJSON());
    }
    if (Array.isArray(this.featureValues)) {
      data['featureValues'] = [];
      for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetTenantFeaturesEditOutput {
  features: FlatFeatureDto[] | undefined;
  featureValues: NameValueDto[] | undefined;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
  friends!: FriendshipDto[] | undefined;
  serverTime!: moment.Moment;

  constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['friends'])) {
        this.friends = [] as any;
        for (let item of _data['friends']) this.friends!.push(FriendshipDto.fromJS(item));
      }
      this.serverTime = _data['serverTime'] ? moment(_data['serverTime'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUserChatFriendsWithSettingsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.friends)) {
      data['friends'] = [];
      for (let item of this.friends) data['friends'].push(item.toJSON());
    }
    data['serverTime'] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
    return data;
  }
}

export interface IGetUserChatFriendsWithSettingsOutput {
  friends: FriendshipDto[] | undefined;
  serverTime: moment.Moment;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
  profilePictureId!: string | undefined;
  roles!: UserRoleDto[] | undefined;
  user!: UserEditDto;

  constructor(data?: IGetUserForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profilePictureId = _data['profilePictureId'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(UserRoleDto.fromJS(item));
      }
      this.user = _data['user'] ? UserEditDto.fromJS(_data['user']) : <any>undefined;
    }
  }

  static fromJS(data: any): GetUserForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUserForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profilePictureId'] = this.profilePictureId;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item.toJSON());
    }
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetUserForEditOutput {
  profilePictureId: string | undefined;
  roles: UserRoleDto[] | undefined;
  user: UserEditDto;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
  grantedPermissionNames!: string[] | undefined;
  permissions!: FlatPermissionDto[] | undefined;

  constructor(data?: IGetUserPermissionsForEditOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['grantedPermissionNames'])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames!.push(item);
      }
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(FlatPermissionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetUserPermissionsForEditOutput {
    data = typeof data === 'object' ? data : {};
    let result = new GetUserPermissionsForEditOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.grantedPermissionNames)) {
      data['grantedPermissionNames'] = [];
      for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
    }
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetUserPermissionsForEditOutput {
  grantedPermissionNames: string[] | undefined;
  permissions: FlatPermissionDto[] | undefined;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  userInfoEndpoint!: string | undefined;

  constructor(data?: IGoogleExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientSecret = _data['clientSecret'];
      this.userInfoEndpoint = _data['userInfoEndpoint'];
    }
  }

  static fromJS(data: any): GoogleExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new GoogleExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientSecret'] = this.clientSecret;
    data['userInfoEndpoint'] = this.userInfoEndpoint;
    return data;
  }
}

export interface IGoogleExternalLoginProviderSettings {
  clientId: string | undefined;
  clientSecret: string | undefined;
  userInfoEndpoint: string | undefined;
}

export class GoogleSettingsEditDto implements IGoogleSettingsEditDto {
  analytics!: string | undefined;
  recaptchaSiteKey!: string | undefined;
  tag!: string | undefined;

  constructor(data?: IGoogleSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.analytics = _data['analytics'];
      this.recaptchaSiteKey = _data['recaptchaSiteKey'];
      this.tag = _data['tag'];
    }
  }

  static fromJS(data: any): GoogleSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new GoogleSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['analytics'] = this.analytics;
    data['recaptchaSiteKey'] = this.recaptchaSiteKey;
    data['tag'] = this.tag;
    return data;
  }
}

export interface IGoogleSettingsEditDto {
  analytics: string | undefined;
  recaptchaSiteKey: string | undefined;
  tag: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
  azureActiveDirectory!: AzureActiveDirectorySettingsEditDto;
  email!: EmailSettingsEditDto;
  externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto;
  general!: GeneralSettingsEditDto;
  google!: GoogleSettingsEditDto;
  ldap!: LdapSettingsEditDto;
  security!: SecuritySettingsEditDto;
  userManagement!: HostUserManagementSettingsEditDto;
  logDeleter!: ExpiredEntityLogDeleterSettingsEditDto;
  loginImpersonator!: ExpiredEntityLoginImpersonatorSettingsEditDto;

  constructor(data?: IHostSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.email = new EmailSettingsEditDto();
      this.general = new GeneralSettingsEditDto();
      this.security = new SecuritySettingsEditDto();
      this.userManagement = new HostUserManagementSettingsEditDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.azureActiveDirectory = _data['azureActiveDirectory']
        ? AzureActiveDirectorySettingsEditDto.fromJS(_data['azureActiveDirectory'])
        : <any>undefined;
      this.email = _data['email'] ? EmailSettingsEditDto.fromJS(_data['email']) : new EmailSettingsEditDto();
      this.externalLoginProviderSettings = _data['externalLoginProviderSettings']
        ? ExternalLoginProviderSettingsEditDto.fromJS(_data['externalLoginProviderSettings'])
        : <any>undefined;
      this.general = _data['general'] ? GeneralSettingsEditDto.fromJS(_data['general']) : new GeneralSettingsEditDto();
      this.google = _data['google'] ? GoogleSettingsEditDto.fromJS(_data['google']) : <any>undefined;
      this.ldap = _data['ldap'] ? LdapSettingsEditDto.fromJS(_data['ldap']) : <any>undefined;
      this.security = _data['security'] ? SecuritySettingsEditDto.fromJS(_data['security']) : new SecuritySettingsEditDto();
      this.userManagement = _data['userManagement']
        ? HostUserManagementSettingsEditDto.fromJS(_data['userManagement'])
        : new HostUserManagementSettingsEditDto();
      this.logDeleter = _data['logDeleter'] ? ExpiredEntityLogDeleterSettingsEditDto.fromJS(_data['logDeleter']) : <any>undefined;
      this.loginImpersonator = _data['loginImpersonator']
        ? ExpiredEntityLoginImpersonatorSettingsEditDto.fromJS(_data['loginImpersonator'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): HostSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new HostSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['azureActiveDirectory'] = this.azureActiveDirectory ? this.azureActiveDirectory.toJSON() : <any>undefined;
    data['email'] = this.email ? this.email.toJSON() : <any>undefined;
    data['externalLoginProviderSettings'] = this.externalLoginProviderSettings
      ? this.externalLoginProviderSettings.toJSON()
      : <any>undefined;
    data['general'] = this.general ? this.general.toJSON() : <any>undefined;
    data['google'] = this.google ? this.google.toJSON() : <any>undefined;
    data['ldap'] = this.ldap ? this.ldap.toJSON() : <any>undefined;
    data['security'] = this.security ? this.security.toJSON() : <any>undefined;
    data['userManagement'] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
    data['logDeleter'] = this.logDeleter ? this.logDeleter.toJSON() : <any>undefined;
    data['loginImpersonator'] = this.loginImpersonator ? this.loginImpersonator.toJSON() : <any>undefined;
    return data;
  }
}

export interface IHostSettingsEditDto {
  azureActiveDirectory: AzureActiveDirectorySettingsEditDto;
  email: EmailSettingsEditDto;
  externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto;
  general: GeneralSettingsEditDto;
  google: GoogleSettingsEditDto;
  ldap: LdapSettingsEditDto;
  security: SecuritySettingsEditDto;
  userManagement: HostUserManagementSettingsEditDto;
  logDeleter: ExpiredEntityLogDeleterSettingsEditDto;
  loginImpersonator: ExpiredEntityLoginImpersonatorSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
  allowOneConcurrentLoginPerUser!: boolean;
  isCookieConsentEnabled!: boolean;
  isEmailConfirmationRequiredForLogin!: boolean;
  isRegisterRequiredForLogin!: boolean;
  storeExternalTokenInformation!: boolean;
  tokenExpiration!: number;
  useCaptchaOnLogin!: boolean;

  constructor(data?: IHostUserManagementSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowOneConcurrentLoginPerUser = _data['allowOneConcurrentLoginPerUser'];
      this.isCookieConsentEnabled = _data['isCookieConsentEnabled'];
      this.isEmailConfirmationRequiredForLogin = _data['isEmailConfirmationRequiredForLogin'];
      this.isRegisterRequiredForLogin = _data['isRegisterRequiredForLogin'];
      this.storeExternalTokenInformation = _data['storeExternalTokenInformation'];
      this.tokenExpiration = _data['tokenExpiration'];
      this.useCaptchaOnLogin = _data['useCaptchaOnLogin'];
    }
  }

  static fromJS(data: any): HostUserManagementSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new HostUserManagementSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['allowOneConcurrentLoginPerUser'] = this.allowOneConcurrentLoginPerUser;
    data['isCookieConsentEnabled'] = this.isCookieConsentEnabled;
    data['isEmailConfirmationRequiredForLogin'] = this.isEmailConfirmationRequiredForLogin;
    data['isRegisterRequiredForLogin'] = this.isRegisterRequiredForLogin;
    data['storeExternalTokenInformation'] = this.storeExternalTokenInformation;
    data['tokenExpiration'] = this.tokenExpiration;
    data['useCaptchaOnLogin'] = this.useCaptchaOnLogin;
    return data;
  }
}

export interface IHostUserManagementSettingsEditDto {
  allowOneConcurrentLoginPerUser: boolean;
  isCookieConsentEnabled: boolean;
  isEmailConfirmationRequiredForLogin: boolean;
  isRegisterRequiredForLogin: boolean;
  storeExternalTokenInformation: boolean;
  tokenExpiration: number;
  useCaptchaOnLogin: boolean;
}

export enum HttpStatusCode {
  Continue = 100,
  SwitchingProtocols = 101,
  Processing = 102,
  EarlyHints = 103,
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NoContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultiStatus = 207,
  AlreadyReported = 208,
  IMUsed = 226,
  MultipleChoices = 300,
  Ambiguous = 301,
  MovedPermanently = 302,
  Moved = 303,
  Found = 304,
  Redirect = 305,
  SeeOther = 306,
  RedirectMethod = 307,
  NotModified = 308,
  UseProxy = 400,
  Unused = 401,
  TemporaryRedirect = 402,
  RedirectKeepVerb = 403,
  PermanentRedirect = 404,
  BadRequest = 405,
  Unauthorized = 406,
  PaymentRequired = 407,
  Forbidden = 408,
  NotFound = 409,
  MethodNotAllowed = 410,
  NotAcceptable = 411,
  ProxyAuthenticationRequired = 412,
  RequestTimeout = 413,
  Conflict = 414,
  Gone = 415,
  LengthRequired = 416,
  PreconditionFailed = 417,
  RequestEntityTooLarge = 421,
  RequestUriTooLong = 422,
  UnsupportedMediaType = 423,
  RequestedRangeNotSatisfiable = 424,
  ExpectationFailed = 426,
  MisdirectedRequest = 428,
  UnprocessableEntity = 429,
  UnprocessableContent = 431,
  Locked = 451,
  FailedDependency = 500,
  UpgradeRequired = 501,
  PreconditionRequired = 502,
  TooManyRequests = 503,
  RequestHeaderFieldsTooLarge = 504,
  UnavailableForLegalReasons = 505,
  InternalServerError = 506,
  NotImplemented = 507,
  BadGateway = 508,
  ServiceUnavailable = 510,
  GatewayTimeout = 511,
}

export class IValueValidator implements IIValueValidator {
  readonly attributes!: { [key: string]: any } | undefined;
  readonly name!: string | undefined;

  constructor(data?: IIValueValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['attributes']) {
        (<any>this).attributes = {} as any;
        for (let key in _data['attributes']) {
          if (_data['attributes'].hasOwnProperty(key)) (<any>(<any>this).attributes)![key] = _data['attributes'][key];
        }
      }
      (<any>this).name = _data['name'];
    }
  }

  static fromJS(data: any): IValueValidator {
    data = typeof data === 'object' ? data : {};
    let result = new IValueValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.attributes) {
      data['attributes'] = {};
      for (let key in this.attributes) {
        if (this.attributes.hasOwnProperty(key)) (<any>data['attributes'])[key] = (<any>this.attributes)[key];
      }
    }
    data['name'] = this.name;
    return data;
  }
}

export interface IIValueValidator {
  attributes: { [key: string]: any } | undefined;
  name: string | undefined;
}

export class ImpersonateInput implements IImpersonateInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IImpersonateInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ImpersonateInput {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonateInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IImpersonateInput {
  tenantId: number | undefined;
  userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
  impersonationToken!: string | undefined;
  tenancyName!: string | undefined;

  constructor(data?: IImpersonateOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.impersonationToken = _data['impersonationToken'];
      this.tenancyName = _data['tenancyName'];
    }
  }

  static fromJS(data: any): ImpersonateOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonateOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['impersonationToken'] = this.impersonationToken;
    data['tenancyName'] = this.tenancyName;
    return data;
  }
}

export interface IImpersonateOutput {
  impersonationToken: string | undefined;
  tenancyName: string | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
  accessToken!: string | undefined;
  encryptedAccessToken!: string | undefined;
  expireInSeconds!: number;

  constructor(data?: IImpersonatedAuthenticateResultModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.accessToken = _data['accessToken'];
      this.encryptedAccessToken = _data['encryptedAccessToken'];
      this.expireInSeconds = _data['expireInSeconds'];
    }
  }

  static fromJS(data: any): ImpersonatedAuthenticateResultModel {
    data = typeof data === 'object' ? data : {};
    let result = new ImpersonatedAuthenticateResultModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['accessToken'] = this.accessToken;
    data['encryptedAccessToken'] = this.encryptedAccessToken;
    data['expireInSeconds'] = this.expireInSeconds;
    return data;
  }
}

export interface IImpersonatedAuthenticateResultModel {
  accessToken: string | undefined;
  encryptedAccessToken: string | undefined;
  expireInSeconds: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
  tenancyName!: string;

  constructor(data?: IIsTenantAvailableInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenancyName = _data['tenancyName'];
    }
  }

  static fromJS(data: any): IsTenantAvailableInput {
    data = typeof data === 'object' ? data : {};
    let result = new IsTenantAvailableInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenancyName'] = this.tenancyName;
    return data;
  }
}

export interface IIsTenantAvailableInput {
  tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
  serverRootAddress!: string | undefined;
  state!: TenantAvailabilityState;
  tenantId!: number | undefined;

  constructor(data?: IIsTenantAvailableOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serverRootAddress = _data['serverRootAddress'];
      this.state = _data['state'];
      this.tenantId = _data['tenantId'];
    }
  }

  static fromJS(data: any): IsTenantAvailableOutput {
    data = typeof data === 'object' ? data : {};
    let result = new IsTenantAvailableOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['serverRootAddress'] = this.serverRootAddress;
    data['state'] = this.state;
    data['tenantId'] = this.tenantId;
    return data;
  }
}

export interface IIsTenantAvailableOutput {
  serverRootAddress: string | undefined;
  state: TenantAvailabilityState;
  tenantId: number | undefined;
}

export class ItensBriefingGolDto implements IItensBriefingGolDto {
  matricula!: string | undefined;
  dep!: string | undefined;
  arr!: string | undefined;
  voosNetLine!: string | undefined;
  msnPopUp!: string | undefined;
  remainingFuel!: string | undefined;
  importantAlert!: string | undefined;
  costIndexOperacao!: string | undefined;
  costIndexEngenharia!: string | undefined;
  listAbaBriefing!: AbaBriefing[] | undefined;
  listAbaNotam!: AbaNotam[] | undefined;
  listAbaNotamSupl!: AbaNotamSupl[] | undefined;
  listAbaExtraFual!: AbaExtraFual[] | undefined;
  listAbaMinimumsDEP!: CompleteObjectMinimumDto[] | undefined;
  listAbaMinimumsARR!: CompleteObjectMinimumDto[] | undefined;
  listAbaAlternate!: AbaAlternate[] | undefined;

  constructor(data?: IItensBriefingGolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.matricula = _data['matricula'];
      this.dep = _data['dep'];
      this.arr = _data['arr'];
      this.voosNetLine = _data['voosNetLine'];
      this.msnPopUp = _data['msnPopUp'];
      this.remainingFuel = _data['remainingFuel'];
      this.importantAlert = _data['importantAlert'];
      this.costIndexOperacao = _data['costIndexOperacao'];
      this.costIndexEngenharia = _data['costIndexEngenharia'];
      if (Array.isArray(_data['listAbaBriefing'])) {
        this.listAbaBriefing = [] as any;
        for (let item of _data['listAbaBriefing']) this.listAbaBriefing!.push(AbaBriefing.fromJS(item));
      }
      if (Array.isArray(_data['listAbaNotam'])) {
        this.listAbaNotam = [] as any;
        for (let item of _data['listAbaNotam']) this.listAbaNotam!.push(AbaNotam.fromJS(item));
      }
      if (Array.isArray(_data['listAbaNotamSupl'])) {
        this.listAbaNotamSupl = [] as any;
        for (let item of _data['listAbaNotamSupl']) this.listAbaNotamSupl!.push(AbaNotamSupl.fromJS(item));
      }
      if (Array.isArray(_data['listAbaExtraFual'])) {
        this.listAbaExtraFual = [] as any;
        for (let item of _data['listAbaExtraFual']) this.listAbaExtraFual!.push(AbaExtraFual.fromJS(item));
      }
      if (Array.isArray(_data['listAbaMinimumsDEP'])) {
        this.listAbaMinimumsDEP = [] as any;
        for (let item of _data['listAbaMinimumsDEP']) this.listAbaMinimumsDEP!.push(CompleteObjectMinimumDto.fromJS(item));
      }
      if (Array.isArray(_data['listAbaMinimumsARR'])) {
        this.listAbaMinimumsARR = [] as any;
        for (let item of _data['listAbaMinimumsARR']) this.listAbaMinimumsARR!.push(CompleteObjectMinimumDto.fromJS(item));
      }
      if (Array.isArray(_data['listAbaAlternate'])) {
        this.listAbaAlternate = [] as any;
        for (let item of _data['listAbaAlternate']) this.listAbaAlternate!.push(AbaAlternate.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ItensBriefingGolDto {
    data = typeof data === 'object' ? data : {};
    let result = new ItensBriefingGolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['matricula'] = this.matricula;
    data['dep'] = this.dep;
    data['arr'] = this.arr;
    data['voosNetLine'] = this.voosNetLine;
    data['msnPopUp'] = this.msnPopUp;
    data['remainingFuel'] = this.remainingFuel;
    data['importantAlert'] = this.importantAlert;
    data['costIndexOperacao'] = this.costIndexOperacao;
    data['costIndexEngenharia'] = this.costIndexEngenharia;
    if (Array.isArray(this.listAbaBriefing)) {
      data['listAbaBriefing'] = [];
      for (let item of this.listAbaBriefing) data['listAbaBriefing'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaNotam)) {
      data['listAbaNotam'] = [];
      for (let item of this.listAbaNotam) data['listAbaNotam'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaNotamSupl)) {
      data['listAbaNotamSupl'] = [];
      for (let item of this.listAbaNotamSupl) data['listAbaNotamSupl'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaExtraFual)) {
      data['listAbaExtraFual'] = [];
      for (let item of this.listAbaExtraFual) data['listAbaExtraFual'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaMinimumsDEP)) {
      data['listAbaMinimumsDEP'] = [];
      for (let item of this.listAbaMinimumsDEP) data['listAbaMinimumsDEP'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaMinimumsARR)) {
      data['listAbaMinimumsARR'] = [];
      for (let item of this.listAbaMinimumsARR) data['listAbaMinimumsARR'].push(item.toJSON());
    }
    if (Array.isArray(this.listAbaAlternate)) {
      data['listAbaAlternate'] = [];
      for (let item of this.listAbaAlternate) data['listAbaAlternate'].push(item.toJSON());
    }
    return data;
  }
}

export interface IItensBriefingGolDto {
  matricula: string | undefined;
  dep: string | undefined;
  arr: string | undefined;
  voosNetLine: string | undefined;
  msnPopUp: string | undefined;
  remainingFuel: string | undefined;
  importantAlert: string | undefined;
  costIndexOperacao: string | undefined;
  costIndexEngenharia: string | undefined;
  listAbaBriefing: AbaBriefing[] | undefined;
  listAbaNotam: AbaNotam[] | undefined;
  listAbaNotamSupl: AbaNotamSupl[] | undefined;
  listAbaExtraFual: AbaExtraFual[] | undefined;
  listAbaMinimumsDEP: CompleteObjectMinimumDto[] | undefined;
  listAbaMinimumsARR: CompleteObjectMinimumDto[] | undefined;
  listAbaAlternate: AbaAlternate[] | undefined;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
  claim!: string | undefined;
  key!: string | undefined;

  constructor(data?: IJsonClaimMapDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.claim = _data['claim'];
      this.key = _data['key'];
    }
  }

  static fromJS(data: any): JsonClaimMapDto {
    data = typeof data === 'object' ? data : {};
    let result = new JsonClaimMapDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['claim'] = this.claim;
    data['key'] = this.key;
    return data;
  }
}

export interface IJsonClaimMapDto {
  claim: string | undefined;
  key: string | undefined;
}

export class LanguageInfo implements ILanguageInfo {
  displayName!: string | undefined;
  icon!: string | undefined;
  isDefault!: boolean;
  isDisabled!: boolean;
  readonly isRightToLeft!: boolean;
  name!: string | undefined;

  constructor(data?: ILanguageInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data['displayName'];
      this.icon = _data['icon'];
      this.isDefault = _data['isDefault'];
      this.isDisabled = _data['isDisabled'];
      (<any>this).isRightToLeft = _data['isRightToLeft'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): LanguageInfo {
    data = typeof data === 'object' ? data : {};
    let result = new LanguageInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayName'] = this.displayName;
    data['icon'] = this.icon;
    data['isDefault'] = this.isDefault;
    data['isDisabled'] = this.isDisabled;
    data['isRightToLeft'] = this.isRightToLeft;
    data['name'] = this.name;
    return data;
  }
}

export interface ILanguageInfo {
  displayName: string | undefined;
  icon: string | undefined;
  isDefault: boolean;
  isDisabled: boolean;
  isRightToLeft: boolean;
  name: string | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
  baseValue!: string | undefined;
  key!: string | undefined;
  targetValue!: string | undefined;

  constructor(data?: ILanguageTextListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.baseValue = _data['baseValue'];
      this.key = _data['key'];
      this.targetValue = _data['targetValue'];
    }
  }

  static fromJS(data: any): LanguageTextListDto {
    data = typeof data === 'object' ? data : {};
    let result = new LanguageTextListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['baseValue'] = this.baseValue;
    data['key'] = this.key;
    data['targetValue'] = this.targetValue;
    return data;
  }
}

export interface ILanguageTextListDto {
  baseValue: string | undefined;
  key: string | undefined;
  targetValue: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
  domain!: string | undefined;
  isEnabled!: boolean;
  isModuleEnabled!: boolean;
  password!: string | undefined;
  userName!: string | undefined;

  constructor(data?: ILdapSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.domain = _data['domain'];
      this.isEnabled = _data['isEnabled'];
      this.isModuleEnabled = _data['isModuleEnabled'];
      this.password = _data['password'];
      this.userName = _data['userName'];
    }
  }

  static fromJS(data: any): LdapSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new LdapSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['domain'] = this.domain;
    data['isEnabled'] = this.isEnabled;
    data['isModuleEnabled'] = this.isModuleEnabled;
    data['password'] = this.password;
    data['userName'] = this.userName;
    return data;
  }
}

export interface ILdapSettingsEditDto {
  domain: string | undefined;
  isEnabled: boolean;
  isModuleEnabled: boolean;
  password: string | undefined;
  userName: string | undefined;
}

export class LineChartDto implements ILineChartDto {
  name!: string | undefined;
  maxValue!: number;
  minValue!: number;
  sunValue!: number;
  series!: LineChartSeriesDto[] | undefined;

  constructor(data?: ILineChartDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.maxValue = _data['maxValue'];
      this.minValue = _data['minValue'];
      this.sunValue = _data['sunValue'];
      if (Array.isArray(_data['series'])) {
        this.series = [] as any;
        for (let item of _data['series']) this.series!.push(LineChartSeriesDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LineChartDto {
    data = typeof data === 'object' ? data : {};
    let result = new LineChartDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['maxValue'] = this.maxValue;
    data['minValue'] = this.minValue;
    data['sunValue'] = this.sunValue;
    if (Array.isArray(this.series)) {
      data['series'] = [];
      for (let item of this.series) data['series'].push(item.toJSON());
    }
    return data;
  }
}

export interface ILineChartDto {
  name: string | undefined;
  maxValue: number;
  minValue: number;
  sunValue: number;
  series: LineChartSeriesDto[] | undefined;
}

export class LineChartSeriesDto implements ILineChartSeriesDto {
  name!: string | undefined;
  value!: number;

  constructor(data?: ILineChartSeriesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): LineChartSeriesDto {
    data = typeof data === 'object' ? data : {};
    let result = new LineChartSeriesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    return data;
  }
}

export interface ILineChartSeriesDto {
  name: string | undefined;
  value: number;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
  items!: CacheDto[] | undefined;

  constructor(data?: IListResultDtoOfCacheDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CacheDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfCacheDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfCacheDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfCacheDto {
  items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
  items!: ChatMessageDto[] | undefined;

  constructor(data?: IListResultDtoOfChatMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ChatMessageDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfChatMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfChatMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfChatMessageDto {
  items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
  items!: FlatPermissionWithLevelDto[] | undefined;

  constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfFlatPermissionWithLevelDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
  items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfGetAllAvailableWebhooksOutput implements IListResultDtoOfGetAllAvailableWebhooksOutput {
  items!: GetAllAvailableWebhooksOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllAvailableWebhooksOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(GetAllAvailableWebhooksOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllAvailableWebhooksOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllAvailableWebhooksOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllAvailableWebhooksOutput {
  items: GetAllAvailableWebhooksOutput[] | undefined;
}

export class ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput implements IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
  items!: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(GetAllSendAttemptsOfWebhookEventOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllSendAttemptsOfWebhookEventOutput {
  items: GetAllSendAttemptsOfWebhookEventOutput[] | undefined;
}

export class ListResultDtoOfGetAllSubscriptionsOutput implements IListResultDtoOfGetAllSubscriptionsOutput {
  items!: GetAllSubscriptionsOutput[] | undefined;

  constructor(data?: IListResultDtoOfGetAllSubscriptionsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(GetAllSubscriptionsOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfGetAllSubscriptionsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfGetAllSubscriptionsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfGetAllSubscriptionsOutput {
  items: GetAllSubscriptionsOutput[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
  items!: NameValueDto[] | undefined;

  constructor(data?: IListResultDtoOfNameValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfNameValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfNameValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfNameValueDto {
  items: NameValueDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
  items!: RoleListDto[] | undefined;

  constructor(data?: IListResultDtoOfRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(RoleListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfRoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfRoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfRoleListDto {
  items: RoleListDto[] | undefined;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
  items!: UserLoginAttemptDto[] | undefined;

  constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(UserLoginAttemptDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
    data = typeof data === 'object' ? data : {};
    let result = new ListResultDtoOfUserLoginAttemptDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDtoOfUserLoginAttemptDto {
  items: UserLoginAttemptDto[] | undefined;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
  displayText!: string | undefined;
  value!: string | undefined;

  constructor(data?: ILocalizableComboboxItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayText = _data['displayText'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): LocalizableComboboxItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new LocalizableComboboxItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayText'] = this.displayText;
    data['value'] = this.value;
    return data;
  }
}

export interface ILocalizableComboboxItemDto {
  displayText: string | undefined;
  value: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
  items!: LocalizableComboboxItemDto[] | undefined;

  constructor(data?: ILocalizableComboboxItemSourceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(LocalizableComboboxItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): LocalizableComboboxItemSourceDto {
    data = typeof data === 'object' ? data : {};
    let result = new LocalizableComboboxItemSourceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface ILocalizableComboboxItemSourceDto {
  items: LocalizableComboboxItemDto[] | undefined;
}

export class MELDto implements IMELDto {
  user!: User;
  userId!: number;
  prefix!: string | undefined;
  melItem!: MELItem;
  melItemId!: number;
  melTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IMELDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.prefix = _data['prefix'];
      this.melItem = _data['melItem'] ? MELItem.fromJS(_data['melItem']) : <any>undefined;
      this.melItemId = _data['melItemId'];
      this.melTime = _data['melTime'] ? moment(_data['melTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): MELDto {
    data = typeof data === 'object' ? data : {};
    let result = new MELDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['prefix'] = this.prefix;
    data['melItem'] = this.melItem ? this.melItem.toJSON() : <any>undefined;
    data['melItemId'] = this.melItemId;
    data['melTime'] = this.melTime ? this.melTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IMELDto {
  user: User;
  userId: number;
  prefix: string | undefined;
  melItem: MELItem;
  melItemId: number;
  melTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class MELItem implements IMELItem {
  user!: User;
  userId!: number;
  description!: string | undefined;
  disrepancy!: string | undefined;
  restriction!: string | undefined;
  melItemTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IMELItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.description = _data['description'];
      this.disrepancy = _data['disrepancy'];
      this.restriction = _data['restriction'];
      this.melItemTime = _data['melItemTime'] ? moment(_data['melItemTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): MELItem {
    data = typeof data === 'object' ? data : {};
    let result = new MELItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['description'] = this.description;
    data['disrepancy'] = this.disrepancy;
    data['restriction'] = this.restriction;
    data['melItemTime'] = this.melItemTime ? this.melItemTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IMELItem {
  user: User;
  userId: number;
  description: string | undefined;
  disrepancy: string | undefined;
  restriction: string | undefined;
  melItemTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class MELItemDto implements IMELItemDto {
  user!: User;
  userId!: number;
  description!: string | undefined;
  disrepancy!: string | undefined;
  restriction!: string | undefined;
  melItemTime!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IMELItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.description = _data['description'];
      this.disrepancy = _data['disrepancy'];
      this.restriction = _data['restriction'];
      this.melItemTime = _data['melItemTime'] ? moment(_data['melItemTime'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): MELItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new MELItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['description'] = this.description;
    data['disrepancy'] = this.disrepancy;
    data['restriction'] = this.restriction;
    data['melItemTime'] = this.melItemTime ? this.melItemTime.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IMELItemDto {
  user: User;
  userId: number;
  description: string | undefined;
  disrepancy: string | undefined;
  restriction: string | undefined;
  melItemTime: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
  tenantId!: number | undefined;
  userId!: number | undefined;
  groupId!: number | undefined;

  constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.groupId = _data['groupId'];
    }
  }

  static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
    data = typeof data === 'object' ? data : {};
    let result = new MarkAllUnreadMessagesOfUserAsReadInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['groupId'] = this.groupId;
    return data;
  }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
  tenantId: number | undefined;
  userId: number | undefined;
  groupId: number | undefined;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  tenantId!: string | undefined;

  constructor(data?: IMicrosoftExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.clientId = _data['clientId'];
      this.clientSecret = _data['clientSecret'];
      this.tenantId = _data['tenantId'];
    }
  }

  static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new MicrosoftExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['clientId'] = this.clientId;
    data['clientSecret'] = this.clientSecret;
    data['tenantId'] = this.tenantId;
    return data;
  }
}

export interface IMicrosoftExternalLoginProviderSettings {
  clientId: string | undefined;
  clientSecret: string | undefined;
  tenantId: string | undefined;
}

export class MinimumsDto implements IMinimumsDto {
  id!: number;
  airport!: string;

  constructor(data?: IMinimumsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.airport = _data['airport'];
    }
  }

  static fromJS(data: any): MinimumsDto {
    data = typeof data === 'object' ? data : {};
    let result = new MinimumsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['airport'] = this.airport;
    return data;
  }
}

export interface IMinimumsDto {
  id: number;
  airport: string;
}

export class MinimumsItemDto implements IMinimumsItemDto {
  id!: number;
  cabeceiraDep!: string | undefined;
  rclmDep!: boolean;
  rcllDep!: boolean;
  hirlDep!: boolean;
  noRvrDep!: boolean;
  rvrOneDep!: boolean;
  rvrTwoDep!: boolean;
  diurnoDep!: string | undefined;
  noturnoDep!: string | undefined;
  observacoesDep!: string | undefined;
  cabeceiraArr!: string | undefined;
  ilsVisArr!: number | undefined;
  ilsOchArr!: number | undefined;
  rnavRnpVisArr!: number | undefined;
  rnavRnpOchArr!: number | undefined;
  rnpAr0101503VisArr!: number | undefined;
  rnpAr0101503OchArr!: number | undefined;
  observacoesArr!: string | undefined;
  minimumsId!: number;
  airport!: string | undefined;
  userCreator!: string | undefined;
  userLastModified!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;

  constructor(data?: IMinimumsItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.rclmDep = false;
      this.rcllDep = false;
      this.hirlDep = false;
      this.noRvrDep = false;
      this.rvrOneDep = false;
      this.rvrTwoDep = false;
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.cabeceiraDep = _data['cabeceiraDep'];
      this.rclmDep = _data['rclmDep'] !== undefined ? _data['rclmDep'] : false;
      this.rcllDep = _data['rcllDep'] !== undefined ? _data['rcllDep'] : false;
      this.hirlDep = _data['hirlDep'] !== undefined ? _data['hirlDep'] : false;
      this.noRvrDep = _data['noRvrDep'] !== undefined ? _data['noRvrDep'] : false;
      this.rvrOneDep = _data['rvrOneDep'] !== undefined ? _data['rvrOneDep'] : false;
      this.rvrTwoDep = _data['rvrTwoDep'] !== undefined ? _data['rvrTwoDep'] : false;
      this.diurnoDep = _data['diurnoDep'];
      this.noturnoDep = _data['noturnoDep'];
      this.observacoesDep = _data['observacoesDep'];
      this.cabeceiraArr = _data['cabeceiraArr'];
      this.ilsVisArr = _data['ilsVisArr'];
      this.ilsOchArr = _data['ilsOchArr'];
      this.rnavRnpVisArr = _data['rnavRnpVisArr'];
      this.rnavRnpOchArr = _data['rnavRnpOchArr'];
      this.rnpAr0101503VisArr = _data['rnpAr0101503VisArr'];
      this.rnpAr0101503OchArr = _data['rnpAr0101503OchArr'];
      this.observacoesArr = _data['observacoesArr'];
      this.minimumsId = _data['minimumsId'];
      this.airport = _data['airport'];
      this.userCreator = _data['userCreator'];
      this.userLastModified = _data['userLastModified'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
    }
  }

  static fromJS(data: any): MinimumsItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new MinimumsItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['cabeceiraDep'] = this.cabeceiraDep;
    data['rclmDep'] = this.rclmDep;
    data['rcllDep'] = this.rcllDep;
    data['hirlDep'] = this.hirlDep;
    data['noRvrDep'] = this.noRvrDep;
    data['rvrOneDep'] = this.rvrOneDep;
    data['rvrTwoDep'] = this.rvrTwoDep;
    data['diurnoDep'] = this.diurnoDep;
    data['noturnoDep'] = this.noturnoDep;
    data['observacoesDep'] = this.observacoesDep;
    data['cabeceiraArr'] = this.cabeceiraArr;
    data['ilsVisArr'] = this.ilsVisArr;
    data['ilsOchArr'] = this.ilsOchArr;
    data['rnavRnpVisArr'] = this.rnavRnpVisArr;
    data['rnavRnpOchArr'] = this.rnavRnpOchArr;
    data['rnpAr0101503VisArr'] = this.rnpAr0101503VisArr;
    data['rnpAr0101503OchArr'] = this.rnpAr0101503OchArr;
    data['observacoesArr'] = this.observacoesArr;
    data['minimumsId'] = this.minimumsId;
    data['airport'] = this.airport;
    data['userCreator'] = this.userCreator;
    data['userLastModified'] = this.userLastModified;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    return data;
  }
}

export interface IMinimumsItemDto {
  id: number;
  cabeceiraDep: string | undefined;
  rclmDep: boolean;
  rcllDep: boolean;
  hirlDep: boolean;
  noRvrDep: boolean;
  rvrOneDep: boolean;
  rvrTwoDep: boolean;
  diurnoDep: string | undefined;
  noturnoDep: string | undefined;
  observacoesDep: string | undefined;
  cabeceiraArr: string | undefined;
  ilsVisArr: number | undefined;
  ilsOchArr: number | undefined;
  rnavRnpVisArr: number | undefined;
  rnavRnpOchArr: number | undefined;
  rnpAr0101503VisArr: number | undefined;
  rnpAr0101503OchArr: number | undefined;
  observacoesArr: string | undefined;
  minimumsId: number;
  airport: string | undefined;
  userCreator: string | undefined;
  userLastModified: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
}

export class NameValueDto implements INameValueDto {
  name!: string | undefined;
  value!: string | undefined;

  constructor(data?: INameValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): NameValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new NameValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    return data;
  }
}

export interface INameValueDto {
  name: string | undefined;
  value: string | undefined;
}

export class NotamDto implements INotamDto {
  user!: User;
  userId!: number;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  confirmation!: string | undefined;
  equipment!: string | undefined;
  airport!: string | undefined;
  notamType!: NotamType;
  description!: string | undefined;
  supervisor!: string | undefined;
  announcement!: string | undefined;
  fuel!: moment.Moment | undefined;
  startValidate!: moment.Moment;
  endValidate!: moment.Moment;
  notamTime!: moment.Moment;
  fir!: FirDto;
  firId!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: INotamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.confirmation = _data['confirmation'];
      this.equipment = _data['equipment'];
      this.airport = _data['airport'];
      this.notamType = _data['notamType'];
      this.description = _data['description'];
      this.supervisor = _data['supervisor'];
      this.announcement = _data['announcement'];
      this.fuel = _data['fuel'] ? moment(_data['fuel'].toString()) : <any>undefined;
      this.startValidate = _data['startValidate'] ? moment(_data['startValidate'].toString()) : <any>undefined;
      this.endValidate = _data['endValidate'] ? moment(_data['endValidate'].toString()) : <any>undefined;
      this.notamTime = _data['notamTime'] ? moment(_data['notamTime'].toString()) : <any>undefined;
      this.fir = _data['fir'] ? FirDto.fromJS(_data['fir']) : <any>undefined;
      this.firId = _data['firId'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): NotamDto {
    data = typeof data === 'object' ? data : {};
    let result = new NotamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['confirmation'] = this.confirmation;
    data['equipment'] = this.equipment;
    data['airport'] = this.airport;
    data['notamType'] = this.notamType;
    data['description'] = this.description;
    data['supervisor'] = this.supervisor;
    data['announcement'] = this.announcement;
    data['fuel'] = this.fuel ? this.fuel.toISOString() : <any>undefined;
    data['startValidate'] = this.startValidate ? this.startValidate.toISOString() : <any>undefined;
    data['endValidate'] = this.endValidate ? this.endValidate.toISOString() : <any>undefined;
    data['notamTime'] = this.notamTime ? this.notamTime.toISOString() : <any>undefined;
    data['fir'] = this.fir ? this.fir.toJSON() : <any>undefined;
    data['firId'] = this.firId;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface INotamDto {
  user: User;
  userId: number;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  confirmation: string | undefined;
  equipment: string | undefined;
  airport: string | undefined;
  notamType: NotamType;
  description: string | undefined;
  supervisor: string | undefined;
  announcement: string | undefined;
  fuel: moment.Moment | undefined;
  startValidate: moment.Moment;
  endValidate: moment.Moment;
  notamTime: moment.Moment;
  fir: FirDto;
  firId: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum NotamType {
  None = 0,
  Notam = 1,
  SuplNotam = 2,
  Briefing = 3,
  ExtraFuel = 4,
  NotamGps = 5,
  Equipamento = 6,
}

export class NotificationData implements INotificationData {
  properties!: { [key: string]: any } | undefined;
  readonly type!: string | undefined;

  constructor(data?: INotificationData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['properties']) {
        this.properties = {} as any;
        for (let key in _data['properties']) {
          if (_data['properties'].hasOwnProperty(key)) (<any>this.properties)![key] = _data['properties'][key];
        }
      }
      (<any>this).type = _data['type'];
    }
  }

  static fromJS(data: any): NotificationData {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.properties) {
      data['properties'] = {};
      for (let key in this.properties) {
        if (this.properties.hasOwnProperty(key)) (<any>data['properties'])[key] = (<any>this.properties)[key];
      }
    }
    data['type'] = this.type;
    return data;
  }
}

export interface INotificationData {
  properties: { [key: string]: any } | undefined;
  type: string | undefined;
}

export enum NotificationSeverity {
  Info = 0,
  Success = 1,
  Warn = 2,
  Error = 3,
  Fatal = 4,
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
  isSubscribed!: boolean;
  name!: string;

  constructor(data?: INotificationSubscriptionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isSubscribed = _data['isSubscribed'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): NotificationSubscriptionDto {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationSubscriptionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isSubscribed'] = this.isSubscribed;
    data['name'] = this.name;
    return data;
  }
}

export interface INotificationSubscriptionDto {
  isSubscribed: boolean;
  name: string;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
  description!: string | undefined;
  displayName!: string | undefined;
  isSubscribed!: boolean;
  name!: string;

  constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.description = _data['description'];
      this.displayName = _data['displayName'];
      this.isSubscribed = _data['isSubscribed'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationSubscriptionWithDisplayNameDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['description'] = this.description;
    data['displayName'] = this.displayName;
    data['isSubscribed'] = this.isSubscribed;
    data['name'] = this.name;
    return data;
  }
}

export interface INotificationSubscriptionWithDisplayNameDto {
  description: string | undefined;
  displayName: string | undefined;
  isSubscribed: boolean;
  name: string;
}

export class Occurrence implements IOccurrence {
  occurrenceArea!: OccurrenceArea;
  occurrenceType!: OccurrenceType;
  occurrenceTime!: moment.Moment;
  user!: User;
  userId!: number;
  remarks!: string | undefined;
  imageUrl!: string | undefined;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  alternating!: string | undefined;
  motive!: string | undefined;
  fRem!: string | undefined;
  location!: string | undefined;
  code!: string | undefined;
  employee!: User;
  employeeId!: number;
  commander!: Commander;
  commanderId!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IOccurrence) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.occurrenceArea = _data['occurrenceArea'];
      this.occurrenceType = _data['occurrenceType'];
      this.occurrenceTime = _data['occurrenceTime'] ? moment(_data['occurrenceTime'].toString()) : <any>undefined;
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.remarks = _data['remarks'];
      this.imageUrl = _data['imageUrl'];
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.alternating = _data['alternating'];
      this.motive = _data['motive'];
      this.fRem = _data['fRem'];
      this.location = _data['location'];
      this.code = _data['code'];
      this.employee = _data['employee'] ? User.fromJS(_data['employee']) : <any>undefined;
      this.employeeId = _data['employeeId'];
      this.commander = _data['commander'] ? Commander.fromJS(_data['commander']) : <any>undefined;
      this.commanderId = _data['commanderId'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): Occurrence {
    data = typeof data === 'object' ? data : {};
    let result = new Occurrence();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['occurrenceArea'] = this.occurrenceArea;
    data['occurrenceType'] = this.occurrenceType;
    data['occurrenceTime'] = this.occurrenceTime ? this.occurrenceTime.toISOString() : <any>undefined;
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['remarks'] = this.remarks;
    data['imageUrl'] = this.imageUrl;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['alternating'] = this.alternating;
    data['motive'] = this.motive;
    data['fRem'] = this.fRem;
    data['location'] = this.location;
    data['code'] = this.code;
    data['employee'] = this.employee ? this.employee.toJSON() : <any>undefined;
    data['employeeId'] = this.employeeId;
    data['commander'] = this.commander ? this.commander.toJSON() : <any>undefined;
    data['commanderId'] = this.commanderId;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IOccurrence {
  occurrenceArea: OccurrenceArea;
  occurrenceType: OccurrenceType;
  occurrenceTime: moment.Moment;
  user: User;
  userId: number;
  remarks: string | undefined;
  imageUrl: string | undefined;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  alternating: string | undefined;
  motive: string | undefined;
  fRem: string | undefined;
  location: string | undefined;
  code: string | undefined;
  employee: User;
  employeeId: number;
  commander: Commander;
  commanderId: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum OccurrenceArea {
  Operations = 0,
  Coordination = 1,
  Airports = 2,
  Management = 3,
  IT = 4,
}

export class OccurrenceDto implements IOccurrenceDto {
  occurrenceArea!: OccurrenceArea;
  occurrenceType!: OccurrenceType;
  occurrenceTime!: moment.Moment;
  user!: User;
  userId!: number;
  remarks!: string | undefined;
  imageUrl!: string | undefined;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  alternating!: string | undefined;
  motive!: string | undefined;
  fRem!: string | undefined;
  location!: string | undefined;
  code!: string | undefined;
  employee!: User;
  employeeId!: number;
  commander!: Commander;
  commanderId!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IOccurrenceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.occurrenceArea = _data['occurrenceArea'];
      this.occurrenceType = _data['occurrenceType'];
      this.occurrenceTime = _data['occurrenceTime'] ? moment(_data['occurrenceTime'].toString()) : <any>undefined;
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.remarks = _data['remarks'];
      this.imageUrl = _data['imageUrl'];
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.alternating = _data['alternating'];
      this.motive = _data['motive'];
      this.fRem = _data['fRem'];
      this.location = _data['location'];
      this.code = _data['code'];
      this.employee = _data['employee'] ? User.fromJS(_data['employee']) : <any>undefined;
      this.employeeId = _data['employeeId'];
      this.commander = _data['commander'] ? Commander.fromJS(_data['commander']) : <any>undefined;
      this.commanderId = _data['commanderId'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): OccurrenceDto {
    data = typeof data === 'object' ? data : {};
    let result = new OccurrenceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['occurrenceArea'] = this.occurrenceArea;
    data['occurrenceType'] = this.occurrenceType;
    data['occurrenceTime'] = this.occurrenceTime ? this.occurrenceTime.toISOString() : <any>undefined;
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['remarks'] = this.remarks;
    data['imageUrl'] = this.imageUrl;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['alternating'] = this.alternating;
    data['motive'] = this.motive;
    data['fRem'] = this.fRem;
    data['location'] = this.location;
    data['code'] = this.code;
    data['employee'] = this.employee ? this.employee.toJSON() : <any>undefined;
    data['employeeId'] = this.employeeId;
    data['commander'] = this.commander ? this.commander.toJSON() : <any>undefined;
    data['commanderId'] = this.commanderId;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IOccurrenceDto {
  occurrenceArea: OccurrenceArea;
  occurrenceType: OccurrenceType;
  occurrenceTime: moment.Moment;
  user: User;
  userId: number;
  remarks: string | undefined;
  imageUrl: string | undefined;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  alternating: string | undefined;
  motive: string | undefined;
  fRem: string | undefined;
  location: string | undefined;
  code: string | undefined;
  employee: User;
  employeeId: number;
  commander: Commander;
  commanderId: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum OccurrenceType {
  Alternating = 0,
  OperationsDelay = 1,
  OverloadAndLoads = 2,
  CPTFuel = 3,
  Maintenance = 4,
  PCN = 5,
  DifferentiatedSchedules = 6,
  CrewReport = 7,
  EngineeringAndStandards = 8,
  OperationsOthers = 9,
  Studies = 10,
  ConstIndex = 11,
  CoordinationOthers = 12,
  Strike = 13,
  Notams = 14,
  AirTraffic = 15,
  Meteorology = 16,
  AirportsOthers = 17,
  Absence = 18,
  ManagementDelay = 19,
  DM = 20,
  Feedback = 21,
  ManagementOthers = 22,
  SystemCrashes = 23,
  ITOthers = 24,
  ExtraFuel = 25,
  Scale = 26,
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
  authority!: string | undefined;
  clientId!: string | undefined;
  clientSecret!: string | undefined;
  loginUrl!: string | undefined;
  validateIssuer!: boolean;

  constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authority = _data['authority'];
      this.clientId = _data['clientId'];
      this.clientSecret = _data['clientSecret'];
      this.loginUrl = _data['loginUrl'];
      this.validateIssuer = _data['validateIssuer'];
    }
  }

  static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
    data = typeof data === 'object' ? data : {};
    let result = new OpenIdConnectExternalLoginProviderSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authority'] = this.authority;
    data['clientId'] = this.clientId;
    data['clientSecret'] = this.clientSecret;
    data['loginUrl'] = this.loginUrl;
    data['validateIssuer'] = this.validateIssuer;
    return data;
  }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
  authority: string | undefined;
  clientId: string | undefined;
  clientSecret: string | undefined;
  loginUrl: string | undefined;
  validateIssuer: boolean;
}

export class OperationalTacticalDto implements IOperationalTacticalDto {
  createDateTime!: moment.Moment;
  hours!: string | undefined;
  flightCount!: number;
  id!: number;

  constructor(data?: IOperationalTacticalDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.createDateTime = _data['createDateTime'] ? moment(_data['createDateTime'].toString()) : <any>undefined;
      this.hours = _data['hours'];
      this.flightCount = _data['flightCount'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): OperationalTacticalDto {
    data = typeof data === 'object' ? data : {};
    let result = new OperationalTacticalDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['createDateTime'] = this.createDateTime ? this.createDateTime.toISOString() : <any>undefined;
    data['hours'] = this.hours;
    data['flightCount'] = this.flightCount;
    data['id'] = this.id;
    return data;
  }
}

export interface IOperationalTacticalDto {
  createDateTime: moment.Moment;
  hours: string | undefined;
  flightCount: number;
  id: number;
}

export class OrientationDto implements IOrientationDto {
  title!: string | undefined;
  content!: string | undefined;
  startValidate!: moment.Moment;
  endValidate!: moment.Moment;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IOrientationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data['title'];
      this.content = _data['content'];
      this.startValidate = _data['startValidate'] ? moment(_data['startValidate'].toString()) : <any>undefined;
      this.endValidate = _data['endValidate'] ? moment(_data['endValidate'].toString()) : <any>undefined;
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): OrientationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrientationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['title'] = this.title;
    data['content'] = this.content;
    data['startValidate'] = this.startValidate ? this.startValidate.toISOString() : <any>undefined;
    data['endValidate'] = this.endValidate ? this.endValidate.toISOString() : <any>undefined;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IOrientationDto {
  title: string | undefined;
  content: string | undefined;
  startValidate: moment.Moment;
  endValidate: moment.Moment;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class PagedResultDtoOfAirportsDto implements IPagedResultDtoOfAirportsDto {
  totalCount!: number;
  items!: AirportsDto[] | undefined;

  constructor(data?: IPagedResultDtoOfAirportsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AirportsDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfAirportsDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfAirportsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfAirportsDto {
  totalCount: number;
  items: AirportsDto[] | undefined;
}

export class PagedResultDtoOfAlertDto implements IPagedResultDtoOfAlertDto {
  totalCount!: number;
  items!: AlertDto[] | undefined;

  constructor(data?: IPagedResultDtoOfAlertDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AlertDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfAlertDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfAlertDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfAlertDto {
  totalCount: number;
  items: AlertDto[] | undefined;
}

export class PagedResultDtoOfAlternateFlightDto implements IPagedResultDtoOfAlternateFlightDto {
  totalCount!: number;
  items!: AlternateFlightDto[] | undefined;

  constructor(data?: IPagedResultDtoOfAlternateFlightDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AlternateFlightDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfAlternateFlightDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfAlternateFlightDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfAlternateFlightDto {
  totalCount: number;
  items: AlternateFlightDto[] | undefined;
}

export class PagedResultDtoOfArticleDto implements IPagedResultDtoOfArticleDto {
  totalCount!: number;
  items!: ArticleDto[] | undefined;

  constructor(data?: IPagedResultDtoOfArticleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ArticleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfArticleDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfArticleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfArticleDto {
  totalCount: number;
  items: ArticleDto[] | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
  totalCount!: number;
  items!: AuditLogListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfAuditLogListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AuditLogListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfAuditLogListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfAuditLogListDto {
  totalCount: number;
  items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfBriefingAirportDto implements IPagedResultDtoOfBriefingAirportDto {
  totalCount!: number;
  items!: BriefingAirportDto[] | undefined;

  constructor(data?: IPagedResultDtoOfBriefingAirportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(BriefingAirportDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfBriefingAirportDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfBriefingAirportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfBriefingAirportDto {
  totalCount: number;
  items: BriefingAirportDto[] | undefined;
}

export class PagedResultDtoOfBriefingGolDto implements IPagedResultDtoOfBriefingGolDto {
  totalCount!: number;
  items!: BriefingGolDto[] | undefined;

  constructor(data?: IPagedResultDtoOfBriefingGolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(BriefingGolDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfBriefingGolDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfBriefingGolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfBriefingGolDto {
  totalCount: number;
  items: BriefingGolDto[] | undefined;
}

export class PagedResultDtoOfCityPairDto implements IPagedResultDtoOfCityPairDto {
  totalCount!: number;
  items!: CityPairDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCityPairDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CityPairDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCityPairDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCityPairDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfCityPairDto {
  totalCount: number;
  items: CityPairDto[] | undefined;
}

export class PagedResultDtoOfCommanderDto implements IPagedResultDtoOfCommanderDto {
  totalCount!: number;
  items!: CommanderDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCommanderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CommanderDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCommanderDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCommanderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfCommanderDto {
  totalCount: number;
  items: CommanderDto[] | undefined;
}

export class PagedResultDtoOfContactDto implements IPagedResultDtoOfContactDto {
  totalCount!: number;
  items!: ContactDto[] | undefined;

  constructor(data?: IPagedResultDtoOfContactDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContactDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfContactDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfContactDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfContactDto {
  totalCount: number;
  items: ContactDto[] | undefined;
}

export class PagedResultDtoOfContinuousImprovementDto implements IPagedResultDtoOfContinuousImprovementDto {
  totalCount!: number;
  items!: ContinuousImprovementDto[] | undefined;

  constructor(data?: IPagedResultDtoOfContinuousImprovementDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContinuousImprovementDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfContinuousImprovementDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfContinuousImprovementDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfContinuousImprovementDto {
  totalCount: number;
  items: ContinuousImprovementDto[] | undefined;
}

export class PagedResultDtoOfCostIndexDto implements IPagedResultDtoOfCostIndexDto {
  totalCount!: number;
  items!: CostIndexDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCostIndexDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CostIndexDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCostIndexDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCostIndexDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfCostIndexDto {
  totalCount: number;
  items: CostIndexDto[] | undefined;
}

export class PagedResultDtoOfCostIndexOperationalDto implements IPagedResultDtoOfCostIndexOperationalDto {
  totalCount!: number;
  items!: CostIndexOperationalDto[] | undefined;

  constructor(data?: IPagedResultDtoOfCostIndexOperationalDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CostIndexOperationalDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfCostIndexOperationalDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfCostIndexOperationalDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfCostIndexOperationalDto {
  totalCount: number;
  items: CostIndexOperationalDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
  totalCount!: number;
  items!: EntityChangeListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(EntityChangeListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfEntityChangeListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfEntityChangeListDto {
  totalCount: number;
  items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfEventDto implements IPagedResultDtoOfEventDto {
  totalCount!: number;
  items!: EventDto[] | undefined;

  constructor(data?: IPagedResultDtoOfEventDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(EventDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfEventDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfEventDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfEventDto {
  totalCount: number;
  items: EventDto[] | undefined;
}

export class PagedResultDtoOfFirDto implements IPagedResultDtoOfFirDto {
  totalCount!: number;
  items!: FirDto[] | undefined;

  constructor(data?: IPagedResultDtoOfFirDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FirDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfFirDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfFirDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfFirDto {
  totalCount: number;
  items: FirDto[] | undefined;
}

export class PagedResultDtoOfFlightLaunchDto implements IPagedResultDtoOfFlightLaunchDto {
  totalCount!: number;
  items!: FlightLaunchDto[] | undefined;

  constructor(data?: IPagedResultDtoOfFlightLaunchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FlightLaunchDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfFlightLaunchDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfFlightLaunchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfFlightLaunchDto {
  totalCount: number;
  items: FlightLaunchDto[] | undefined;
}

export class PagedResultDtoOfFlightMonitoringDto implements IPagedResultDtoOfFlightMonitoringDto {
  totalCount!: number;
  items!: FlightMonitoringDto[] | undefined;

  constructor(data?: IPagedResultDtoOfFlightMonitoringDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FlightMonitoringDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfFlightMonitoringDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfFlightMonitoringDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfFlightMonitoringDto {
  totalCount: number;
  items: FlightMonitoringDto[] | undefined;
}

export class PagedResultDtoOfFlightTimeDto implements IPagedResultDtoOfFlightTimeDto {
  totalCount!: number;
  items!: FlightTimeDto[] | undefined;

  constructor(data?: IPagedResultDtoOfFlightTimeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FlightTimeDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfFlightTimeDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfFlightTimeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfFlightTimeDto {
  totalCount: number;
  items: FlightTimeDto[] | undefined;
}

export class PagedResultDtoOfGetAllSendAttemptsOutput implements IPagedResultDtoOfGetAllSendAttemptsOutput {
  totalCount!: number;
  items!: GetAllSendAttemptsOutput[] | undefined;

  constructor(data?: IPagedResultDtoOfGetAllSendAttemptsOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(GetAllSendAttemptsOutput.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfGetAllSendAttemptsOutput {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfGetAllSendAttemptsOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfGetAllSendAttemptsOutput {
  totalCount: number;
  items: GetAllSendAttemptsOutput[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
  totalCount!: number;
  items!: LanguageTextListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(LanguageTextListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfLanguageTextListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfLanguageTextListDto {
  totalCount: number;
  items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfMELDto implements IPagedResultDtoOfMELDto {
  totalCount!: number;
  items!: MELDto[] | undefined;

  constructor(data?: IPagedResultDtoOfMELDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(MELDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfMELDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfMELDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfMELDto {
  totalCount: number;
  items: MELDto[] | undefined;
}

export class PagedResultDtoOfMELItemDto implements IPagedResultDtoOfMELItemDto {
  totalCount!: number;
  items!: MELItemDto[] | undefined;

  constructor(data?: IPagedResultDtoOfMELItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(MELItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfMELItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfMELItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfMELItemDto {
  totalCount: number;
  items: MELItemDto[] | undefined;
}

export class PagedResultDtoOfMinimumsItemDto implements IPagedResultDtoOfMinimumsItemDto {
  totalCount!: number;
  items!: MinimumsItemDto[] | undefined;

  constructor(data?: IPagedResultDtoOfMinimumsItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(MinimumsItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfMinimumsItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfMinimumsItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfMinimumsItemDto {
  totalCount: number;
  items: MinimumsItemDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
  totalCount!: number;
  items!: NameValueDto[] | undefined;

  constructor(data?: IPagedResultDtoOfNameValueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(NameValueDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfNameValueDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfNameValueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfNameValueDto {
  totalCount: number;
  items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfNotamDto implements IPagedResultDtoOfNotamDto {
  totalCount!: number;
  items!: NotamDto[] | undefined;

  constructor(data?: IPagedResultDtoOfNotamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(NotamDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfNotamDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfNotamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfNotamDto {
  totalCount: number;
  items: NotamDto[] | undefined;
}

export class PagedResultDtoOfOccurrenceDto implements IPagedResultDtoOfOccurrenceDto {
  totalCount!: number;
  items!: OccurrenceDto[] | undefined;

  constructor(data?: IPagedResultDtoOfOccurrenceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(OccurrenceDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfOccurrenceDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfOccurrenceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfOccurrenceDto {
  totalCount: number;
  items: OccurrenceDto[] | undefined;
}

export class PagedResultDtoOfOrientationDto implements IPagedResultDtoOfOrientationDto {
  totalCount!: number;
  items!: OrientationDto[] | undefined;

  constructor(data?: IPagedResultDtoOfOrientationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(OrientationDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfOrientationDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfOrientationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfOrientationDto {
  totalCount: number;
  items: OrientationDto[] | undefined;
}

export class PagedResultDtoOfRootThemeDto implements IPagedResultDtoOfRootThemeDto {
  totalCount!: number;
  items!: RootThemeDto[] | undefined;

  constructor(data?: IPagedResultDtoOfRootThemeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(RootThemeDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfRootThemeDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfRootThemeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfRootThemeDto {
  totalCount: number;
  items: RootThemeDto[] | undefined;
}

export class PagedResultDtoOfSettingsDto implements IPagedResultDtoOfSettingsDto {
  totalCount!: number;
  items!: SettingsDto[] | undefined;

  constructor(data?: IPagedResultDtoOfSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(SettingsDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfSettingsDto {
  totalCount: number;
  items: SettingsDto[] | undefined;
}

export class PagedResultDtoOfTenantAddressDto implements IPagedResultDtoOfTenantAddressDto {
  totalCount!: number;
  items!: TenantAddressDto[] | undefined;

  constructor(data?: IPagedResultDtoOfTenantAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TenantAddressDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfTenantAddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfTenantAddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfTenantAddressDto {
  totalCount: number;
  items: TenantAddressDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
  totalCount!: number;
  items!: TenantListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfTenantListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TenantListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfTenantListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfTenantListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfTenantListDto {
  totalCount: number;
  items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
  totalCount!: number;
  items!: UserListDto[] | undefined;

  constructor(data?: IPagedResultDtoOfUserListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(UserListDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfUserListDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfUserListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfUserListDto {
  totalCount: number;
  items: UserListDto[] | undefined;
}

export class PagedResultDtoOfWorkShiftDto implements IPagedResultDtoOfWorkShiftDto {
  totalCount!: number;
  items!: WorkShiftDto[] | undefined;

  constructor(data?: IPagedResultDtoOfWorkShiftDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data['totalCount'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(WorkShiftDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PagedResultDtoOfWorkShiftDto {
    data = typeof data === 'object' ? data : {};
    let result = new PagedResultDtoOfWorkShiftDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['totalCount'] = this.totalCount;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPagedResultDtoOfWorkShiftDto {
  totalCount: number;
  items: WorkShiftDto[] | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
  requireDigit!: boolean;
  requiredLength!: number;
  requireLowercase!: boolean;
  requireNonAlphanumeric!: boolean;
  requireUppercase!: boolean;

  constructor(data?: IPasswordComplexitySetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requireDigit = _data['requireDigit'];
      this.requiredLength = _data['requiredLength'];
      this.requireLowercase = _data['requireLowercase'];
      this.requireNonAlphanumeric = _data['requireNonAlphanumeric'];
      this.requireUppercase = _data['requireUppercase'];
    }
  }

  static fromJS(data: any): PasswordComplexitySetting {
    data = typeof data === 'object' ? data : {};
    let result = new PasswordComplexitySetting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['requireDigit'] = this.requireDigit;
    data['requiredLength'] = this.requiredLength;
    data['requireLowercase'] = this.requireLowercase;
    data['requireNonAlphanumeric'] = this.requireNonAlphanumeric;
    data['requireUppercase'] = this.requireUppercase;
    return data;
  }
}

export interface IPasswordComplexitySetting {
  requireDigit: boolean;
  requiredLength: number;
  requireLowercase: boolean;
  requireNonAlphanumeric: boolean;
  requireUppercase: boolean;
}

export class ProviderModel implements IProviderModel {
  usernameOrEmailAddress!: string | undefined;
  authenticationSource!: string | undefined;
  tenant!: TenantModal;

  constructor(data?: IProviderModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.usernameOrEmailAddress = _data['usernameOrEmailAddress'];
      this.authenticationSource = _data['authenticationSource'];
      this.tenant = _data['tenant'] ? TenantModal.fromJS(_data['tenant']) : <any>undefined;
    }
  }

  static fromJS(data: any): ProviderModel {
    data = typeof data === 'object' ? data : {};
    let result = new ProviderModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['usernameOrEmailAddress'] = this.usernameOrEmailAddress;
    data['authenticationSource'] = this.authenticationSource;
    data['tenant'] = this.tenant ? this.tenant.toJSON() : <any>undefined;
    return data;
  }
}

export interface IProviderModel {
  usernameOrEmailAddress: string | undefined;
  authenticationSource: string | undefined;
  tenant: TenantModal;
}

export class ReleaseDto implements IReleaseDto {
  information!: string | undefined;
  prominence!: boolean;
  order!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IReleaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.information = _data['information'];
      this.prominence = _data['prominence'];
      this.order = _data['order'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ReleaseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ReleaseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['information'] = this.information;
    data['prominence'] = this.prominence;
    data['order'] = this.order;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IReleaseDto {
  information: string | undefined;
  prominence: boolean;
  order: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum RepeatMode {
  AllDays = 0,
  WeekDays = 1,
  Weekends = 2,
}

export class ResetPasswordInput implements IResetPasswordInput {
  authenticationSource!: string | undefined;
  c!: string | undefined;
  password!: string | undefined;
  resetCode!: string | undefined;
  returnUrl!: string | undefined;
  singleSignIn!: string | undefined;
  userId!: number;

  constructor(data?: IResetPasswordInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authenticationSource = _data['authenticationSource'];
      this.c = _data['c'];
      this.password = _data['password'];
      this.resetCode = _data['resetCode'];
      this.returnUrl = _data['returnUrl'];
      this.singleSignIn = _data['singleSignIn'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ResetPasswordInput {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authenticationSource'] = this.authenticationSource;
    data['c'] = this.c;
    data['password'] = this.password;
    data['resetCode'] = this.resetCode;
    data['returnUrl'] = this.returnUrl;
    data['singleSignIn'] = this.singleSignIn;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IResetPasswordInput {
  authenticationSource: string | undefined;
  c: string | undefined;
  password: string | undefined;
  resetCode: string | undefined;
  returnUrl: string | undefined;
  singleSignIn: string | undefined;
  userId: number;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
  canLogin!: boolean;
  userName!: string | undefined;

  constructor(data?: IResetPasswordOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canLogin = _data['canLogin'];
      this.userName = _data['userName'];
    }
  }

  static fromJS(data: any): ResetPasswordOutput {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['canLogin'] = this.canLogin;
    data['userName'] = this.userName;
    return data;
  }
}

export interface IResetPasswordOutput {
  canLogin: boolean;
  userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
  c!: string | undefined;

  constructor(data?: IResolveTenantIdInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.c = _data['c'];
    }
  }

  static fromJS(data: any): ResolveTenantIdInput {
    data = typeof data === 'object' ? data : {};
    let result = new ResolveTenantIdInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['c'] = this.c;
    return data;
  }
}

export interface IResolveTenantIdInput {
  c: string | undefined;
}

export class RoleEditDto implements IRoleEditDto {
  displayName!: string;
  id!: number | undefined;
  isDefault!: boolean;

  constructor(data?: IRoleEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data['displayName'];
      this.id = _data['id'];
      this.isDefault = _data['isDefault'];
    }
  }

  static fromJS(data: any): RoleEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayName'] = this.displayName;
    data['id'] = this.id;
    data['isDefault'] = this.isDefault;
    return data;
  }
}

export interface IRoleEditDto {
  displayName: string;
  id: number | undefined;
  isDefault: boolean;
}

export class RoleListDto implements IRoleListDto {
  displayName!: string | undefined;
  isDefault!: boolean;
  isStatic!: boolean;
  readonly lastModificationDate!: moment.Moment;
  name!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IRoleListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data['displayName'];
      this.isDefault = _data['isDefault'];
      this.isStatic = _data['isStatic'];
      (<any>this).lastModificationDate = _data['lastModificationDate'] ? moment(_data['lastModificationDate'].toString()) : <any>undefined;
      this.name = _data['name'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): RoleListDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayName'] = this.displayName;
    data['isDefault'] = this.isDefault;
    data['isStatic'] = this.isStatic;
    data['lastModificationDate'] = this.lastModificationDate ? this.lastModificationDate.toISOString() : <any>undefined;
    data['name'] = this.name;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IRoleListDto {
  displayName: string | undefined;
  isDefault: boolean;
  isStatic: boolean;
  lastModificationDate: moment.Moment;
  name: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class RootThemeDto implements IRootThemeDto {
  user!: User;
  userId!: number;
  root!: RootType;
  theme!: ThemeType;
  description!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IRootThemeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
      this.userId = _data['userId'];
      this.root = _data['root'];
      this.theme = _data['theme'];
      this.description = _data['description'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): RootThemeDto {
    data = typeof data === 'object' ? data : {};
    let result = new RootThemeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['user'] = this.user ? this.user.toJSON() : <any>undefined;
    data['userId'] = this.userId;
    data['root'] = this.root;
    data['theme'] = this.theme;
    data['description'] = this.description;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IRootThemeDto {
  user: User;
  userId: number;
  root: RootType;
  theme: ThemeType;
  description: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum RootType {
  Operational = 0,
  Administrative = 1,
}

export enum RouteType {
  Arrival = 1,
  Departure = 2,
}

export class SearchAlertDto implements ISearchAlertDto {
  offset!: number;
  limit!: number;
  filterByRegistration!: string | undefined;
  filterByInitialDate!: moment.Moment | undefined;
  filterByFinalDate!: moment.Moment | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchAlertDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByRegistration = _data['filterByRegistration'];
      this.filterByInitialDate = _data['filterByInitialDate'] ? moment(_data['filterByInitialDate'].toString()) : <any>undefined;
      this.filterByFinalDate = _data['filterByFinalDate'] ? moment(_data['filterByFinalDate'].toString()) : <any>undefined;
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchAlertDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchAlertDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByRegistration'] = this.filterByRegistration;
    data['filterByInitialDate'] = this.filterByInitialDate ? this.filterByInitialDate.toISOString() : <any>undefined;
    data['filterByFinalDate'] = this.filterByFinalDate ? this.filterByFinalDate.toISOString() : <any>undefined;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchAlertDto {
  offset: number;
  limit: number;
  filterByRegistration: string | undefined;
  filterByInitialDate: moment.Moment | undefined;
  filterByFinalDate: moment.Moment | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchAlternateFlightDto implements ISearchAlternateFlightDto {
  filterByDestiny!: string | undefined;
  filterByFirstDestiny!: string | undefined;
  filterBySecondDestiny!: string | undefined;
  filterByThirdDestiny!: string | undefined;
  offset!: number;
  limit!: number;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchAlternateFlightDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filterByDestiny = _data['filterByDestiny'];
      this.filterByFirstDestiny = _data['filterByFirstDestiny'];
      this.filterBySecondDestiny = _data['filterBySecondDestiny'];
      this.filterByThirdDestiny = _data['filterByThirdDestiny'];
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchAlternateFlightDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchAlternateFlightDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['filterByDestiny'] = this.filterByDestiny;
    data['filterByFirstDestiny'] = this.filterByFirstDestiny;
    data['filterBySecondDestiny'] = this.filterBySecondDestiny;
    data['filterByThirdDestiny'] = this.filterByThirdDestiny;
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchAlternateFlightDto {
  filterByDestiny: string | undefined;
  filterByFirstDestiny: string | undefined;
  filterBySecondDestiny: string | undefined;
  filterByThirdDestiny: string | undefined;
  offset: number;
  limit: number;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchBriefingAirportDto implements ISearchBriefingAirportDto {
  offset!: number;
  limit!: number;
  filterByDestiny!: string | undefined;
  filterByFirstDestiny!: string | undefined;
  filterBySecondDestiny!: string | undefined;
  filterByThirdDestiny!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchBriefingAirportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByDestiny = _data['filterByDestiny'];
      this.filterByFirstDestiny = _data['filterByFirstDestiny'];
      this.filterBySecondDestiny = _data['filterBySecondDestiny'];
      this.filterByThirdDestiny = _data['filterByThirdDestiny'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchBriefingAirportDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchBriefingAirportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByDestiny'] = this.filterByDestiny;
    data['filterByFirstDestiny'] = this.filterByFirstDestiny;
    data['filterBySecondDestiny'] = this.filterBySecondDestiny;
    data['filterByThirdDestiny'] = this.filterByThirdDestiny;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchBriefingAirportDto {
  offset: number;
  limit: number;
  filterByDestiny: string | undefined;
  filterByFirstDestiny: string | undefined;
  filterBySecondDestiny: string | undefined;
  filterByThirdDestiny: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchBriefingGolDto implements ISearchBriefingGolDto {
  flightDate!: moment.Moment;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  flightNlCrewOrigin!: string | undefined;
  flightNlCrewDestiny!: string | undefined;
  prefix!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchBriefingGolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.flightDate = _data['flightDate'] ? moment(_data['flightDate'].toString()) : <any>undefined;
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.flightNlCrewOrigin = _data['flightNlCrewOrigin'];
      this.flightNlCrewDestiny = _data['flightNlCrewDestiny'];
      this.prefix = _data['prefix'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchBriefingGolDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchBriefingGolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['flightDate'] = this.flightDate ? this.flightDate.toISOString() : <any>undefined;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['flightNlCrewOrigin'] = this.flightNlCrewOrigin;
    data['flightNlCrewDestiny'] = this.flightNlCrewDestiny;
    data['prefix'] = this.prefix;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchBriefingGolDto {
  flightDate: moment.Moment;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  flightNlCrewOrigin: string | undefined;
  flightNlCrewDestiny: string | undefined;
  prefix: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchCityPairDto implements ISearchCityPairDto {
  offset!: number;
  limit!: number;
  filterByArrival!: string | undefined;
  filterByDeparture!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchCityPairDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByArrival = _data['filterByArrival'];
      this.filterByDeparture = _data['filterByDeparture'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchCityPairDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchCityPairDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByArrival'] = this.filterByArrival;
    data['filterByDeparture'] = this.filterByDeparture;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchCityPairDto {
  offset: number;
  limit: number;
  filterByArrival: string | undefined;
  filterByDeparture: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchCostIndexDto implements ISearchCostIndexDto {
  offset!: number;
  limit!: number;
  filterByIndex!: number;
  filterByInitialDate!: moment.Moment | undefined;
  filterByFinalDate!: moment.Moment | undefined;
  filterByOrigin!: string | undefined;
  filterByDestiny!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchCostIndexDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByIndex = _data['filterByIndex'];
      this.filterByInitialDate = _data['filterByInitialDate'] ? moment(_data['filterByInitialDate'].toString()) : <any>undefined;
      this.filterByFinalDate = _data['filterByFinalDate'] ? moment(_data['filterByFinalDate'].toString()) : <any>undefined;
      this.filterByOrigin = _data['filterByOrigin'];
      this.filterByDestiny = _data['filterByDestiny'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchCostIndexDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchCostIndexDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByIndex'] = this.filterByIndex;
    data['filterByInitialDate'] = this.filterByInitialDate ? this.filterByInitialDate.toISOString() : <any>undefined;
    data['filterByFinalDate'] = this.filterByFinalDate ? this.filterByFinalDate.toISOString() : <any>undefined;
    data['filterByOrigin'] = this.filterByOrigin;
    data['filterByDestiny'] = this.filterByDestiny;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchCostIndexDto {
  offset: number;
  limit: number;
  filterByIndex: number;
  filterByInitialDate: moment.Moment | undefined;
  filterByFinalDate: moment.Moment | undefined;
  filterByOrigin: string | undefined;
  filterByDestiny: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchCostIndexOperationalDto implements ISearchCostIndexOperationalDto {
  offset!: number;
  limit!: number;
  filterByOperationalIndex!: number;
  filterByInitialDate!: moment.Moment | undefined;
  filterByFinalDate!: moment.Moment | undefined;
  filterByFlightNumber!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchCostIndexOperationalDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByOperationalIndex = _data['filterByOperationalIndex'];
      this.filterByInitialDate = _data['filterByInitialDate'] ? moment(_data['filterByInitialDate'].toString()) : <any>undefined;
      this.filterByFinalDate = _data['filterByFinalDate'] ? moment(_data['filterByFinalDate'].toString()) : <any>undefined;
      this.filterByFlightNumber = _data['filterByFlightNumber'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchCostIndexOperationalDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchCostIndexOperationalDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByOperationalIndex'] = this.filterByOperationalIndex;
    data['filterByInitialDate'] = this.filterByInitialDate ? this.filterByInitialDate.toISOString() : <any>undefined;
    data['filterByFinalDate'] = this.filterByFinalDate ? this.filterByFinalDate.toISOString() : <any>undefined;
    data['filterByFlightNumber'] = this.filterByFlightNumber;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchCostIndexOperationalDto {
  offset: number;
  limit: number;
  filterByOperationalIndex: number;
  filterByInitialDate: moment.Moment | undefined;
  filterByFinalDate: moment.Moment | undefined;
  filterByFlightNumber: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchFirDto implements ISearchFirDto {
  offset!: number;
  limit!: number;
  filterByDescription!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchFirDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByDescription = _data['filterByDescription'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchFirDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchFirDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByDescription'] = this.filterByDescription;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchFirDto {
  offset: number;
  limit: number;
  filterByDescription: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchFlightLaunchDto implements ISearchFlightLaunchDto {
  offset!: number;
  limit!: number;
  filterByOrigin!: string | undefined;
  filterByDestiny!: string | undefined;
  filterByRouteType!: number | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchFlightLaunchDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByOrigin = _data['filterByOrigin'];
      this.filterByDestiny = _data['filterByDestiny'];
      this.filterByRouteType = _data['filterByRouteType'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchFlightLaunchDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchFlightLaunchDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByOrigin'] = this.filterByOrigin;
    data['filterByDestiny'] = this.filterByDestiny;
    data['filterByRouteType'] = this.filterByRouteType;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchFlightLaunchDto {
  offset: number;
  limit: number;
  filterByOrigin: string | undefined;
  filterByDestiny: string | undefined;
  filterByRouteType: number | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchFlightMonitoringDto implements ISearchFlightMonitoringDto {
  monitoringInitialDate!: moment.Moment | undefined;
  monitoringFinalDate!: moment.Moment | undefined;
  userLeaderDovId!: number | undefined;
  userDovId!: number | undefined;
  monitoringType!: number | undefined;
  monitoringArea!: number | undefined;
  flightNumber!: string | undefined;
  flightOrigin!: string | undefined;
  flightDestiny!: string | undefined;
  prefix!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchFlightMonitoringDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.monitoringInitialDate = _data['monitoringInitialDate'] ? moment(_data['monitoringInitialDate'].toString()) : <any>undefined;
      this.monitoringFinalDate = _data['monitoringFinalDate'] ? moment(_data['monitoringFinalDate'].toString()) : <any>undefined;
      this.userLeaderDovId = _data['userLeaderDovId'];
      this.userDovId = _data['userDovId'];
      this.monitoringType = _data['monitoringType'];
      this.monitoringArea = _data['monitoringArea'];
      this.flightNumber = _data['flightNumber'];
      this.flightOrigin = _data['flightOrigin'];
      this.flightDestiny = _data['flightDestiny'];
      this.prefix = _data['prefix'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchFlightMonitoringDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchFlightMonitoringDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['monitoringInitialDate'] = this.monitoringInitialDate ? this.monitoringInitialDate.toISOString() : <any>undefined;
    data['monitoringFinalDate'] = this.monitoringFinalDate ? this.monitoringFinalDate.toISOString() : <any>undefined;
    data['userLeaderDovId'] = this.userLeaderDovId;
    data['userDovId'] = this.userDovId;
    data['monitoringType'] = this.monitoringType;
    data['monitoringArea'] = this.monitoringArea;
    data['flightNumber'] = this.flightNumber;
    data['flightOrigin'] = this.flightOrigin;
    data['flightDestiny'] = this.flightDestiny;
    data['prefix'] = this.prefix;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchFlightMonitoringDto {
  monitoringInitialDate: moment.Moment | undefined;
  monitoringFinalDate: moment.Moment | undefined;
  userLeaderDovId: number | undefined;
  userDovId: number | undefined;
  monitoringType: number | undefined;
  monitoringArea: number | undefined;
  flightNumber: string | undefined;
  flightOrigin: string | undefined;
  flightDestiny: string | undefined;
  prefix: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchFlightTimeDto implements ISearchFlightTimeDto {
  offset!: number;
  limit!: number;
  filterByOrigin!: string | undefined;
  filterByDestiny!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchFlightTimeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByOrigin = _data['filterByOrigin'];
      this.filterByDestiny = _data['filterByDestiny'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchFlightTimeDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchFlightTimeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByOrigin'] = this.filterByOrigin;
    data['filterByDestiny'] = this.filterByDestiny;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchFlightTimeDto {
  offset: number;
  limit: number;
  filterByOrigin: string | undefined;
  filterByDestiny: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchMELDto implements ISearchMELDto {
  offset!: number;
  limit!: number;
  filterByPrefix!: string | undefined;
  filterByMel!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchMELDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByPrefix = _data['filterByPrefix'];
      this.filterByMel = _data['filterByMel'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchMELDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchMELDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByPrefix'] = this.filterByPrefix;
    data['filterByMel'] = this.filterByMel;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchMELDto {
  offset: number;
  limit: number;
  filterByPrefix: string | undefined;
  filterByMel: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchMELItemDto implements ISearchMELItemDto {
  offset!: number;
  limit!: number;
  filterByDescription!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchMELItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByDescription = _data['filterByDescription'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchMELItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchMELItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByDescription'] = this.filterByDescription;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchMELItemDto {
  offset: number;
  limit: number;
  filterByDescription: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchMinimumsDto implements ISearchMinimumsDto {
  airport!: string | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchMinimumsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.airport = _data['airport'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchMinimumsDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchMinimumsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['airport'] = this.airport;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchMinimumsDto {
  airport: string | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchNotamDto implements ISearchNotamDto {
  offset!: number;
  limit!: number;
  filterByOrigin!: string | undefined;
  filterByDestiny!: string | undefined;
  filterByInitialDate!: moment.Moment | undefined;
  filterByFinalDate!: moment.Moment | undefined;
  filterByAirport!: string | undefined;
  filterBySupervisor!: string | undefined;
  filterByTypeNotam!: number | undefined;
  filterByFirId!: number | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchNotamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByOrigin = _data['filterByOrigin'];
      this.filterByDestiny = _data['filterByDestiny'];
      this.filterByInitialDate = _data['filterByInitialDate'] ? moment(_data['filterByInitialDate'].toString()) : <any>undefined;
      this.filterByFinalDate = _data['filterByFinalDate'] ? moment(_data['filterByFinalDate'].toString()) : <any>undefined;
      this.filterByAirport = _data['filterByAirport'];
      this.filterBySupervisor = _data['filterBySupervisor'];
      this.filterByTypeNotam = _data['filterByTypeNotam'];
      this.filterByFirId = _data['filterByFirId'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchNotamDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchNotamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByOrigin'] = this.filterByOrigin;
    data['filterByDestiny'] = this.filterByDestiny;
    data['filterByInitialDate'] = this.filterByInitialDate ? this.filterByInitialDate.toISOString() : <any>undefined;
    data['filterByFinalDate'] = this.filterByFinalDate ? this.filterByFinalDate.toISOString() : <any>undefined;
    data['filterByAirport'] = this.filterByAirport;
    data['filterBySupervisor'] = this.filterBySupervisor;
    data['filterByTypeNotam'] = this.filterByTypeNotam;
    data['filterByFirId'] = this.filterByFirId;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchNotamDto {
  offset: number;
  limit: number;
  filterByOrigin: string | undefined;
  filterByDestiny: string | undefined;
  filterByInitialDate: moment.Moment | undefined;
  filterByFinalDate: moment.Moment | undefined;
  filterByAirport: string | undefined;
  filterBySupervisor: string | undefined;
  filterByTypeNotam: number | undefined;
  filterByFirId: number | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchOccurrencesDto implements ISearchOccurrencesDto {
  offset!: number;
  limit!: number;
  filterByOccurrenceArea!: number | undefined;
  filterByOccurrenceType!: number | undefined;
  filterByInitialDate!: moment.Moment | undefined;
  filterByFinalDate!: moment.Moment | undefined;
  filterByEmployee!: number | undefined;
  filterByCommander!: number | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchOccurrencesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.offset = _data['offset'];
      this.limit = _data['limit'];
      this.filterByOccurrenceArea = _data['filterByOccurrenceArea'];
      this.filterByOccurrenceType = _data['filterByOccurrenceType'];
      this.filterByInitialDate = _data['filterByInitialDate'] ? moment(_data['filterByInitialDate'].toString()) : <any>undefined;
      this.filterByFinalDate = _data['filterByFinalDate'] ? moment(_data['filterByFinalDate'].toString()) : <any>undefined;
      this.filterByEmployee = _data['filterByEmployee'];
      this.filterByCommander = _data['filterByCommander'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchOccurrencesDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchOccurrencesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['offset'] = this.offset;
    data['limit'] = this.limit;
    data['filterByOccurrenceArea'] = this.filterByOccurrenceArea;
    data['filterByOccurrenceType'] = this.filterByOccurrenceType;
    data['filterByInitialDate'] = this.filterByInitialDate ? this.filterByInitialDate.toISOString() : <any>undefined;
    data['filterByFinalDate'] = this.filterByFinalDate ? this.filterByFinalDate.toISOString() : <any>undefined;
    data['filterByEmployee'] = this.filterByEmployee;
    data['filterByCommander'] = this.filterByCommander;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchOccurrencesDto {
  offset: number;
  limit: number;
  filterByOccurrenceArea: number | undefined;
  filterByOccurrenceType: number | undefined;
  filterByInitialDate: moment.Moment | undefined;
  filterByFinalDate: moment.Moment | undefined;
  filterByEmployee: number | undefined;
  filterByCommander: number | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SearchRootThemeDto implements ISearchRootThemeDto {
  filter!: string | undefined;
  filterByRootType!: number | undefined;
  filterByThemeType!: number | undefined;
  sorting!: string | undefined;
  skipCount!: number;
  maxResultCount!: number;

  constructor(data?: ISearchRootThemeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filter = _data['filter'];
      this.filterByRootType = _data['filterByRootType'];
      this.filterByThemeType = _data['filterByThemeType'];
      this.sorting = _data['sorting'];
      this.skipCount = _data['skipCount'];
      this.maxResultCount = _data['maxResultCount'];
    }
  }

  static fromJS(data: any): SearchRootThemeDto {
    data = typeof data === 'object' ? data : {};
    let result = new SearchRootThemeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['filter'] = this.filter;
    data['filterByRootType'] = this.filterByRootType;
    data['filterByThemeType'] = this.filterByThemeType;
    data['sorting'] = this.sorting;
    data['skipCount'] = this.skipCount;
    data['maxResultCount'] = this.maxResultCount;
    return data;
  }
}

export interface ISearchRootThemeDto {
  filter: string | undefined;
  filterByRootType: number | undefined;
  filterByThemeType: number | undefined;
  sorting: string | undefined;
  skipCount: number;
  maxResultCount: number;
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
  allowOneConcurrentLoginPerUser!: boolean;
  defaultPasswordComplexity!: PasswordComplexitySetting;
  passwordComplexity!: PasswordComplexitySetting;
  twoFactorLogin!: TwoFactorLoginSettingsEditDto;
  useDefaultPasswordComplexitySettings!: boolean;
  userLockOut!: UserLockOutSettingsEditDto;

  constructor(data?: ISecuritySettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowOneConcurrentLoginPerUser = _data['allowOneConcurrentLoginPerUser'];
      this.defaultPasswordComplexity = _data['defaultPasswordComplexity']
        ? PasswordComplexitySetting.fromJS(_data['defaultPasswordComplexity'])
        : <any>undefined;
      this.passwordComplexity = _data['passwordComplexity']
        ? PasswordComplexitySetting.fromJS(_data['passwordComplexity'])
        : <any>undefined;
      this.twoFactorLogin = _data['twoFactorLogin'] ? TwoFactorLoginSettingsEditDto.fromJS(_data['twoFactorLogin']) : <any>undefined;
      this.useDefaultPasswordComplexitySettings = _data['useDefaultPasswordComplexitySettings'];
      this.userLockOut = _data['userLockOut'] ? UserLockOutSettingsEditDto.fromJS(_data['userLockOut']) : <any>undefined;
    }
  }

  static fromJS(data: any): SecuritySettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new SecuritySettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['allowOneConcurrentLoginPerUser'] = this.allowOneConcurrentLoginPerUser;
    data['defaultPasswordComplexity'] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
    data['passwordComplexity'] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
    data['twoFactorLogin'] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
    data['useDefaultPasswordComplexitySettings'] = this.useDefaultPasswordComplexitySettings;
    data['userLockOut'] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISecuritySettingsEditDto {
  allowOneConcurrentLoginPerUser: boolean;
  defaultPasswordComplexity: PasswordComplexitySetting;
  passwordComplexity: PasswordComplexitySetting;
  twoFactorLogin: TwoFactorLoginSettingsEditDto;
  useDefaultPasswordComplexitySettings: boolean;
  userLockOut: UserLockOutSettingsEditDto;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
  emailAddress!: string;

  constructor(data?: ISendEmailActivationLinkInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
    }
  }

  static fromJS(data: any): SendEmailActivationLinkInput {
    data = typeof data === 'object' ? data : {};
    let result = new SendEmailActivationLinkInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    return data;
  }
}

export interface ISendEmailActivationLinkInput {
  emailAddress: string;
}

export class SendEmailDto implements ISendEmailDto {
  image!: string | undefined;
  pdf!: string | undefined;
  email!: string | undefined;

  constructor(data?: ISendEmailDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.image = _data['image'];
      this.pdf = _data['pdf'];
      this.email = _data['email'];
    }
  }

  static fromJS(data: any): SendEmailDto {
    data = typeof data === 'object' ? data : {};
    let result = new SendEmailDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['image'] = this.image;
    data['pdf'] = this.pdf;
    data['email'] = this.email;
    return data;
  }
}

export interface ISendEmailDto {
  image: string | undefined;
  pdf: string | undefined;
  email: string | undefined;
}

export class SendImageDto implements ISendImageDto {
  name!: string | undefined;
  base64Image!: string | undefined;

  constructor(data?: ISendImageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.base64Image = _data['base64Image'];
    }
  }

  static fromJS(data: any): SendImageDto {
    data = typeof data === 'object' ? data : {};
    let result = new SendImageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['base64Image'] = this.base64Image;
    return data;
  }
}

export interface ISendImageDto {
  name: string | undefined;
  base64Image: string | undefined;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
  emailAddress!: string;

  constructor(data?: ISendPasswordResetCodeInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
    }
  }

  static fromJS(data: any): SendPasswordResetCodeInput {
    data = typeof data === 'object' ? data : {};
    let result = new SendPasswordResetCodeInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    return data;
  }
}

export interface ISendPasswordResetCodeInput {
  emailAddress: string;
}

export class SendTestEmailInput implements ISendTestEmailInput {
  emailAddress!: string;

  constructor(data?: ISendTestEmailInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
    }
  }

  static fromJS(data: any): SendTestEmailInput {
    data = typeof data === 'object' ? data : {};
    let result = new SendTestEmailInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    return data;
  }
}

export interface ISendTestEmailInput {
  emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
  provider!: string;
  userId!: number;

  constructor(data?: ISendTwoFactorAuthCodeModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.provider = _data['provider'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): SendTwoFactorAuthCodeModel {
    data = typeof data === 'object' ? data : {};
    let result = new SendTwoFactorAuthCodeModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['provider'] = this.provider;
    data['userId'] = this.userId;
    return data;
  }
}

export interface ISendTwoFactorAuthCodeModel {
  provider: string;
  userId: number;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
  name!: string;

  constructor(data?: ISetDefaultLanguageInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): SetDefaultLanguageInput {
    data = typeof data === 'object' ? data : {};
    let result = new SetDefaultLanguageInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface ISetDefaultLanguageInput {
  name: string;
}

export class Setting implements ISetting {
  name!: string;
  tenantId!: number | undefined;
  userId!: number | undefined;
  value!: string | undefined;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ISetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.value = _data['value'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): Setting {
    data = typeof data === 'object' ? data : {};
    let result = new Setting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['value'] = this.value;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ISetting {
  name: string;
  tenantId: number | undefined;
  userId: number | undefined;
  value: string | undefined;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum SettingScopes {
  Application = 1,
  Tenant = 2,
  User = 4,
  All = 7,
}

export class SettingsDto implements ISettingsDto {
  name!: string | undefined;
  value!: string | undefined;

  constructor(data?: ISettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): SettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new SettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    return data;
  }
}

export interface ISettingsDto {
  name: string | undefined;
  value: string | undefined;
}

export enum SingleImageType {
  Mel = 0,
  Tactical = 1,
  Satelete = 2,
  Track = 3,
}

export enum SuplemNotamType {
  NotGenerated = 0,
  Generated = 1,
}

export class TenantAddressDto implements ITenantAddressDto {
  zipCode!: string;
  street!: string;
  neighborhood!: string;
  city!: string;
  state!: string;
  complement!: string | undefined;
  observation!: string | undefined;
  email!: string | undefined;
  document!: string | undefined;
  tenantId!: number;
  extensionData!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ITenantAddressDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.zipCode = _data['zipCode'];
      this.street = _data['street'];
      this.neighborhood = _data['neighborhood'];
      this.city = _data['city'];
      this.state = _data['state'];
      this.complement = _data['complement'];
      this.observation = _data['observation'];
      this.email = _data['email'];
      this.document = _data['document'];
      this.tenantId = _data['tenantId'];
      this.extensionData = _data['extensionData'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): TenantAddressDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantAddressDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['zipCode'] = this.zipCode;
    data['street'] = this.street;
    data['neighborhood'] = this.neighborhood;
    data['city'] = this.city;
    data['state'] = this.state;
    data['complement'] = this.complement;
    data['observation'] = this.observation;
    data['email'] = this.email;
    data['document'] = this.document;
    data['tenantId'] = this.tenantId;
    data['extensionData'] = this.extensionData;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ITenantAddressDto {
  zipCode: string;
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  complement: string | undefined;
  observation: string | undefined;
  email: string | undefined;
  document: string | undefined;
  tenantId: number;
  extensionData: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum TenantAvailabilityState {
  Available = 1,
  InActive = 2,
  NotFound = 3,
}

export class TenantEditDto implements ITenantEditDto {
  isActive!: boolean;
  name!: string;
  tenancyName!: string;
  id!: number;

  constructor(data?: ITenantEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
      this.name = _data['name'];
      this.tenancyName = _data['tenancyName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): TenantEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    data['name'] = this.name;
    data['tenancyName'] = this.tenancyName;
    data['id'] = this.id;
    return data;
  }
}

export interface ITenantEditDto {
  isActive: boolean;
  name: string;
  tenancyName: string;
  id: number;
}

export class TenantListDto implements ITenantListDto {
  isActive!: boolean;
  readonly lastModificationDate!: moment.Moment;
  name!: string | undefined;
  tenancyName!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: ITenantListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isActive = _data['isActive'];
      (<any>this).lastModificationDate = _data['lastModificationDate'] ? moment(_data['lastModificationDate'].toString()) : <any>undefined;
      this.name = _data['name'];
      this.tenancyName = _data['tenancyName'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): TenantListDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isActive'] = this.isActive;
    data['lastModificationDate'] = this.lastModificationDate ? this.lastModificationDate.toISOString() : <any>undefined;
    data['name'] = this.name;
    data['tenancyName'] = this.tenancyName;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface ITenantListDto {
  isActive: boolean;
  lastModificationDate: moment.Moment;
  name: string | undefined;
  tenancyName: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
  creationTime!: moment.Moment;
  name!: string | undefined;
  tenancyName!: string | undefined;
  id!: number;

  constructor(data?: ITenantLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.name = _data['name'];
      this.tenancyName = _data['tenancyName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): TenantLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['name'] = this.name;
    data['tenancyName'] = this.tenancyName;
    data['id'] = this.id;
    return data;
  }
}

export interface ITenantLoginInfoDto {
  creationTime: moment.Moment;
  name: string | undefined;
  tenancyName: string | undefined;
  id: number;
}

export class TenantModal implements ITenantModal {
  name!: string | undefined;
  tenancyName!: string | undefined;
  id!: number;

  constructor(data?: ITenantModal) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.tenancyName = _data['tenancyName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): TenantModal {
    data = typeof data === 'object' ? data : {};
    let result = new TenantModal();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['tenancyName'] = this.tenancyName;
    data['id'] = this.id;
    return data;
  }
}

export interface ITenantModal {
  name: string | undefined;
  tenancyName: string | undefined;
  id: number;
}

export class TenantNotification implements ITenantNotification {
  creationTime!: moment.Moment;
  data!: NotificationData;
  entityId!: any | undefined;
  entityTypeName!: string | undefined;
  notificationName!: string | undefined;
  severity!: NotificationSeverity;
  tenantId!: number | undefined;
  id!: string;

  constructor(data?: ITenantNotification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.data = _data['data'] ? NotificationData.fromJS(_data['data']) : <any>undefined;
      this.entityId = _data['entityId'];
      this.entityTypeName = _data['entityTypeName'];
      this.notificationName = _data['notificationName'];
      this.severity = _data['severity'];
      this.tenantId = _data['tenantId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): TenantNotification {
    data = typeof data === 'object' ? data : {};
    let result = new TenantNotification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['data'] = this.data ? this.data.toJSON() : <any>undefined;
    data['entityId'] = this.entityId;
    data['entityTypeName'] = this.entityTypeName;
    data['notificationName'] = this.notificationName;
    data['severity'] = this.severity;
    data['tenantId'] = this.tenantId;
    data['id'] = this.id;
    return data;
  }
}

export interface ITenantNotification {
  creationTime: moment.Moment;
  data: NotificationData;
  entityId: any | undefined;
  entityTypeName: string | undefined;
  notificationName: string | undefined;
  severity: NotificationSeverity;
  tenantId: number | undefined;
  id: string;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
  desktopFixedHeader!: boolean;
  headerSkin!: string | undefined;
  mobileFixedHeader!: boolean;

  constructor(data?: IThemeHeaderSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.desktopFixedHeader = _data['desktopFixedHeader'];
      this.headerSkin = _data['headerSkin'];
      this.mobileFixedHeader = _data['mobileFixedHeader'];
    }
  }

  static fromJS(data: any): ThemeHeaderSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeHeaderSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['desktopFixedHeader'] = this.desktopFixedHeader;
    data['headerSkin'] = this.headerSkin;
    data['mobileFixedHeader'] = this.mobileFixedHeader;
    return data;
  }
}

export interface IThemeHeaderSettingsDto {
  desktopFixedHeader: boolean;
  headerSkin: string | undefined;
  mobileFixedHeader: boolean;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
  contentSkin!: string | undefined;
  layoutType!: string | undefined;
  themeColor!: string | undefined;

  constructor(data?: IThemeLayoutSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentSkin = _data['contentSkin'];
      this.layoutType = _data['layoutType'];
      this.themeColor = _data['themeColor'];
    }
  }

  static fromJS(data: any): ThemeLayoutSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeLayoutSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contentSkin'] = this.contentSkin;
    data['layoutType'] = this.layoutType;
    data['themeColor'] = this.themeColor;
    return data;
  }
}

export interface IThemeLayoutSettingsDto {
  contentSkin: string | undefined;
  layoutType: string | undefined;
  themeColor: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
  allowAsideHiding!: boolean;
  allowAsideMinimizing!: boolean;
  asideSkin!: string | undefined;
  defaultHiddenAside!: boolean;
  defaultMinimizedAside!: boolean;
  fixedAside!: boolean;
  position!: string | undefined;
  submenuToggle!: string | undefined;

  constructor(data?: IThemeMenuSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowAsideHiding = _data['allowAsideHiding'];
      this.allowAsideMinimizing = _data['allowAsideMinimizing'];
      this.asideSkin = _data['asideSkin'];
      this.defaultHiddenAside = _data['defaultHiddenAside'];
      this.defaultMinimizedAside = _data['defaultMinimizedAside'];
      this.fixedAside = _data['fixedAside'];
      this.position = _data['position'];
      this.submenuToggle = _data['submenuToggle'];
    }
  }

  static fromJS(data: any): ThemeMenuSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeMenuSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['allowAsideHiding'] = this.allowAsideHiding;
    data['allowAsideMinimizing'] = this.allowAsideMinimizing;
    data['asideSkin'] = this.asideSkin;
    data['defaultHiddenAside'] = this.defaultHiddenAside;
    data['defaultMinimizedAside'] = this.defaultMinimizedAside;
    data['fixedAside'] = this.fixedAside;
    data['position'] = this.position;
    data['submenuToggle'] = this.submenuToggle;
    return data;
  }
}

export interface IThemeMenuSettingsDto {
  allowAsideHiding: boolean;
  allowAsideMinimizing: boolean;
  asideSkin: string | undefined;
  defaultHiddenAside: boolean;
  defaultMinimizedAside: boolean;
  fixedAside: boolean;
  position: string | undefined;
  submenuToggle: string | undefined;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
  header!: ThemeHeaderSettingsDto;
  layout!: ThemeLayoutSettingsDto;
  menu!: ThemeMenuSettingsDto;
  theme!: string | undefined;

  constructor(data?: IThemeSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.header = _data['header'] ? ThemeHeaderSettingsDto.fromJS(_data['header']) : <any>undefined;
      this.layout = _data['layout'] ? ThemeLayoutSettingsDto.fromJS(_data['layout']) : <any>undefined;
      this.menu = _data['menu'] ? ThemeMenuSettingsDto.fromJS(_data['menu']) : <any>undefined;
      this.theme = _data['theme'];
    }
  }

  static fromJS(data: any): ThemeSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ThemeSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['header'] = this.header ? this.header.toJSON() : <any>undefined;
    data['layout'] = this.layout ? this.layout.toJSON() : <any>undefined;
    data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined;
    data['theme'] = this.theme;
    return data;
  }
}

export interface IThemeSettingsDto {
  header: ThemeHeaderSettingsDto;
  layout: ThemeLayoutSettingsDto;
  menu: ThemeMenuSettingsDto;
  theme: string | undefined;
}

export enum ThemeType {
  Processes = 0,
  Systems = 1,
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
  isEmailProviderEnabled!: boolean;
  isEnabled!: boolean;
  isEnabledForApplication!: boolean;
  isGoogleAuthenticatorEnabled!: boolean;
  isRememberBrowserEnabled!: boolean;
  isSmsProviderEnabled!: boolean;

  constructor(data?: ITwoFactorLoginSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEmailProviderEnabled = _data['isEmailProviderEnabled'];
      this.isEnabled = _data['isEnabled'];
      this.isEnabledForApplication = _data['isEnabledForApplication'];
      this.isGoogleAuthenticatorEnabled = _data['isGoogleAuthenticatorEnabled'];
      this.isRememberBrowserEnabled = _data['isRememberBrowserEnabled'];
      this.isSmsProviderEnabled = _data['isSmsProviderEnabled'];
    }
  }

  static fromJS(data: any): TwoFactorLoginSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new TwoFactorLoginSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isEmailProviderEnabled'] = this.isEmailProviderEnabled;
    data['isEnabled'] = this.isEnabled;
    data['isEnabledForApplication'] = this.isEnabledForApplication;
    data['isGoogleAuthenticatorEnabled'] = this.isGoogleAuthenticatorEnabled;
    data['isRememberBrowserEnabled'] = this.isRememberBrowserEnabled;
    data['isSmsProviderEnabled'] = this.isSmsProviderEnabled;
    return data;
  }
}

export interface ITwoFactorLoginSettingsEditDto {
  isEmailProviderEnabled: boolean;
  isEnabled: boolean;
  isEnabledForApplication: boolean;
  isGoogleAuthenticatorEnabled: boolean;
  isRememberBrowserEnabled: boolean;
  isSmsProviderEnabled: boolean;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
  allowMenuScroll!: boolean;
  baseSettings!: ThemeSettingsDto;
  isLeftMenuUsed!: boolean;
  isTabMenuUsed!: boolean;
  isTopMenuUsed!: boolean;

  constructor(data?: IUiCustomizationSettingsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.allowMenuScroll = _data['allowMenuScroll'];
      this.baseSettings = _data['baseSettings'] ? ThemeSettingsDto.fromJS(_data['baseSettings']) : <any>undefined;
      this.isLeftMenuUsed = _data['isLeftMenuUsed'];
      this.isTabMenuUsed = _data['isTabMenuUsed'];
      this.isTopMenuUsed = _data['isTopMenuUsed'];
    }
  }

  static fromJS(data: any): UiCustomizationSettingsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UiCustomizationSettingsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['allowMenuScroll'] = this.allowMenuScroll;
    data['baseSettings'] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
    data['isLeftMenuUsed'] = this.isLeftMenuUsed;
    data['isTabMenuUsed'] = this.isTabMenuUsed;
    data['isTopMenuUsed'] = this.isTopMenuUsed;
    return data;
  }
}

export interface IUiCustomizationSettingsDto {
  allowMenuScroll: boolean;
  baseSettings: ThemeSettingsDto;
  isLeftMenuUsed: boolean;
  isTabMenuUsed: boolean;
  isTopMenuUsed: boolean;
}

export class UnblockUserInput implements IUnblockUserInput {
  tenantId!: number | undefined;
  userId!: number;

  constructor(data?: IUnblockUserInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): UnblockUserInput {
    data = typeof data === 'object' ? data : {};
    let result = new UnblockUserInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IUnblockUserInput {
  tenantId: number | undefined;
  userId: number;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
  key!: string;
  languageName!: string;
  sourceName!: string;
  value!: string;

  constructor(data?: IUpdateLanguageTextInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data['key'];
      this.languageName = _data['languageName'];
      this.sourceName = _data['sourceName'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): UpdateLanguageTextInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateLanguageTextInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['key'] = this.key;
    data['languageName'] = this.languageName;
    data['sourceName'] = this.sourceName;
    data['value'] = this.value;
    return data;
  }
}

export interface IUpdateLanguageTextInput {
  key: string;
  languageName: string;
  sourceName: string;
  value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
  notifications!: NotificationSubscriptionDto[] | undefined;
  receiveNotifications!: boolean;

  constructor(data?: IUpdateNotificationSettingsInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['notifications'])) {
        this.notifications = [] as any;
        for (let item of _data['notifications']) this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
      }
      this.receiveNotifications = _data['receiveNotifications'];
    }
  }

  static fromJS(data: any): UpdateNotificationSettingsInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateNotificationSettingsInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.notifications)) {
      data['notifications'] = [];
      for (let item of this.notifications) data['notifications'].push(item.toJSON());
    }
    data['receiveNotifications'] = this.receiveNotifications;
    return data;
  }
}

export interface IUpdateNotificationSettingsInput {
  notifications: NotificationSubscriptionDto[] | undefined;
  receiveNotifications: boolean;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
  fileToken!: string;
  height!: number;
  width!: number;
  x!: number;
  y!: number;

  constructor(data?: IUpdateProfilePictureInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileToken = _data['fileToken'];
      this.height = _data['height'];
      this.width = _data['width'];
      this.x = _data['x'];
      this.y = _data['y'];
    }
  }

  static fromJS(data: any): UpdateProfilePictureInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProfilePictureInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['fileToken'] = this.fileToken;
    data['height'] = this.height;
    data['width'] = this.width;
    data['x'] = this.x;
    data['y'] = this.y;
    return data;
  }
}

export interface IUpdateProfilePictureInput {
  fileToken: string;
  height: number;
  width: number;
  x: number;
  y: number;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
  featureValues!: NameValueDto[];
  id!: number;

  constructor(data?: IUpdateTenantFeaturesInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.featureValues = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['featureValues'])) {
        this.featureValues = [] as any;
        for (let item of _data['featureValues']) this.featureValues!.push(NameValueDto.fromJS(item));
      }
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UpdateTenantFeaturesInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateTenantFeaturesInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.featureValues)) {
      data['featureValues'] = [];
      for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
    }
    data['id'] = this.id;
    return data;
  }
}

export interface IUpdateTenantFeaturesInput {
  featureValues: NameValueDto[];
  id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
  grantedPermissionNames!: string[];
  id!: number;

  constructor(data?: IUpdateUserPermissionsInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.grantedPermissionNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['grantedPermissionNames'])) {
        this.grantedPermissionNames = [] as any;
        for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames!.push(item);
      }
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UpdateUserPermissionsInput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserPermissionsInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.grantedPermissionNames)) {
      data['grantedPermissionNames'] = [];
      for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
    }
    data['id'] = this.id;
    return data;
  }
}

export interface IUpdateUserPermissionsInput {
  grantedPermissionNames: string[];
  id: number;
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
  encodedTenantId!: string | undefined;
  encodedUserId!: string | undefined;
  signInToken!: string | undefined;

  constructor(data?: IUpdateUserSignInTokenOutput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.encodedTenantId = _data['encodedTenantId'];
      this.encodedUserId = _data['encodedUserId'];
      this.signInToken = _data['signInToken'];
    }
  }

  static fromJS(data: any): UpdateUserSignInTokenOutput {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserSignInTokenOutput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['encodedTenantId'] = this.encodedTenantId;
    data['encodedUserId'] = this.encodedUserId;
    data['signInToken'] = this.signInToken;
    return data;
  }
}

export interface IUpdateUserSignInTokenOutput {
  encodedTenantId: string | undefined;
  encodedUserId: string | undefined;
  signInToken: string | undefined;
}

export class User implements IUser {
  profilePictureId!: string | undefined;
  shouldChangePasswordOnNextLogin!: boolean;
  signInTokenExpireTimeUtc!: moment.Moment | undefined;
  concurrencyStamp!: string | undefined;
  creatorUser!: User;
  deleterUser!: User;
  lastModifierUser!: User;
  normalizedEmailAddress!: string;
  normalizedUserName!: string;
  tokens!: UserToken[] | undefined;
  accessFailedCount!: number;
  authenticationSource!: string | undefined;
  claims!: UserClaim[] | undefined;
  emailAddress!: string;
  emailConfirmationCode!: string | undefined;
  readonly fullName!: string | undefined;
  isActive!: boolean;
  isEmailConfirmed!: boolean;
  isLockoutEnabled!: boolean | undefined;
  isPhoneNumberConfirmed!: boolean;
  isTwoFactorEnabled!: boolean;
  lastLoginTime!: moment.Moment | undefined;
  lockoutEndDateUtc!: moment.Moment | undefined;
  logins!: UserLogin[] | undefined;
  name!: string;
  password!: string;
  passwordResetCode!: string | undefined;
  permissions!: UserPermissionSetting[] | undefined;
  phoneNumber!: string | undefined;
  roles!: UserRole[] | undefined;
  securityStamp!: string | undefined;
  settings!: Setting[] | undefined;
  signInToken!: string | undefined;
  surname!: string;
  tenantId!: number | undefined;
  externalTokenInformation!: string | undefined;
  externalAuthProviderformation!: string | undefined;
  userName!: string;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profilePictureId = _data['profilePictureId'];
      this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
      this.signInTokenExpireTimeUtc = _data['signInTokenExpireTimeUtc']
        ? moment(_data['signInTokenExpireTimeUtc'].toString())
        : <any>undefined;
      this.concurrencyStamp = _data['concurrencyStamp'];
      this.creatorUser = _data['creatorUser'] ? User.fromJS(_data['creatorUser']) : <any>undefined;
      this.deleterUser = _data['deleterUser'] ? User.fromJS(_data['deleterUser']) : <any>undefined;
      this.lastModifierUser = _data['lastModifierUser'] ? User.fromJS(_data['lastModifierUser']) : <any>undefined;
      this.normalizedEmailAddress = _data['normalizedEmailAddress'];
      this.normalizedUserName = _data['normalizedUserName'];
      if (Array.isArray(_data['tokens'])) {
        this.tokens = [] as any;
        for (let item of _data['tokens']) this.tokens!.push(UserToken.fromJS(item));
      }
      this.accessFailedCount = _data['accessFailedCount'];
      this.authenticationSource = _data['authenticationSource'];
      if (Array.isArray(_data['claims'])) {
        this.claims = [] as any;
        for (let item of _data['claims']) this.claims!.push(UserClaim.fromJS(item));
      }
      this.emailAddress = _data['emailAddress'];
      this.emailConfirmationCode = _data['emailConfirmationCode'];
      (<any>this).fullName = _data['fullName'];
      this.isActive = _data['isActive'];
      this.isEmailConfirmed = _data['isEmailConfirmed'];
      this.isLockoutEnabled = _data['isLockoutEnabled'];
      this.isPhoneNumberConfirmed = _data['isPhoneNumberConfirmed'];
      this.isTwoFactorEnabled = _data['isTwoFactorEnabled'];
      this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
      this.lockoutEndDateUtc = _data['lockoutEndDateUtc'] ? moment(_data['lockoutEndDateUtc'].toString()) : <any>undefined;
      if (Array.isArray(_data['logins'])) {
        this.logins = [] as any;
        for (let item of _data['logins']) this.logins!.push(UserLogin.fromJS(item));
      }
      this.name = _data['name'];
      this.password = _data['password'];
      this.passwordResetCode = _data['passwordResetCode'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(UserPermissionSetting.fromJS(item));
      }
      this.phoneNumber = _data['phoneNumber'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(UserRole.fromJS(item));
      }
      this.securityStamp = _data['securityStamp'];
      if (Array.isArray(_data['settings'])) {
        this.settings = [] as any;
        for (let item of _data['settings']) this.settings!.push(Setting.fromJS(item));
      }
      this.signInToken = _data['signInToken'];
      this.surname = _data['surname'];
      this.tenantId = _data['tenantId'];
      this.externalTokenInformation = _data['externalTokenInformation'];
      this.externalAuthProviderformation = _data['externalAuthProviderformation'];
      this.userName = _data['userName'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): User {
    data = typeof data === 'object' ? data : {};
    let result = new User();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profilePictureId'] = this.profilePictureId;
    data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
    data['signInTokenExpireTimeUtc'] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
    data['concurrencyStamp'] = this.concurrencyStamp;
    data['creatorUser'] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
    data['deleterUser'] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
    data['lastModifierUser'] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
    data['normalizedEmailAddress'] = this.normalizedEmailAddress;
    data['normalizedUserName'] = this.normalizedUserName;
    if (Array.isArray(this.tokens)) {
      data['tokens'] = [];
      for (let item of this.tokens) data['tokens'].push(item.toJSON());
    }
    data['accessFailedCount'] = this.accessFailedCount;
    data['authenticationSource'] = this.authenticationSource;
    if (Array.isArray(this.claims)) {
      data['claims'] = [];
      for (let item of this.claims) data['claims'].push(item.toJSON());
    }
    data['emailAddress'] = this.emailAddress;
    data['emailConfirmationCode'] = this.emailConfirmationCode;
    data['fullName'] = this.fullName;
    data['isActive'] = this.isActive;
    data['isEmailConfirmed'] = this.isEmailConfirmed;
    data['isLockoutEnabled'] = this.isLockoutEnabled;
    data['isPhoneNumberConfirmed'] = this.isPhoneNumberConfirmed;
    data['isTwoFactorEnabled'] = this.isTwoFactorEnabled;
    data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
    data['lockoutEndDateUtc'] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
    if (Array.isArray(this.logins)) {
      data['logins'] = [];
      for (let item of this.logins) data['logins'].push(item.toJSON());
    }
    data['name'] = this.name;
    data['password'] = this.password;
    data['passwordResetCode'] = this.passwordResetCode;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item.toJSON());
    }
    data['phoneNumber'] = this.phoneNumber;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item.toJSON());
    }
    data['securityStamp'] = this.securityStamp;
    if (Array.isArray(this.settings)) {
      data['settings'] = [];
      for (let item of this.settings) data['settings'].push(item.toJSON());
    }
    data['signInToken'] = this.signInToken;
    data['surname'] = this.surname;
    data['tenantId'] = this.tenantId;
    data['externalTokenInformation'] = this.externalTokenInformation;
    data['externalAuthProviderformation'] = this.externalAuthProviderformation;
    data['userName'] = this.userName;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUser {
  profilePictureId: string | undefined;
  shouldChangePasswordOnNextLogin: boolean;
  signInTokenExpireTimeUtc: moment.Moment | undefined;
  concurrencyStamp: string | undefined;
  creatorUser: User;
  deleterUser: User;
  lastModifierUser: User;
  normalizedEmailAddress: string;
  normalizedUserName: string;
  tokens: UserToken[] | undefined;
  accessFailedCount: number;
  authenticationSource: string | undefined;
  claims: UserClaim[] | undefined;
  emailAddress: string;
  emailConfirmationCode: string | undefined;
  fullName: string | undefined;
  isActive: boolean;
  isEmailConfirmed: boolean;
  isLockoutEnabled: boolean | undefined;
  isPhoneNumberConfirmed: boolean;
  isTwoFactorEnabled: boolean;
  lastLoginTime: moment.Moment | undefined;
  lockoutEndDateUtc: moment.Moment | undefined;
  logins: UserLogin[] | undefined;
  name: string;
  password: string;
  passwordResetCode: string | undefined;
  permissions: UserPermissionSetting[] | undefined;
  phoneNumber: string | undefined;
  roles: UserRole[] | undefined;
  securityStamp: string | undefined;
  settings: Setting[] | undefined;
  signInToken: string | undefined;
  surname: string;
  tenantId: number | undefined;
  externalTokenInformation: string | undefined;
  externalAuthProviderformation: string | undefined;
  userName: string;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class UserClaim implements IUserClaim {
  claimType!: string | undefined;
  claimValue!: string | undefined;
  tenantId!: number | undefined;
  userId!: number;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IUserClaim) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.claimType = _data['claimType'];
      this.claimValue = _data['claimValue'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserClaim {
    data = typeof data === 'object' ? data : {};
    let result = new UserClaim();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['claimType'] = this.claimType;
    data['claimValue'] = this.claimValue;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserClaim {
  claimType: string | undefined;
  claimValue: string | undefined;
  tenantId: number | undefined;
  userId: number;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class UserEditDto implements IUserEditDto {
  emailAddress!: string;
  id!: number | undefined;
  isActive!: boolean;
  isLockoutEnabled!: boolean;
  name!: string;
  password!: string | undefined;
  shouldChangePasswordOnNextLogin!: boolean;
  surname!: string;
  userName!: string;
  phoneNumber!: string | undefined;

  constructor(data?: IUserEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.emailAddress = _data['emailAddress'];
      this.id = _data['id'];
      this.isActive = _data['isActive'];
      this.isLockoutEnabled = _data['isLockoutEnabled'];
      this.name = _data['name'];
      this.password = _data['password'];
      this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
      this.surname = _data['surname'];
      this.userName = _data['userName'];
      this.phoneNumber = _data['phoneNumber'];
    }
  }

  static fromJS(data: any): UserEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['emailAddress'] = this.emailAddress;
    data['id'] = this.id;
    data['isActive'] = this.isActive;
    data['isLockoutEnabled'] = this.isLockoutEnabled;
    data['name'] = this.name;
    data['password'] = this.password;
    data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
    data['surname'] = this.surname;
    data['userName'] = this.userName;
    data['phoneNumber'] = this.phoneNumber;
    return data;
  }
}

export interface IUserEditDto {
  emailAddress: string;
  id: number | undefined;
  isActive: boolean;
  isLockoutEnabled: boolean;
  name: string;
  password: string | undefined;
  shouldChangePasswordOnNextLogin: boolean;
  surname: string;
  userName: string;
  phoneNumber: string | undefined;
}

export class UserListDto implements IUserListDto {
  authenticationSource!: string | undefined;
  emailAddress!: string | undefined;
  isActive!: boolean;
  isEmailConfirmed!: boolean;
  lastLoginTime!: moment.Moment | undefined;
  readonly lastModificationDate!: moment.Moment;
  name!: string | undefined;
  profilePictureId!: string | undefined;
  roles!: UserListRoleDto[] | undefined;
  surname!: string | undefined;
  userName!: string | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IUserListDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authenticationSource = _data['authenticationSource'];
      this.emailAddress = _data['emailAddress'];
      this.isActive = _data['isActive'];
      this.isEmailConfirmed = _data['isEmailConfirmed'];
      this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
      (<any>this).lastModificationDate = _data['lastModificationDate'] ? moment(_data['lastModificationDate'].toString()) : <any>undefined;
      this.name = _data['name'];
      this.profilePictureId = _data['profilePictureId'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(UserListRoleDto.fromJS(item));
      }
      this.surname = _data['surname'];
      this.userName = _data['userName'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserListDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserListDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authenticationSource'] = this.authenticationSource;
    data['emailAddress'] = this.emailAddress;
    data['isActive'] = this.isActive;
    data['isEmailConfirmed'] = this.isEmailConfirmed;
    data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
    data['lastModificationDate'] = this.lastModificationDate ? this.lastModificationDate.toISOString() : <any>undefined;
    data['name'] = this.name;
    data['profilePictureId'] = this.profilePictureId;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item.toJSON());
    }
    data['surname'] = this.surname;
    data['userName'] = this.userName;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserListDto {
  authenticationSource: string | undefined;
  emailAddress: string | undefined;
  isActive: boolean;
  isEmailConfirmed: boolean;
  lastLoginTime: moment.Moment | undefined;
  lastModificationDate: moment.Moment;
  name: string | undefined;
  profilePictureId: string | undefined;
  roles: UserListRoleDto[] | undefined;
  surname: string | undefined;
  userName: string | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
  roleId!: number;
  roleName!: string | undefined;

  constructor(data?: IUserListRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
    }
  }

  static fromJS(data: any): UserListRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserListRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    return data;
  }
}

export interface IUserListRoleDto {
  roleId: number;
  roleName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
  defaultAccountLockoutSeconds!: number;
  isEnabled!: boolean;
  maxFailedAccessAttemptsBeforeLockout!: number;

  constructor(data?: IUserLockOutSettingsEditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultAccountLockoutSeconds = _data['defaultAccountLockoutSeconds'];
      this.isEnabled = _data['isEnabled'];
      this.maxFailedAccessAttemptsBeforeLockout = _data['maxFailedAccessAttemptsBeforeLockout'];
    }
  }

  static fromJS(data: any): UserLockOutSettingsEditDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLockOutSettingsEditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['defaultAccountLockoutSeconds'] = this.defaultAccountLockoutSeconds;
    data['isEnabled'] = this.isEnabled;
    data['maxFailedAccessAttemptsBeforeLockout'] = this.maxFailedAccessAttemptsBeforeLockout;
    return data;
  }
}

export interface IUserLockOutSettingsEditDto {
  defaultAccountLockoutSeconds: number;
  isEnabled: boolean;
  maxFailedAccessAttemptsBeforeLockout: number;
}

export class UserLogin implements IUserLogin {
  loginProvider!: string;
  providerKey!: string;
  tenantId!: number | undefined;
  userId!: number;
  id!: number;

  constructor(data?: IUserLogin) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.loginProvider = _data['loginProvider'];
      this.providerKey = _data['providerKey'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserLogin {
    data = typeof data === 'object' ? data : {};
    let result = new UserLogin();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['loginProvider'] = this.loginProvider;
    data['providerKey'] = this.providerKey;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserLogin {
  loginProvider: string;
  providerKey: string;
  tenantId: number | undefined;
  userId: number;
  id: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
  browserInfo!: string | undefined;
  clientIpAddress!: string | undefined;
  clientName!: string | undefined;
  creationTime!: moment.Moment;
  result!: string | undefined;
  tenancyName!: string | undefined;
  userNameOrEmail!: string | undefined;

  constructor(data?: IUserLoginAttemptDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.browserInfo = _data['browserInfo'];
      this.clientIpAddress = _data['clientIpAddress'];
      this.clientName = _data['clientName'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.result = _data['result'];
      this.tenancyName = _data['tenancyName'];
      this.userNameOrEmail = _data['userNameOrEmail'];
    }
  }

  static fromJS(data: any): UserLoginAttemptDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLoginAttemptDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['browserInfo'] = this.browserInfo;
    data['clientIpAddress'] = this.clientIpAddress;
    data['clientName'] = this.clientName;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['result'] = this.result;
    data['tenancyName'] = this.tenancyName;
    data['userNameOrEmail'] = this.userNameOrEmail;
    return data;
  }
}

export interface IUserLoginAttemptDto {
  browserInfo: string | undefined;
  clientIpAddress: string | undefined;
  clientName: string | undefined;
  creationTime: moment.Moment;
  result: string | undefined;
  tenancyName: string | undefined;
  userNameOrEmail: string | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
  authenticationSource!: string | undefined;
  emailAddress!: string | undefined;
  name!: string | undefined;
  profilePictureId!: string | undefined;
  surname!: string | undefined;
  userName!: string | undefined;
  id!: number;

  constructor(data?: IUserLoginInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.authenticationSource = _data['authenticationSource'];
      this.emailAddress = _data['emailAddress'];
      this.name = _data['name'];
      this.profilePictureId = _data['profilePictureId'];
      this.surname = _data['surname'];
      this.userName = _data['userName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserLoginInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserLoginInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['authenticationSource'] = this.authenticationSource;
    data['emailAddress'] = this.emailAddress;
    data['name'] = this.name;
    data['profilePictureId'] = this.profilePictureId;
    data['surname'] = this.surname;
    data['userName'] = this.userName;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserLoginInfoDto {
  authenticationSource: string | undefined;
  emailAddress: string | undefined;
  name: string | undefined;
  profilePictureId: string | undefined;
  surname: string | undefined;
  userName: string | undefined;
  id: number;
}

export class UserNotification implements IUserNotification {
  notification!: TenantNotification;
  state!: UserNotificationState;
  tenantId!: number | undefined;
  userId!: number;
  id!: string;

  constructor(data?: IUserNotification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.notification = _data['notification'] ? TenantNotification.fromJS(_data['notification']) : <any>undefined;
      this.state = _data['state'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserNotification {
    data = typeof data === 'object' ? data : {};
    let result = new UserNotification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['notification'] = this.notification ? this.notification.toJSON() : <any>undefined;
    data['state'] = this.state;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserNotification {
  notification: TenantNotification;
  state: UserNotificationState;
  tenantId: number | undefined;
  userId: number;
  id: string;
}

export enum UserNotificationState {
  Unread = 0,
  Read = 1,
}

export class UserPermissionSetting implements IUserPermissionSetting {
  userId!: number;
  isGranted!: boolean;
  name!: string;
  tenantId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IUserPermissionSetting) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.isGranted = _data['isGranted'];
      this.name = _data['name'];
      this.tenantId = _data['tenantId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserPermissionSetting {
    data = typeof data === 'object' ? data : {};
    let result = new UserPermissionSetting();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['isGranted'] = this.isGranted;
    data['name'] = this.name;
    data['tenantId'] = this.tenantId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserPermissionSetting {
  userId: number;
  isGranted: boolean;
  name: string;
  tenantId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class UserRole implements IUserRole {
  roleId!: number;
  tenantId!: number | undefined;
  userId!: number;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IUserRole) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserRole {
    data = typeof data === 'object' ? data : {};
    let result = new UserRole();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserRole {
  roleId: number;
  tenantId: number | undefined;
  userId: number;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export class UserRoleDto implements IUserRoleDto {
  isAssigned!: boolean;
  roleDisplayName!: string | undefined;
  roleId!: number;
  roleName!: string | undefined;

  constructor(data?: IUserRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isAssigned = _data['isAssigned'];
      this.roleDisplayName = _data['roleDisplayName'];
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
    }
  }

  static fromJS(data: any): UserRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isAssigned'] = this.isAssigned;
    data['roleDisplayName'] = this.roleDisplayName;
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    return data;
  }
}

export interface IUserRoleDto {
  isAssigned: boolean;
  roleDisplayName: string | undefined;
  roleId: number;
  roleName: string | undefined;
}

export class UserToken implements IUserToken {
  expireDate!: moment.Moment | undefined;
  loginProvider!: string | undefined;
  name!: string | undefined;
  tenantId!: number | undefined;
  userId!: number;
  value!: string | undefined;
  id!: number;

  constructor(data?: IUserToken) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.expireDate = _data['expireDate'] ? moment(_data['expireDate'].toString()) : <any>undefined;
      this.loginProvider = _data['loginProvider'];
      this.name = _data['name'];
      this.tenantId = _data['tenantId'];
      this.userId = _data['userId'];
      this.value = _data['value'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): UserToken {
    data = typeof data === 'object' ? data : {};
    let result = new UserToken();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['expireDate'] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
    data['loginProvider'] = this.loginProvider;
    data['name'] = this.name;
    data['tenantId'] = this.tenantId;
    data['userId'] = this.userId;
    data['value'] = this.value;
    data['id'] = this.id;
    return data;
  }
}

export interface IUserToken {
  expireDate: moment.Moment | undefined;
  loginProvider: string | undefined;
  name: string | undefined;
  tenantId: number | undefined;
  userId: number;
  value: string | undefined;
  id: number;
}

export class WebhookEvent implements IWebhookEvent {
  creationTime!: moment.Moment;
  data!: string | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  tenantId!: number | undefined;
  webhookName!: string;
  id!: string;

  constructor(data?: IWebhookEvent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.data = _data['data'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.tenantId = _data['tenantId'];
      this.webhookName = _data['webhookName'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): WebhookEvent {
    data = typeof data === 'object' ? data : {};
    let result = new WebhookEvent();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['data'] = this.data;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['tenantId'] = this.tenantId;
    data['webhookName'] = this.webhookName;
    data['id'] = this.id;
    return data;
  }
}

export interface IWebhookEvent {
  creationTime: moment.Moment;
  data: string | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  tenantId: number | undefined;
  webhookName: string;
  id: string;
}

export class WebhookSubscription implements IWebhookSubscription {
  headers!: { [key: string]: string } | undefined;
  isActive!: boolean;
  secret!: string | undefined;
  tenantId!: number | undefined;
  webhooks!: string[] | undefined;
  webhookUri!: string | undefined;
  id!: string;

  constructor(data?: IWebhookSubscription) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['headers']) {
        this.headers = {} as any;
        for (let key in _data['headers']) {
          if (_data['headers'].hasOwnProperty(key)) (<any>this.headers)![key] = _data['headers'][key];
        }
      }
      this.isActive = _data['isActive'];
      this.secret = _data['secret'];
      this.tenantId = _data['tenantId'];
      if (Array.isArray(_data['webhooks'])) {
        this.webhooks = [] as any;
        for (let item of _data['webhooks']) this.webhooks!.push(item);
      }
      this.webhookUri = _data['webhookUri'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): WebhookSubscription {
    data = typeof data === 'object' ? data : {};
    let result = new WebhookSubscription();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.headers) {
      data['headers'] = {};
      for (let key in this.headers) {
        if (this.headers.hasOwnProperty(key)) (<any>data['headers'])[key] = (<any>this.headers)[key];
      }
    }
    data['isActive'] = this.isActive;
    data['secret'] = this.secret;
    data['tenantId'] = this.tenantId;
    if (Array.isArray(this.webhooks)) {
      data['webhooks'] = [];
      for (let item of this.webhooks) data['webhooks'].push(item);
    }
    data['webhookUri'] = this.webhookUri;
    data['id'] = this.id;
    return data;
  }
}

export interface IWebhookSubscription {
  headers: { [key: string]: string } | undefined;
  isActive: boolean;
  secret: string | undefined;
  tenantId: number | undefined;
  webhooks: string[] | undefined;
  webhookUri: string | undefined;
  id: string;
}

export class WorkShiftDto implements IWorkShiftDto {
  type!: WorkShiftType;
  referenceDate!: moment.Moment;
  details!: string | undefined;
  requester!: string | undefined;
  requesterId!: number;
  requesterCurrent!: string | undefined;
  requesterWanted!: string | undefined;
  requested!: string | undefined;
  requestedId!: number | undefined;
  requestedCurrent!: string | undefined;
  requestedWanted!: string | undefined;
  requestedSecondary!: string | undefined;
  requestedSecondaryId!: number | undefined;
  requestedSecondaryCurrent!: string | undefined;
  requestedSecondaryWanted!: string | undefined;
  remarks!: string | undefined;
  status!: WorkShiftStatus;
  approver!: string | undefined;
  approverId!: number | undefined;
  deleterUserId!: number | undefined;
  deletionTime!: moment.Moment | undefined;
  isDeleted!: boolean;
  lastModificationTime!: moment.Moment | undefined;
  lastModifierUserId!: number | undefined;
  creationTime!: moment.Moment;
  creatorUserId!: number | undefined;
  id!: number;

  constructor(data?: IWorkShiftDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.referenceDate = _data['referenceDate'] ? moment(_data['referenceDate'].toString()) : <any>undefined;
      this.details = _data['details'];
      this.requester = _data['requester'];
      this.requesterId = _data['requesterId'];
      this.requesterCurrent = _data['requesterCurrent'];
      this.requesterWanted = _data['requesterWanted'];
      this.requested = _data['requested'];
      this.requestedId = _data['requestedId'];
      this.requestedCurrent = _data['requestedCurrent'];
      this.requestedWanted = _data['requestedWanted'];
      this.requestedSecondary = _data['requestedSecondary'];
      this.requestedSecondaryId = _data['requestedSecondaryId'];
      this.requestedSecondaryCurrent = _data['requestedSecondaryCurrent'];
      this.requestedSecondaryWanted = _data['requestedSecondaryWanted'];
      this.remarks = _data['remarks'];
      this.status = _data['status'];
      this.approver = _data['approver'];
      this.approverId = _data['approverId'];
      this.deleterUserId = _data['deleterUserId'];
      this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
      this.isDeleted = _data['isDeleted'];
      this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
      this.lastModifierUserId = _data['lastModifierUserId'];
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.creatorUserId = _data['creatorUserId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): WorkShiftDto {
    data = typeof data === 'object' ? data : {};
    let result = new WorkShiftDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined;
    data['details'] = this.details;
    data['requester'] = this.requester;
    data['requesterId'] = this.requesterId;
    data['requesterCurrent'] = this.requesterCurrent;
    data['requesterWanted'] = this.requesterWanted;
    data['requested'] = this.requested;
    data['requestedId'] = this.requestedId;
    data['requestedCurrent'] = this.requestedCurrent;
    data['requestedWanted'] = this.requestedWanted;
    data['requestedSecondary'] = this.requestedSecondary;
    data['requestedSecondaryId'] = this.requestedSecondaryId;
    data['requestedSecondaryCurrent'] = this.requestedSecondaryCurrent;
    data['requestedSecondaryWanted'] = this.requestedSecondaryWanted;
    data['remarks'] = this.remarks;
    data['status'] = this.status;
    data['approver'] = this.approver;
    data['approverId'] = this.approverId;
    data['deleterUserId'] = this.deleterUserId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['isDeleted'] = this.isDeleted;
    data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
    data['lastModifierUserId'] = this.lastModifierUserId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorUserId'] = this.creatorUserId;
    data['id'] = this.id;
    return data;
  }
}

export interface IWorkShiftDto {
  type: WorkShiftType;
  referenceDate: moment.Moment;
  details: string | undefined;
  requester: string | undefined;
  requesterId: number;
  requesterCurrent: string | undefined;
  requesterWanted: string | undefined;
  requested: string | undefined;
  requestedId: number | undefined;
  requestedCurrent: string | undefined;
  requestedWanted: string | undefined;
  requestedSecondary: string | undefined;
  requestedSecondaryId: number | undefined;
  requestedSecondaryCurrent: string | undefined;
  requestedSecondaryWanted: string | undefined;
  remarks: string | undefined;
  status: WorkShiftStatus;
  approver: string | undefined;
  approverId: number | undefined;
  deleterUserId: number | undefined;
  deletionTime: moment.Moment | undefined;
  isDeleted: boolean;
  lastModificationTime: moment.Moment | undefined;
  lastModifierUserId: number | undefined;
  creationTime: moment.Moment;
  creatorUserId: number | undefined;
  id: number;
}

export enum WorkShiftStatus {
  Pending = 0,
  Approved = 1,
  Reproved = 2,
  Aware = 3,
  PendingAware = 4,
}

export enum WorkShiftType {
  ShiftChangeRequest = 0,
  AbsenceRequest = 1,
  CompanyRequest = 2,
  MedicalRequest = 3,
  OtherRequest = 4,
}

export class MIRCMessageDto implements IMIRCMessageDto {
  creationTime!: moment.Moment;
  message!: string | undefined;
  userId!: number;
  id!: string;

  constructor(data?: IMIRCMessageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
      this.message = _data['message'];
      this.userId = _data['userId'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): MIRCMessageDto {
    data = typeof data === 'object' ? data : {};
    let result = new MIRCMessageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['message'] = this.message;
    data['userId'] = this.userId;
    data['id'] = this.id;
    return data;
  }
}

export interface IMIRCMessageDto {
  creationTime: moment.Moment;
  message: string | undefined;
  userId: number;
  id: string;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
  return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
